'use strict';

var React = require('react');
var classNames = require('classnames');
var reactResponsive = require('react-responsive');
var react = require('@storyblok/react');
var reactUse = require('react-use');
var button = require('@react-aria/button');
var cloneDeep = require('clone-deep');
var ReactDOMServer = require('react-dom/server');
var htmlparser2 = require('htmlparser2');
var cssSelect = require('css-select');
var domutils = require('domutils');
var domhandler = require('domhandler');
var domSerializer = require('dom-serializer');
var makeSlug = require('slugify');
var Modal = require('react-modal');
var reactOptimize = require('react-optimize');
var queryString = require('query-string');
var IframeResizer = require('iframe-resizer-react');
var Cookies = require('js-cookie');
var parseMoney = require('parse-money');
var reactIntl = require('react-intl');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);
var classNames__default = /*#__PURE__*/_interopDefaultCompat(classNames);
var cloneDeep__default = /*#__PURE__*/_interopDefaultCompat(cloneDeep);
var ReactDOMServer__default = /*#__PURE__*/_interopDefaultCompat(ReactDOMServer);
var makeSlug__default = /*#__PURE__*/_interopDefaultCompat(makeSlug);
var Modal__default = /*#__PURE__*/_interopDefaultCompat(Modal);
var queryString__default = /*#__PURE__*/_interopDefaultCompat(queryString);
var IframeResizer__default = /*#__PURE__*/_interopDefaultCompat(IframeResizer);
var Cookies__default = /*#__PURE__*/_interopDefaultCompat(Cookies);
var parseMoney__default = /*#__PURE__*/_interopDefaultCompat(parseMoney);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var initialValue = {
    provider: 'default',
    components: {},
    hooks: {
        useRouter: function () { return ''; }
    },
    internalLinks: {},
    lang: 'gb',
    localeCode: '',
    storyUuid: '',
    pricing: {
        getPrice: function () { return ''; }
    }
};
var SiteComponentContext = React.createContext(initialValue);
var Provider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var value = __assign(__assign({}, initialValue), props);
    return (React__namespace.default.createElement(SiteComponentContext.Provider, { value: value }, children));
};

var BasicImage = function (_a) {
    _a.maxWidth; // eslint-disable-line @typescript-eslint/no-unused-vars
    _a.fillColor; // eslint-disable-line @typescript-eslint/no-unused-vars
    _a.resizeProps; // eslint-disable-line @typescript-eslint/no-unused-vars
    var props = __rest(_a, ["maxWidth", "fillColor", "resizeProps"]);
    return React__namespace.default.createElement("img", __assign({ alt: "" }, props));
};

var ioOptions = {
    threshold: 0.01,
    rootMargin: '50%'
};
var useIntersectionObserver = function (ref, isDisabled) {
    if (isDisabled === void 0) { isDisabled = false; }
    var _a = React.useState(isDisabled), isVisible = _a[0], setIsVisible = _a[1];
    var _b = React.useState(isDisabled), shouldReveal = _b[0], setShouldReveal = _b[1];
    React.useEffect(function () {
        var observer;
        var node = ref.current;
        if (node) {
            if ('IntersectionObserver' in window) {
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                            setIsVisible(true);
                        }
                    });
                }, ioOptions);
                observer.observe(node);
            }
            else {
                setIsVisible(true);
            }
        }
        return function () {
            if (observer && observer.unobserve) {
                observer.unobserve(node);
            }
        };
    }, [ref, setIsVisible]);
    return {
        isVisible: isVisible,
        shouldReveal: shouldReveal,
        setIsVisible: setIsVisible,
        setShouldReveal: setShouldReveal
    };
};

var checkImage = function (asset) {
    return asset &&
        typeof asset.image === 'string' &&
        asset.image.length > 0;
};
var generateSrcSetString = function (imageSet) {
    return imageSet
        .map(function (item) {
        var _a = item.split(','), src = _a[0], width = _a[1];
        return "".concat(src, " ").concat(width, "w");
    })
        .join(', \n');
};
var getLargestTransformedImage = function (imageSet) {
    var lastImage = imageSet[imageSet.length - 1];
    return lastImage.split(',')[0];
};
var getImageFormat = function (imgPath) {
    var imgFormat = imgPath.match(/\.(\w+)$/);
    return imgFormat ? imgFormat[1].toLowerCase() : '';
};
var createReferenceImage = function (onLoad, imageSet) {
    var img = new Image();
    img.onload = function () { return onLoad(); };
    img.src = getLargestTransformedImage(imageSet);
    img.srcset = generateSrcSetString(imageSet);
};
var getPossibleMaxWidth = function (isFluidImage, maxWidth) {
    if (maxWidth) {
        return maxWidth;
    }
    if (isFluidImage) {
        return 3840;
    }
    else {
        return 1440;
    }
};
var generateBgClassName = function (imgPath) {
    var part = imgPath.split('.')[0].split('/').join('-');
    return "img-background-".concat(part);
};
var getInitialBackgroundStyles = function (className, base64, fillColor) {
    return "\n    .".concat(className, " .before,\n    .").concat(className, " .after {\n      display: block;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      transition: opacity 500ms ease-in-out;\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: cover;\n      z-index: -100;\n    }\n\n    .").concat(className, " {\n      position: relative;\n      overflow: hidden;\n    }\n\n    .").concat(className, " .before {\n      background-image: url(").concat(base64 ? base64 : '', ");\n      background-color: ").concat(fillColor ? fillColor : 'transparent', ";\n    }\n\n    .").concat(className, " .after {\n      opacity: 0;\n    }\n  ");
};
var getResponsiveBackgroundStyles = function (imageSet, className) {
    var mediaQueryStyles = imageSet.reverse().map(function (item) {
        var _a = item.split(','), src = _a[0], width = _a[1];
        return "\n    @media (max-width: ".concat(width, "px) {\n      .").concat(className, " .after {\n        background-image: url(\"").concat(src, "\");\n      }\n    }");
    });
    return "\n    .".concat(className, " .after {\n      background-image: url(\"").concat(imageSet[0].split(',')[0], "\");\n      transition: opacity 500ms ease-in-out;\n      opacity: 1;\n    }\n    ").concat(mediaQueryStyles, "\n  ");
};

var imageScales = [360, 440, 800, 1024, 1440, 1920, 2560, 3840];
var getScales = function (width, maxWidth) {
    var maxScaleWidth = getMaxScaleWidth(width, maxWidth);
    var allScales = imageScales.includes(maxWidth)
        ? imageScales
        : __spreadArray(__spreadArray([], imageScales, true), [maxWidth], false);
    var scales = allScales.filter(function (size) { return size <= maxScaleWidth; });
    scales.length === 0 && scales.push(maxScaleWidth);
    return scales;
};
var getMaxScaleWidth = function (originalWidth, maxWidth) {
    return maxWidth > originalWidth ? originalWidth : maxWidth;
};

var matchStoryblokAssetOrigin = function (url) {
    var origin = url.match(/(https?:|)\/\/a\.storyblok\.com\//g);
    return origin ? origin : '';
};
var getOriginalImageDimensions = function (imagePath) {
    var matcher = imagePath.match(/f\/\d+\/([0-9]+x[0-9]+)/i) || [];
    if (typeof matcher[1] === 'undefined') {
        return {
            width: 0,
            height: 0
        };
    }
    var imgDimensions = matcher[1];
    var dimensions = imgDimensions.split('x');
    var width = Number(dimensions[0]);
    var height = Number(dimensions[1]);
    return { width: width, height: height };
};
var getStoryblokImagePath = function (url) {
    return url.replace(matchStoryblokAssetOrigin(url)[0], '');
};
var getBasicImageProps = function (src) {
    var imgPath = getStoryblokImagePath(src);
    var imgFormat = getImageFormat(imgPath);
    var _a = getOriginalImageDimensions(imgPath), width = _a.width, height = _a.height;
    var aspectRatio = width / height;
    return {
        imgPath: imgPath,
        imgFormat: imgFormat,
        dimensions: {
            width: width,
            height: height,
            aspectRatio: aspectRatio
        }
    };
};
var generateUrl = function (imgPath, props) {
    var imageService = 'https://img2.storyblok.com';
    var quality = props.quality ? props.quality : 93;
    var focal = props.focal ? ":focal(".concat(props.focal, ")") : '';
    var resize = props.resize;
    var imageSize = resize ? resize : "".concat(props.width, "x").concat(props.height);
    var smart = resize ? '' : 'smart/';
    if (props.imgFormat === 'webp') {
        return "".concat(imageService, "/").concat(imageSize, "/").concat(smart, "filters:format(webp):quality(").concat(quality, ")").concat(focal, "/").concat(imgPath);
    }
    return "".concat(imageService, "/").concat(imageSize, "/").concat(smart, "filters:quality(").concat(quality, ")").concat(focal, "/").concat(imgPath);
};
var getFixedImageProps = function (src, maxWidth, quality, focal, resize) {
    var basicImgProps = getBasicImageProps(src);
    var imgPath = basicImgProps.imgPath, imgFormat = basicImgProps.imgFormat, dimensions = basicImgProps.dimensions;
    var aspectRatio = dimensions.aspectRatio, width = dimensions.width;
    var scales = getScales(width, maxWidth);
    var srcSet = { base: [], webp: [] };
    scales.forEach(function (currentWidth) {
        var props = {
            width: currentWidth,
            height: Math.round(currentWidth / aspectRatio),
            quality: quality,
            focal: focal,
            resize: resize,
            imgFormat: imgFormat
        };
        var baseUrl = "".concat(generateUrl(imgPath, __assign({}, props)), ",").concat(currentWidth);
        var webpUrl = "".concat(generateUrl(imgPath, __assign(__assign({}, props), { imgFormat: 'webp' })), ",").concat(currentWidth);
        srcSet.webp.push(webpUrl);
        srcSet.base.push(baseUrl);
    });
    return __assign(__assign({}, basicImgProps), { srcSet: srcSet });
};

var generateImageSources = function (imageVariants, isWebp) {
    var imageSources = imageVariants.map(function (variant) {
        var _a = variant.split(','), srcSet = _a[0], width = _a[1];
        var media = "(max-width: ".concat(width, "px)");
        return (React__namespace.default.createElement("source", { type: isWebp ? 'image/webp' : '', key: variant, media: media, srcSet: srcSet }));
    });
    if (isWebp) {
        var lastVariant = imageVariants[imageVariants.length - 1];
        var srcSet = lastVariant.split(',')[0];
        imageSources.push(React__namespace.default.createElement("source", { type: "image/webp", key: srcSet, srcSet: srcSet }));
    }
    return imageSources;
};
var wrapperStyles = {
    position: 'relative',
    overflow: 'hidden'
};
var imageStyles = function (cropAlignment) { return ({
    position: 'absolute',
    objectFit: 'cover',
    objectPosition: cropAlignment || 'unset',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    transition: 'opacity 500ms'
}); };
var base64ImageStyles = __assign(__assign({}, imageStyles()), { transition: 'opacity 0s 500ms' });
var bgTagBaseStyles = {
    width: '100%',
    transitionDelay: '500ms'
};
var AdvanceImage = function (_a) {
    var src = _a.src, alt_tag = _a.alt_tag, className = _a.className, _b = _a.type, type = _b === void 0 ? 'fixed' : _b, maxWidth = _a.maxWidth, quality = _a.quality, base64 = _a.base64, fillColor = _a.fillColor, loading = _a.loading, resizeProps = _a.resizeProps, isStatic = _a.isStatic, rest = __rest(_a, ["src", "alt_tag", "className", "type", "maxWidth", "quality", "base64", "fillColor", "loading", "resizeProps", "isStatic"]);
    var isFluidImage = type === 'fluid';
    var isCritical = loading === 'eager';
    var bgFillColor = fillColor ? fillColor : 'rgba(0,0,0, 0.05)';
    var possibleMaxWidth = getPossibleMaxWidth(isFluidImage, Number(maxWidth));
    var _c = React.useState(''), base64Hydration = _c[0], setBase64Hydration = _c[1];
    var imageProps = getFixedImageProps(src, possibleMaxWidth, Number(quality), resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.focal, resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.resize);
    var _d = imageProps.srcSet, webp = _d.webp, base = _d.base;
    var imageRef = React.useRef(null);
    var _e = useIntersectionObserver(imageRef, isStatic), isVisible = _e.isVisible, setIsVisible = _e.setIsVisible, shouldReveal = _e.shouldReveal, setShouldReveal = _e.setShouldReveal;
    if (isCritical) {
        setIsVisible(true);
    }
    var handleImageLoad = function () {
        setShouldReveal(true);
    };
    React.useEffect(function () {
        setBase64Hydration(base64 || '');
    }, [base64, setBase64Hydration]);
    return (React__namespace.default.createElement("div", { className: className, key: src, style: wrapperStyles, ref: imageRef },
        React__namespace.default.createElement("div", { style: __assign(__assign({}, bgTagBaseStyles), { paddingBottom: "".concat(100 /
                    ((resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.cropAspectRatio) || imageProps.dimensions.aspectRatio), "%"), backgroundColor: fillColor ? bgFillColor : 'transparent', opacity: shouldReveal ? 0 : 1 }) }),
        base64Hydration && (React__namespace.default.createElement(BasicImage, __assign({}, rest, { src: base64Hydration, alt: alt_tag, className: className, style: __assign(__assign({}, base64ImageStyles), { opacity: !shouldReveal ? 1 : 0 }) }))),
        isVisible && (React__namespace.default.createElement("picture", null,
            webp && generateImageSources(webp, true),
            base && generateImageSources(base, false),
            React__namespace.default.createElement(BasicImage, __assign({ src: getLargestTransformedImage(base), alt: alt_tag, loading: loading ? loading : 'lazy', onLoad: handleImageLoad, style: __assign(__assign({}, imageStyles(resizeProps === null || resizeProps === void 0 ? void 0 : resizeProps.cropAlignment)), { opacity: shouldReveal ? 1 : 0 }) }, rest))))));
};

var ImgBackground = function (_a) {
    var children = _a.children, src = _a.src, _b = _a.tag, tag = _b === void 0 ? 'div' : _b, _c = _a.type, type = _c === void 0 ? 'fixed' : _c, style = _a.style, className = _a.className, maxWidth = _a.maxWidth, quality = _a.quality, base64 = _a.base64, fillColor = _a.fillColor, loading = _a.loading;
    var isFluidImage = type === 'fluid';
    var isCritical = loading === 'eager';
    var possibleMaxWidth = getPossibleMaxWidth(isFluidImage, Number(maxWidth));
    var imageProps = getFixedImageProps(src, possibleMaxWidth, Number(quality));
    var bgClassName = generateBgClassName(imageProps.imgPath);
    var wrapperRef = React.useRef(null);
    var _d = useIntersectionObserver(wrapperRef), isVisible = _d.isVisible, setIsVisible = _d.setIsVisible, shouldReveal = _d.shouldReveal, setShouldReveal = _d.setShouldReveal;
    if (isCritical) {
        setIsVisible(true);
    }
    var onImageLoad = function () {
        setShouldReveal(true);
    };
    React.useEffect(function () {
        if (isVisible) {
            createReferenceImage(onImageLoad, imageProps.srcSet.base);
        }
    }, [isVisible]);
    // skip JSX to avoid ts errors with ElementType with refs
    // To be able to have JSX again, there might be less conflicts in later
    // versions of react, typescript, ts-jest and their type definitions.
    return React__namespace.default.createElement(tag, {
        className: classNames__default.default(className, bgClassName),
        key: src,
        style: style,
        ref: wrapperRef
    }, React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: "before" }),
        React__namespace.default.createElement("style", null,
            getInitialBackgroundStyles(bgClassName, base64, fillColor),
            shouldReveal &&
                getResponsiveBackgroundStyles(imageProps.srcSet.base, bgClassName)),
        children,
        React__namespace.default.createElement("div", { className: "after" })));
};

var Img = function (_a) {
    var src = _a.src; 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a._uid; var rest = __rest(_a, ["src", "_uid"]);
    if (!src) {
        return null;
    }
    var isStoryblokImage = src.match(/(a|img2).storyblok.com/);
    var isSvgImage = getImageFormat(src) === 'svg';
    if (isStoryblokImage && !isSvgImage) {
        return React__namespace.default.createElement(AdvanceImage, __assign({ src: src }, rest));
    }
    return React__namespace.default.createElement(BasicImage, __assign({ src: src }, rest));
};

var Image$1 = function (_a) {
    var asset = _a.asset;
    var image = asset.image, rest = __rest(asset, ["image"]);
    return (React__namespace.default.createElement("section", { style: { width: '100%' } },
        React__namespace.default.createElement(Img, __assign({ src: image }, rest))));
};

// filters:focal(<left>x<top>:<right>x<bottom>)
var deriveFocal = function (_a) {
    var alignment = _a.alignment, imgPath = _a.imgPath, _b = _a.targetWidth, targetWidth = _b === void 0 ? 0 : _b, _c = _a.targetHeight, targetHeight = _c === void 0 ? 0 : _c;
    var left, top, right, bottom;
    var _d = getOriginalImageDimensions(imgPath), originalWidth = _d.width, originalHeight = _d.height;
    if (originalWidth < targetWidth ||
        originalHeight < targetHeight ||
        !alignment ||
        targetWidth <= 0 ||
        targetHeight <= 0) {
        return '';
    }
    switch (alignment) {
        case 'top':
        case 'bottom':
            left = originalWidth / 2 - targetWidth / 2;
            left = targetWidth === 0 ? originalWidth : left;
            right = left + targetWidth;
            top = alignment === 'top' ? 0 : originalHeight - targetHeight;
            bottom = alignment === 'bottom' ? originalHeight : top + targetHeight;
            break;
        case 'left':
        case 'right':
            top = originalHeight / 2 - targetHeight / 2;
            bottom = top + targetHeight;
            left = alignment === 'left' ? 0 : originalWidth - targetWidth;
            right = alignment === 'right' ? originalWidth : left + targetWidth;
            break;
        case 'center':
        default:
            left = originalWidth / 2 - targetWidth / 2;
            right = left + targetWidth;
            top = originalHeight / 2 - targetHeight / 2;
            bottom = top + targetHeight;
            break;
    }
    return (Math.floor(left) +
        'x' +
        Math.floor(top) +
        ':' +
        Math.floor(right) +
        'x' +
        Math.floor(bottom));
};

var getTargetRatio = function (targetAspectRatio) {
    var _a = targetAspectRatio.split(':'), numerator = _a[0], denominator = _a[1];
    return Number(numerator) / Number(denominator);
};
var getFormatFlags = function (originalDimensions, targetRatio) {
    var originalRatio = originalDimensions.width / originalDimensions.height;
    var originIsLandscape = originalRatio > 1;
    var originIsPortrait = originalRatio < 1;
    var targetIsLandscape = targetRatio > 1;
    var targetIsPortrait = targetRatio < 1;
    var targetIsSquare = targetRatio === 1;
    var targetIsSameOrientation = (targetIsLandscape && originIsLandscape) ||
        (targetIsPortrait && originIsPortrait);
    var targetIsThinner = (targetIsLandscape && targetRatio > originalRatio) ||
        (targetIsPortrait && targetRatio < originalRatio);
    return {
        originIsLandscape: originIsLandscape,
        originIsPortrait: originIsPortrait,
        targetIsLandscape: targetIsLandscape,
        targetIsPortrait: targetIsPortrait,
        targetIsSquare: targetIsSquare,
        targetIsSameOrientation: targetIsSameOrientation,
        targetIsThinner: targetIsThinner
    };
};
var getCropTargetDimensions = function (imgPath, targetAspectRatio) {
    var originalDimensions = getOriginalImageDimensions(imgPath);
    var originalWidth = originalDimensions.width, originalHeight = originalDimensions.height;
    var originalRatio = originalWidth / originalHeight;
    var targetRatio = targetAspectRatio
        ? getTargetRatio(targetAspectRatio)
        : originalRatio;
    var _a = getFormatFlags(originalDimensions, targetRatio), targetIsLandscape = _a.targetIsLandscape, targetIsPortrait = _a.targetIsPortrait, targetIsSquare = _a.targetIsSquare, targetIsThinner = _a.targetIsThinner;
    if ((targetIsLandscape && targetIsThinner) ||
        (targetIsPortrait && !targetIsThinner)) {
        return {
            targetWidth: originalWidth,
            targetHeight: originalWidth / targetRatio
        };
    }
    if ((targetIsLandscape && !targetIsThinner) ||
        (targetIsPortrait && targetIsThinner)) {
        return {
            targetWidth: originalHeight * targetRatio,
            targetHeight: originalHeight
        };
    }
    if (targetIsSquare) {
        return {
            targetWidth: originalRatio > 1 ? originalHeight : originalWidth,
            targetHeight: originalRatio > 1 ? originalHeight : originalWidth
        };
    }
    return { targetWidth: originalWidth, targetHeight: originalHeight };
};

var getOneDimensionResize = function (_a) {
    var targetDimensions = _a.targetDimensions, originalDimensions = _a.originalDimensions, _b = _a.targetScale, targetScale = _b === void 0 ? 100 : _b;
    var targetWidth = targetDimensions.targetWidth, targetHeight = targetDimensions.targetHeight;
    var originalWidth = originalDimensions.width, originalHeight = originalDimensions.height;
    var targetRatio = targetWidth / targetHeight;
    var _c = getFormatFlags(originalDimensions, targetRatio), originIsPortrait = _c.originIsPortrait, targetIsLandscape = _c.targetIsLandscape, targetIsSquare = _c.targetIsSquare, targetIsSameOrientation = _c.targetIsSameOrientation, targetIsThinner = _c.targetIsThinner;
    if (targetIsSameOrientation && !targetIsThinner) {
        return targetIsLandscape
            ? "".concat(Math.floor(targetWidth), "x").concat(Math.floor(originalHeight * targetScale))
            : "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight));
    }
    if (targetIsSquare && originIsPortrait) {
        return "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight));
    }
    return targetWidth > targetHeight
        ? "".concat(Math.floor(originalWidth * targetScale), "x").concat(Math.floor(targetHeight))
        : "".concat(Math.floor(targetWidth), "x").concat(Math.floor(originalHeight * targetScale));
};

var breakpoints = {
    xs: 0,
    sm: 400,
    m1: 600,
    m2: 1024,
    lg: 1440,
    xl: 1920
};
var constructQuery = function (_a) {
    var minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = [];
    var minPx = minBreakpoint && minBreakpoint in breakpoints
        ? breakpoints[minBreakpoint]
        : 0;
    var maxPx = maxBreakpoint && maxBreakpoint in breakpoints
        ? breakpoints[maxBreakpoint]
        : 0;
    if (minPx > 0) {
        query.push("(min-width: ".concat(minPx, "px)"));
    }
    if (maxPx > 0) {
        query.push("(max-width: ".concat(maxPx, "px)"));
    }
    if ((minPx > 0 && maxPx > 0 && minPx >= maxPx) || query.length === 0) {
        return 'all';
    }
    return query.join(' and ');
};
var validateBreakpointCollection = function (list) {
    if (list.find(function (_a, i) {
        var _b = _a.minBreakpoint, min = _b === void 0 ? 'xs' : _b, _c = _a.maxBreakpoint, max = _c === void 0 ? '' : _c;
        return __spreadArray(__spreadArray([], list.slice(i + 1), true), list.slice(0, i), true).find(function (_a) {
            var _b = _a.minBreakpoint, min2 = _b === void 0 ? 'xs' : _b;
            return ((breakpoints[min] || 0) <= (breakpoints[min2] || 0) &&
                (breakpoints[max] || Infinity) > (breakpoints[min2] || 0));
        });
    })) {
        return React__namespace.default.createElement("div", null, errorSvgs['overlap']);
    }
    var screenSizeCoverage = Array.from(list.reduce(function (acc, _a) {
        var _b = _a.minBreakpoint, minBreakpoint = _b === void 0 ? 'xs' : _b, _c = _a.maxBreakpoint, maxBreakpoint = _c === void 0 ? '' : _c;
        var nextMin = breakpoints[minBreakpoint] || 0, nextMax = breakpoints[maxBreakpoint] || Infinity;
        for (var _i = 0, _d = Object.entries(breakpoints); _i < _d.length; _i++) {
            var _e = _d[_i], label = _e[0], breakpoint = _e[1];
            if (breakpoint >= nextMin && breakpoint < nextMax)
                acc.add(label);
        }
        return acc;
    }, new Set()));
    if (screenSizeCoverage.length < 6) {
        return React__namespace.default.createElement("div", null, errorSvgs['disparate']);
    }
    return undefined;
};
var errorSvgs = {
    overlap: (React__namespace.default.createElement("svg", { key: "overlap", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        React__namespace.default.createElement("path", { fill: "gray", d: "M0 0h10v10H0z" }),
        React__namespace.default.createElement("path", { fill: "#bfbfbf", d: "M5 5h11v11H5z" }),
        React__namespace.default.createElement("path", { fill: "#e70000", d: "M5 5h5v5H5z" }),
        React__namespace.default.createElement("text", { transform: "translate(3, 0) rotate(15)", style: { font: 'italic 1px sans-serif' } },
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Responsive error:"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Can't have one min-max"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "within another min-max."),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Check you settings")))),
    disparate: (React__namespace.default.createElement("svg", { key: "disparate", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        React__namespace.default.createElement("path", { fill: "#e70000", d: "M0 0h16v16H0z" }),
        React__namespace.default.createElement("path", { fill: "gray", d: "M0 0h9v9H0z" }),
        React__namespace.default.createElement("path", { fill: "#bfbfbf", d: "M11 11h5v5h-5z" }),
        React__namespace.default.createElement("text", { transform: "translate(3, 0) rotate(40)", style: { font: 'italic 1px sans-serif' } },
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Responsive error:"),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Not every screen size is covered for."),
            React__namespace.default.createElement("tspan", { x: "0", dy: "1px" }, "Check you settings"))))
};

var ImgResized = function (_a) {
    var _b = _a.cropAlignment, cropAlignment = _b === void 0 ? 'center' : _b, _c = _a.cropAspectRatio, cropAspectRatio = _c === void 0 ? '4:3' : _c, _d = _a.cropScaling, cropScaling = _d === void 0 ? '100' : _d, asset = _a.asset, minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = constructQuery({ minBreakpoint: minBreakpoint, maxBreakpoint: maxBreakpoint });
    var show = reactResponsive.useMediaQuery({ query: query });
    if (!checkImage(asset) || !show)
        return null;
    var _e = getBasicImageProps(asset.image), imgPath = _e.imgPath, originalDimensions = _e.dimensions;
    var targetDimensions = getCropTargetDimensions(imgPath, cropAspectRatio);
    var targetScale = Number(cropScaling) >= 100 ? Number(cropScaling) / 100 : 1;
    var resize = getOneDimensionResize({
        targetDimensions: targetDimensions,
        originalDimensions: originalDimensions,
        targetScale: targetScale
    });
    var focal = deriveFocal(__assign({ alignment: cropAlignment || 'center', imgPath: imgPath }, targetDimensions));
    var resizeProps = {
        resize: resize,
        focal: focal,
        cropAlignment: cropAlignment,
        cropScaling: targetScale,
        cropAspectRatio: getTargetRatio(cropAspectRatio)
    };
    // The src as it should be generated by AdvanceImage:
    // `${imageService}/${resize}/filters:focal(${focal}):quality(${quality})/${imgPath}`
    return React__namespace.default.createElement(Img, __assign({}, asset, { src: asset.image, resizeProps: resizeProps }));
};

var Row = function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'top' : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, children = _a.children, className = _a.className;
    var classes = classNames__default.default('row', (_b = {},
        _b["row-".concat(justify)] = justify,
        _b["row-".concat(align)] = align,
        _b), className);
    return React__namespace.default.createElement("div", { className: classes }, children);
};

var createSizeClasses = function (size, columnConfig) {
    var _a;
    if (!columnConfig) {
        return {};
    }
    var sizeConfig = {};
    if (typeof columnConfig === 'number') {
        sizeConfig.span = columnConfig;
    }
    else if (typeof columnConfig === 'object') {
        sizeConfig = columnConfig || {};
    }
    return _a = {},
        _a["col-".concat(size, "-").concat(sizeConfig.span)] = typeof sizeConfig.span !== 'undefined',
        _a["col-".concat(size, "-offset-").concat(sizeConfig.offset)] = sizeConfig.offset || sizeConfig.offset === 0,
        _a["col-".concat(size, "-order-").concat(sizeConfig.order)] = sizeConfig.order || sizeConfig.order === 0,
        _a;
};
var Col = function (props) {
    var _a;
    var span = props.span, offset = props.offset, order = props.order, className = props.className, xs = props.xs, sm = props.sm, md = props.md, ml = props.ml, lg = props.lg, xl = props.xl, children = props.children;
    var sizeClasses = {};
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('xs', xs));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('sm', sm));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('md', md));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('ml', ml));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('lg', lg));
    sizeClasses = __assign(__assign({}, sizeClasses), createSizeClasses('xl', xl));
    var classes = classNames__default.default('col', (_a = {},
        _a["col-".concat(span)] = span !== undefined,
        _a["col-offset-".concat(offset)] = offset,
        _a["col-order-".concat(order)] = order,
        _a), className, sizeClasses);
    return React__namespace.default.createElement("div", { className: classes }, children);
};

var css$1f = {"section-text-left":"styles_section-text-left__b96z7","section-text-center":"styles_section-text-center__tfSfa","section-text-right":"styles_section-text-right__dZYU9"};

var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return React__namespace.default.createElement(React__namespace.default.Fragment, null, condition ? wrapper(children) : children);
};

var gridProfiles$1 = {
    'content-50': {
        ml: {
            span: 6,
            offset: 3
        }
    },
    'content-66': {
        ml: {
            span: 8,
            offset: 2
        }
    },
    'content-66-left-align': {
        ml: {
            span: 8,
            offset: 1
        }
    },
    'md-75-ml-66-lg-50': {
        md: {
            span: 6,
            offset: 1
        },
        ml: {
            span: 8,
            offset: 2
        },
        lg: {
            span: 6,
            offset: 3
        }
    },
    'md-75-ml-100': {
        md: {
            span: 6,
            offset: 1
        },
        ml: {
            span: 12,
            offset: 0
        }
    },
    'w-narrow': {
        ml: {
            span: 6,
            offset: 3
        },
        lg: {
            span: 8,
            offset: 2
        }
    }
};

/*
  Use the "span" property to set the width, specified in number of grid columns.
  The value will be set for the specified breakpoint and all above, if not specified.
  Content is centered by default, to offset it use the "fromLeft" property.
  Grid margin is not added by default, to add it set the "gridMargin" property to true.
*/
// double profiles for renaming purposes
var gridProfiles = {
    'full-width-no-margins': {},
    'full-width-with-margins': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            gridMargin: true
        },
        m2: {
            gridMargin: true
        },
        lg: {
            gridMargin: true
        }
    },
    'm1-10-m2-8-lg-6': {
        m1: {
            span: 10
        },
        m2: {
            span: 8
        },
        lg: {
            span: 6
        }
    },
    'm2-10': {
        m2: {
            span: 10
        }
    },
    's-margin-m2-10': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            gridMargin: true
        },
        m2: {
            span: 10
        }
    },
    'm1-10-m2-8': {
        m1: {
            span: 10
        },
        m2: {
            span: 8
        }
    },
    'm2-11-left-align': {
        m2: {
            span: 11,
            gridMargin: true,
            fromLeft: 0
        },
        lg: {
            gridMargin: true,
            fromLeft: 0
        }
    },
    's-margin-m1-8': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            span: 8
        }
    },
    's-margin-m1-6': {
        xs: {
            gridMargin: true
        },
        sm: {
            gridMargin: true
        },
        m1: {
            span: 6
        }
    },
    'm1-margin-m2-12': {
        m1: {
            gridMargin: true
        },
        m2: {
            span: 12
        }
    }
};

var css$1e = {"innerContainer":"styles_innerContainer__5q3so","noMaxWidth":"styles_noMaxWidth__I2QH4","content":"styles_content__F54rZ","overrideSectionPadding":"styles_overrideSectionPadding__n0zb4","xs-width-0":"styles_xs-width-0__hOrLv","xs-width-1":"styles_xs-width-1__3994G","xs-width-2":"styles_xs-width-2__F7jl3","xs-width-3":"styles_xs-width-3__Iub0-","xs-width-4":"styles_xs-width-4__A303r","xs-from-left-0":"styles_xs-from-left-0__E-jMe","xs-from-left-1":"styles_xs-from-left-1__cycR4","xs-from-left-2":"styles_xs-from-left-2__djE8D","xs-grid-margin":"styles_xs-grid-margin__yoqHs","xs-no-grid-margin":"styles_xs-no-grid-margin__dUL0d","sm-width-0":"styles_sm-width-0__7th64","sm-width-1":"styles_sm-width-1__wUYw4","sm-width-2":"styles_sm-width-2__0ncw6","sm-width-3":"styles_sm-width-3__25eCr","sm-width-4":"styles_sm-width-4__gCYyg","sm-from-left-0":"styles_sm-from-left-0__fpTJD","sm-from-left-1":"styles_sm-from-left-1__6ZVHS","sm-from-left-2":"styles_sm-from-left-2__X6c9H","sm-grid-margin":"styles_sm-grid-margin__iZyes","sm-no-grid-margin":"styles_sm-no-grid-margin__Wmg6E","m1-width-0":"styles_m1-width-0__Q05EA","m1-width-1":"styles_m1-width-1__l4Z3k","m1-width-2":"styles_m1-width-2__DFC-9","m1-width-3":"styles_m1-width-3__TBwxA","m1-width-4":"styles_m1-width-4__FMNaM","m1-width-5":"styles_m1-width-5__GiCFx","m1-width-6":"styles_m1-width-6__MPr9O","m1-width-7":"styles_m1-width-7__S8gzo","m1-width-8":"styles_m1-width-8__vzGM5","m1-width-9":"styles_m1-width-9__BFhzf","m1-width-10":"styles_m1-width-10__h4mx7","m1-width-11":"styles_m1-width-11__Lr44M","m1-width-12":"styles_m1-width-12__iyjCU","m1-from-left-0":"styles_m1-from-left-0__C3K-D","m1-from-left-1":"styles_m1-from-left-1__MMjta","m1-from-left-2":"styles_m1-from-left-2__f7t-5","m1-from-left-3":"styles_m1-from-left-3__KWtUW","m1-from-left-4":"styles_m1-from-left-4__MnkUU","m1-from-left-5":"styles_m1-from-left-5__Ncgg8","m1-from-left-6":"styles_m1-from-left-6__W9K4g","m1-grid-margin":"styles_m1-grid-margin__Mkjn9","m1-no-grid-margin":"styles_m1-no-grid-margin__IICqk","m2-width-0":"styles_m2-width-0__ry6gZ","m2-width-1":"styles_m2-width-1__N58MI","m2-width-2":"styles_m2-width-2__lWo9P","m2-width-3":"styles_m2-width-3__izVBj","m2-width-4":"styles_m2-width-4__5GuLv","m2-width-5":"styles_m2-width-5__NEEGl","m2-width-6":"styles_m2-width-6__A1jAO","m2-width-7":"styles_m2-width-7__rxwqB","m2-width-8":"styles_m2-width-8__P3wPG","m2-width-9":"styles_m2-width-9__p7kNs","m2-width-10":"styles_m2-width-10__0LKy0","m2-width-11":"styles_m2-width-11__AEBsg","m2-width-12":"styles_m2-width-12__8k-HW","m2-from-left-0":"styles_m2-from-left-0__YQssV","m2-from-left-1":"styles_m2-from-left-1__ZYrJ9","m2-from-left-2":"styles_m2-from-left-2__pQds-","m2-from-left-3":"styles_m2-from-left-3__43nVu","m2-from-left-4":"styles_m2-from-left-4__oo0qD","m2-from-left-5":"styles_m2-from-left-5__s2LRD","m2-from-left-6":"styles_m2-from-left-6__ev8Zb","m2-grid-margin":"styles_m2-grid-margin__rtPfs","m2-no-grid-margin":"styles_m2-no-grid-margin__B4spr","lg-width-0":"styles_lg-width-0__9-NCM","lg-width-1":"styles_lg-width-1__tGK14","lg-width-2":"styles_lg-width-2__KUqh8","lg-width-3":"styles_lg-width-3__Yx6PY","lg-width-4":"styles_lg-width-4__H2pey","lg-width-5":"styles_lg-width-5__N1mV8","lg-width-6":"styles_lg-width-6__fZpoM","lg-width-7":"styles_lg-width-7__P9qUm","lg-width-8":"styles_lg-width-8__xZ10R","lg-width-9":"styles_lg-width-9__Pk4Q3","lg-width-10":"styles_lg-width-10__yEZz9","lg-width-11":"styles_lg-width-11__fDR8d","lg-width-12":"styles_lg-width-12__fo-nY","lg-from-left-0":"styles_lg-from-left-0__JzBLd","lg-from-left-1":"styles_lg-from-left-1__zqRpD","lg-from-left-2":"styles_lg-from-left-2__iNxoA","lg-from-left-3":"styles_lg-from-left-3__nVgIN","lg-from-left-4":"styles_lg-from-left-4__ZFN1L","lg-from-left-5":"styles_lg-from-left-5__5IfbF","lg-from-left-6":"styles_lg-from-left-6__nVa0v","lg-grid-margin":"styles_lg-grid-margin__CkMWj","lg-no-grid-margin":"styles_lg-no-grid-margin__w8gMR","paddingTop-only-desktop":"styles_paddingTop-only-desktop__G4dgw","paddingTop-extra-small":"styles_paddingTop-extra-small__TFfC2","paddingTop-small":"styles_paddingTop-small__-BE-E","paddingTop-default":"styles_paddingTop-default__xTARp","paddingTop-large":"styles_paddingTop-large__hvNXH","paddingBottom-only-desktop":"styles_paddingBottom-only-desktop__RJvFS","paddingBottom-extra-small":"styles_paddingBottom-extra-small__dxwb4","paddingBottom-small":"styles_paddingBottom-small__KB1fh","paddingBottom-default":"styles_paddingBottom-default__cQnKM","paddingBottom-large":"styles_paddingBottom-large__U09JH"};

var ppStyles = {"cssOverrides":"pp-styles_cssOverrides__HyNIt"};

/* THIS FILE IS AUTOMATICALLY GENERATED */
var colors = { "default": ["color-default", "#141416"], "secondary": ["color-secondary", "#62646A"], "highlight": ["color-highlight", "#785DDC"], "info": ["color-info", "#273664"], "success": ["color-success", "#2C7551"], "warning": ["color-warning", "#7E4B0A"], "error": ["color-error", "#BC3C17"], "inverted": ["color-inverted", "#FFF"], "placeholder": ["color-placeholder", "#87888E"], "action-primary": ["color-action-primary", "#FFF"], "action-secondary": ["color-action-secondary", "#141416"], "action-minor": ["color-action-minor", "#141416"], "action-destructive": ["color-action-destructive", "#BC3C17"], "action-destructive-solid": ["color-action-destructive-solid", "#FFF"], "action-inline": ["color-action-inline", "#6C4FD4"], "action-inline-destructive": ["color-action-inline-destructive", "#BC3C17"] };
var backgroundColors = { "default": ["bg-default", "#FFF"], "grouped-primary": ["bg-grouped-primary", "#F8F8FA"], "grouped-secondary": ["bg-grouped-secondary", "#ECECEE"], "highlight": ["bg-highlight", "#F4F3FF"], "info": ["bg-info", "#E7EEFD"], "success": ["bg-success", "#E1F9E7"], "warning": ["bg-warning", "#FFF6DF"], "error": ["bg-error", "#FFEDEB"], "inverted": ["bg-inverted", "#192550"], "placeholder": ["bg-placeholder", "#B9BABE"], "action-primary": ["bg-action-primary", "#785DDC"], "action-secondary": ["bg-action-secondary", "transparent"], "action-minor": ["bg-action-minor", "transparent"], "action-destructive": ["bg-action-destructive", "transparent"], "action-destructive-solid": ["bg-action-destructive-solid", "#D44420"], "action-inline": ["bg-action-inline", "transparent"], "action-inline-destructive": ["bg-action-inline-destructive", "transparent"] };
var borderColors = { "divider": ["border-divider", "#D2D3D6"], "success": ["border-succes", "#66C78D"], "warning": ["border-warning", "#E9B33E"], "error": ["border-error", "#F06243"], "focus-form": ["border-focus-form", "#141416"], "focus": ["border-focus", "#785DDC"], "action-primary": ["border-action-primary", "#785DDC"], "action-secondary": ["border-action-secondary", "#93959A"], "action-minor": ["border-action-minor", "#D2D3D6"], "action-destructive": ["border-action-destructive", "#93959A"], "action-destructive-solid": ["border-action-destructive-solid", "transparent"], "action-inline": ["border-action-inline", "transparent"], "action-inline-destructive": ["border-action-inline-destructive", "transparent"], "info": ["border-info", "#5A6DA2"], "form": ["border-form", "#93959A"], "interactive": ["border-interactive", "#93959A"] };

var getClass = function (map) {
    return function (key) { var _a, _b; return (_b = (_a = map[key]) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null; };
};
var getColorClass = getClass(colors);
var getBackgroundColorClass = getClass(backgroundColors);
var getBorderColorClass = getClass(borderColors);
var getColorClasses = function (key) { return ({
    color: getColorClass(key),
    background: getBackgroundColorClass(key),
    border: getBorderColorClass(key)
}); };

var getStoryblokProps = function (input) {
    return input
        ? Object.fromEntries(Object.entries(input).filter(function (_a) {
            var k = _a[0];
            return k.indexOf('data-blok') === 0;
        }))
        : {};
};

var getClasses = function (profile) {
    if (profile in gridProfiles) {
        var _a = gridProfiles[profile], xs = _a.xs, sm = _a.sm, m1 = _a.m1, m2 = _a.m2, lg = _a.lg;
        var classes = {};
        classes = createClasses('xs', xs);
        classes = __assign(__assign({}, classes), createClasses('sm', sm));
        classes = __assign(__assign({}, classes), createClasses('m1', m1));
        classes = __assign(__assign({}, classes), createClasses('m2', m2));
        classes = __assign(__assign({}, classes), createClasses('lg', lg));
        return classes;
    }
    return {};
};
var createClasses = function (size, settings) {
    var _a;
    return _a = {},
        _a[css$1e["".concat(size, "-width-").concat(settings === null || settings === void 0 ? void 0 : settings.span)]] = !!(settings === null || settings === void 0 ? void 0 : settings.span),
        _a[css$1e["".concat(size, "-from-left-").concat(settings === null || settings === void 0 ? void 0 : settings.fromLeft)]] = (settings === null || settings === void 0 ? void 0 : settings.fromLeft) !== undefined,
        _a[css$1e["".concat(size, "-grid-margin")]] = !!(settings === null || settings === void 0 ? void 0 : settings.gridMargin),
        _a[css$1e["".concat(size, "-no-grid-margin")]] = (settings === null || settings === void 0 ? void 0 : settings.gridMargin) !== true,
        _a;
};
var ContainerLayout = function (_a) {
    var _b, _c;
    var _d;
    var id = _a.id, backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, gridProfile = _a.gridProfile, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, children = _a.children, className = _a.className, overrideSectionPadding = _a.overrideSectionPadding, _e = _a.noMaxWidth, noMaxWidth = _e === void 0 ? false : _e, _f = _a.tagName, tagName = _f === void 0 ? 'section' : _f, ppStyleOverride = _a.ppStyleOverride, rest = __rest(_a, ["id", "backgroundColor", "backgroundImage", "gridProfile", "paddingTop", "paddingBottom", "children", "className", "overrideSectionPadding", "noMaxWidth", "tagName", "ppStyleOverride"]);
    var backgroundColorClass = (_d = getBackgroundColorClass(backgroundColor)) !== null && _d !== void 0 ? _d : backgroundColor;
    var TagName = tagName;
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: checkImage(backgroundImage), wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: backgroundImage.image, base64: backgroundImage.base64, quality: 90, loading: "lazy", tag: "section", className: className }, children)); } },
        React__namespace.default.createElement(TagName, __assign({ id: (id === null || id === void 0 ? void 0 : id.length) > 0 ? id : undefined, className: classNames__default.default([backgroundColorClass], (_b = {},
                _b[ppStyles.cssOverrides] = ppStyleOverride,
                _b[css$1e["paddingTop-".concat(paddingTop)]] = paddingTop !== 'none',
                _b[css$1e["paddingBottom-".concat(paddingBottom)]] = paddingBottom !== 'none',
                _b["".concat(className)] = !checkImage(backgroundImage),
                _b[css$1e.overrideSectionPadding] = overrideSectionPadding,
                _b)), "data-testid": "container-layout" }, getStoryblokProps(rest)),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$1e.innerContainer, (_c = {},
                    _c[css$1e.noMaxWidth] = noMaxWidth,
                    _c)) },
                React__namespace.default.createElement("div", { className: classNames__default.default(css$1e.content, __assign({}, getClasses(gridProfile))) }, children)))));
};

var SectionLayout = function (_a) {
    var component = _a.component, props = __rest(_a, ["component"]);
    if (component === 'container-layout') {
        return React__namespace.default.createElement(ContainerLayout, __assign({}, props));
    }
    return React__namespace.default.createElement(SectionLayoutLegacy, __assign({}, props));
};
var SectionLayoutLegacy = function (_a) {
    var _b, _c;
    var disableWrapperClass = _a.disableWrapperClass, _d = _a.gridProfile, gridProfile = _d === void 0 ? '' : _d, disableMaximumWidth = _a.disableMaximumWidth, textAlign = _a.textAlign, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, highlightTextColor = _a.highlightTextColor, id = _a.id, children = _a.children, className = _a.className, rest = __rest(_a, ["disableWrapperClass", "gridProfile", "disableMaximumWidth", "textAlign", "paddingTop", "paddingBottom", "backgroundColor", "backgroundImage", "highlightTextColor", "id", "children", "className"]);
    var hasBackgroundImage = checkImage(backgroundImage);
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: hasBackgroundImage, wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: (backgroundImage && backgroundImage.image) || '', base64: backgroundImage && backgroundImage.base64, quality: 90, loading: "lazy", tag: "section", className: className }, children)); } },
        React__namespace.default.createElement("section", __assign({ className: classNames__default.default({ 'w-full': !disableWrapperClass }, (_b = getBackgroundColorClass(backgroundColor)) !== null && _b !== void 0 ? _b : backgroundColor, (_c = getColorClass(highlightTextColor)) !== null && _c !== void 0 ? _c : highlightTextColor, !hasBackgroundImage && className), id: id && (id === null || id === void 0 ? void 0 : id.length) > 0 ? id : undefined }, getStoryblokProps(rest)),
            React__namespace.default.createElement("div", { className: classNames__default.default({ 'w-normal': !disableMaximumWidth }, css$1f["section-".concat(textAlign)], paddingTop, paddingBottom) },
                React__namespace.default.createElement(ConditionalWrapper, { condition: gridProfile in gridProfiles$1, wrapper: function (children) { return (React__namespace.default.createElement(Row, null,
                        React__namespace.default.createElement(Col, __assign({}, gridProfiles$1[gridProfile]), children))); } }, children)))));
};

var _path$E;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$E || (_path$E = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm-27 424-14-264h82l-14 264h-54zm27 166c-27.4 0-50-22.6-50-50s22.6-50 50-50 50 22.6 50 50-22.6 50-50 50z"
  })));
};

var _path$D;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 720"
  }, props), _path$D || (_path$D = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m520 0 360 360-360 360-56-56 262-264H0v-80h726L464 56l56-56z"
  })));
};

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgArrowRightOtto = function SvgArrowRightOtto(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$N({
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1 8.63h12.93m-4.1-5.51 4.67 5.51-4.67 5.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25px"
    }
  }));
};

var _path$C;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 845"
  }, props), _path$C || (_path$C = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M626.5 265 405 80.5 175 265H73.5L405 0l324 265H626.5zM40 305h720v40H40v-40zm90 360V385h60v280h-60zm240 0V385h60v280h-60zm300 0h-60V385h60v280zM40 705h720v40H40v-40zM0 785h800v60H0v-60z"
  })));
};

var _path$B;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgBarDiagram = function SvgBarDiagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 880"
  }, props), _path$B || (_path$B = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M720 0v880h-60V0h60zM280 40v840h-60V40h60zm221 160v680h-60V200h60zM60 280v600H0V280h60z"
  })));
};

var _path$A;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 601.5 881.2"
  }, props), _path$A || (_path$A = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M460.8 641.2h-60C401.2 472.8 542 444.9 542 295.8 542 161.1 438.3 60 300.8 60 163.2 60 59.5 161.1 59.5 295.8c0 149.2 140.8 177 141.2 345.5h-59C140.2 499.8 0 470.3 0 295.8 0 127.1 129.6 0 300.8 0s300.8 127.1 300.8 295.8c-.1 174.5-139.4 204-140.8 345.4zm0 60v60h-320v-60h320zm0 120v60h-320v-60h320z"
  })));
};

var _path$z;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgCardReader = function SvgCardReader(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 880"
  }, props), _path$z || (_path$z = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M97.5 880C42 880 0 839 0 782.5v-685C0 41 42 0 97.5 0h445C598 0 640 41 640 97.5v685c0 56.5-42 97.5-97.5 97.5h-445zm1.5-60h442c22 0 39-17.5 39-39V99c0-21.5-17-39-39-39H99c-22 0-39 17.5-39 39v682c0 21.5 17 39 39 39zm41-480c-11 0-20-9-20-20V140c0-11 9-20 20-20h360c11 0 20 9 20 20v180c0 11-9 20-20 20H140zm44.5 161c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm-273 120c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm-273 120c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41zm136.5 0c-22.5 0-41-18.5-41-41 0-22 18.5-40.5 41-40.5 22 0 40.5 18.5 40.5 40.5 0 22.5-18.5 41-40.5 41z"
  })));
};

var _path$y;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 805"
  }, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M880 0v600H495.5L220 805V600H0V0h880zm-60 60H60v480h220v147l189.5-147H820V60z"
  })));
};

var _path$x;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 890 781"
  }, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 425.5 48 382l266.5 299L839 0l51 39-570.5 742L0 425.5z"
  })));
};

var _path$w, _path2$e;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.5 16.5"
  }, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-3.8-3.7h24v24h-24v-24z",
    fill: "none"
  })), _path2$e || (_path2$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m.8.9 14.8 14.8M15.7.9.8 15.7",
    fill: "none",
    stroke: "#192550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$v;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 829 829"
  }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m578 0 251 250-578 579H0V578L578 0zm1 85-99.5 99.5 165.1 165.1L744 250 579 85zM226 769l383.6-384.4-165.1-165.1L60 604v165h166z"
  })));
};

var _path$u;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 879.5 640"
  }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h879.5v640H0V0zm774.8 60H105l260.5 268c29 30 53 43 74 43 23 0 48.5-13.5 76-42L774.8 60zM60 580h759.5V93.6L548.5 374c-36.5 38-73.5 57-109 57-34 0-71.5-19.5-108-57L60 93.4V580z"
  })));
};

var _defs$4, _path$t, _path2$d, _path3$9;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$D({
    id: "external-link_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _defs$4 || (_defs$4 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".external-link_svg__cls-1{fill:none;stroke:#192550;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
    className: "external-link_svg__cls-1",
    d: "M17.25 12.1v5.881a1.269 1.269 0 0 1-1.269 1.269H2.019A1.269 1.269 0 0 1 .75 17.981V4.019A1.269 1.269 0 0 1 2.019 2.75H7.9"
  })), _path2$d || (_path2$d = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "external-link_svg__cls-1",
    d: "M18.25 9.132V1.75h-7.423m-2.369 9.792 9.214-9.214"
  })));
};

var _path$s;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800.5 820"
  }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M800.5 820H742l-2-420C739 206.5 592 60 400 60 207 60 60 206.5 60 400v420H0V400C0 172.5 173 0 400 0c226.5 0 399.5 172.5 400 400l.5 420zM120 540h60v280h-60V540zm500 0h60v280h-60V540z"
  })));
};

var _path$r, _path2$c;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgIconDownChevronS = function SvgIconDownChevronS(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$B({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M20 20H0V0h20z"
  })), _path2$c || (_path2$c = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#192550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none",
    d: "M3.113 6.792 10 12.625l6.887-5.833"
  })));
};

var _path$q, _path2$b;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgIconDownChevronM = function SvgIconDownChevronM(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$A({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M24 24H0V0h24z"
  })), _path2$b || (_path2$b = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#192550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none",
    d: "m3.735 8.5 8.265 7 8.264-7"
  })));
};

var _path$p;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgIconRightChevron = function SvgIconRightChevron(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": "##TITLE## ##DESCRIPTION##"
  }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
    d: "m15.8 54.2 22.7-22.7L15.8 8.8 20.7 4l27.5 27.5L20.7 59l-4.9-4.8z"
  })));
};

var _path$o;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$y({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2.7 5.75h18.5m-18.5 7h13.258m-13.258 7h18.5",
    style: {
      fill: "none",
      stroke: "#192550",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
};

var _path$n;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 60"
  }, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M840 0v60H0V0h840z"
  })));
};

var _path$m;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 880"
  }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M600 0v880H0V0h600zm-60 60H60v760h480V60zm-310 50h140v60H230v-60zm115 605c0-25.5-19.5-45-45-45s-45 19.5-45 45 19.5 45 45 45 45-19.5 45-45z"
  })));
};

var _path$l;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811.1 872.4"
  }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 16.5C0 3.4 12-4.1 24 2.3l777.2 417.5c13.3 7.2 13.3 23.3 0 30.5L24 870c-12 6.5-24-1.1-24-14.2V16.5z"
  })));
};

var _path$k;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 860 860"
  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M860 400v60H460v400h-60V460H0v-60h400V0h60v400h400z"
  })));
};

var _g$5;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgSad = function SvgSad(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React__namespace.createElement("g", {
    "data-name": "Lager 2"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0q120 0 221 59t160 160q59 101 59 221t-59 221q-59 101-160 160t-221 59q-120 0-221-59T59 661Q0 560 0 440t59-221q59-101 160-160T440 0zm0 60q-102 0-189.5 51.5T111.5 250Q60 337 60 440q0 102 51.5 189.5a385.86 385.86 0 0 0 139 139Q338 820 440 820q103 0 190-51.5t138.5-139Q820 542 820 440q0-103-51.5-190A388.3 388.3 0 0 0 630 111.5Q543 60 440 60zm142 367q-21 0-36.5-15T530 376q0-22 15.5-37t36.5-15q21 0 36.5 15t15.5 37q0 21-15.5 36T582 427zm-284 0a51.21 51.21 0 0 1-51-51q0-22 15-36.5a49.94 49.94 0 0 1 36-14.5q22 0 37 14.5t15 36.5a49.1 49.1 0 0 1-15 36q-15 15-37 15zm-47 183q37-35 86-59a233 233 0 0 1 206 0q49 24 86 59l-42 43a253.49 253.49 0 0 0-67.5-48.5A177.4 177.4 0 0 0 440 586a180.53 180.53 0 0 0-80 18.5 262.53 262.53 0 0 0-68 47.5z",
    "data-name": "Lager 1"
  }))));
};

var _defs$3, _circle$2, _path$j, _path2$a, _path3$8, _path4$2, _path5$2;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
    id: "search_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".search_svg__cls-1,.search_svg__cls-3{fill:none}.search_svg__cls-1{stroke:#192550;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle$2 || (_circle$2 = /*#__PURE__*/React__namespace.createElement("circle", {
    className: "search_svg__cls-1",
    cx: 9.5,
    cy: 9.5,
    r: 7.75
  })), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.02 4.517a5.008 5.008 0 0 0-4.5 4.471",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    stroke: "#192550",
    strokeLinecap: "round",
    fill: "none"
  })), _path2$a || (_path2$a = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-1",
    d: "m15.19 15.107 5.041 6.065a1.269 1.269 0 0 1-.218 1.78 1.268 1.268 0 0 1-1.78-.219l-3.2-3.878"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "search_svg__cls-3",
    d: "M0 0h24v24H0z"
  })));
};

var _path$i;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 907 907"
  }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M454.5 0 588 133.5h185.5V319L907 452.5 773.5 586v187.5H588L454.5 907 321 773.5H133.5V586L0 452.5 133.5 319V133.5H321L454.5 0zm0 85L346 193.5H193.5v150L85 452.5 193.5 561v152.5H346L454.5 822l109-108.5h150V561L822 452.5l-108.5-109v-150h-150L454.5 85zm-1 528.5c-89 0-160-71-160-160s71-160 160-160 160 71 160 160-71 160-160 160zm0-59c55.5 0 101-45.5 101-101s-45.5-101-101-101-101 45.5-101 101 45.5 101 101 101z"
  })));
};

var _path$h;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgSliders = function SvgSliders(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 880"
  }, props), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M160 454.1c57 13.7 100 65 100 126.4 0 61.8-43.4 113.2-100.9 126.6L160 880h-60l-.9-173C42 693.2 0 641.6 0 580.5c0-61.4 42.4-113.2 100-126.6V0h60v454.1zm319.1-280.3C537.2 187.1 580 238.7 580 301c0 61.8-43.2 113-100.9 126.2L480 880h-60l-.9-453C362 413.4 320 362.5 320 301s42-113.2 99.1-126.9L420 0h60l-.9 173.8zM900 580.5c0 61.7-42.5 113.1-100 126.6v173h-60v-173c-57.5-13.5-100-64.9-100-126.6S682.6 467.4 740 454V0h60v454c57.5 13.4 100 64.8 100 126.5zm-450.5-210c39 0 70.5-31.5 70.5-69.5 0-39-31.5-70.5-70.5-70.5-38 0-69.5 31.5-69.5 70.5 0 38.5 31 69.5 69.5 69.5zm-320 280c38.5 0 70.5-32 70.5-70s-32-70-70.5-70c-38 0-69.5 31.5-69.5 70s31.5 70 69.5 70zm640.5 0c38.5 0 70-31.5 70-70s-31.5-70-70-70-70 31.5-70 70 31.5 70 70 70z"
  })));
};

var _path$g;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm142 371.5c-28.5 0-52-23.5-52-52s23.5-51.5 52-51.5c28 0 51.5 23 51.5 51.5s-23.5 52-51.5 52zm-284 0c-28 0-51.5-24-51.5-52C246.5 351 270 329 298 329c28.5 0 52 22 52 50.5 0 28-23.5 52-52 52zM440 684c-78 0-147.5-42.5-188.5-83l41-41.5C328.5 594 380 625 440 625s111.5-31 147.5-65.5l41 41.5c-41 40.5-110.5 83-188.5 83z"
  })));
};

var _path$f;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgNeutral = function SvgNeutral(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 880"
  }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M440 0c243 0 440 197 440 440S683 880 440 880 0 683 0 440 197 0 440 0zm0 60C231.5 60 60 231.5 60 440s171.5 380 380 380 380-171.5 380-380S648.5 60 440 60zm142 371.5c-28.5 0-52-23.5-52-52s23.5-51.5 52-51.5c28 0 51.5 23 51.5 51.5s-23.5 52-51.5 52zm-284 0c-28 0-51.5-24-51.5-52C246.5 351 270 329 298 329c28.5 0 52 22 52 50.5 0 28-23.5 52-52 52zM633.5 633h-387v-57h387v57z"
  })));
};

var _path$e;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918.4 887.9"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M185.2 886.8c-8.5 4-18-3-16-12.5l52-302c.5-3 0-5-2.5-7.5L4.2 348.8c-8.5-8.5-3-18 6.5-19.5l296.5-41c3-1.5 5-3 6.5-4.5L447.2 8.2c5.5-11 17-11 22 0l133.5 275.5c.5 1.5 3.5 3 6.5 4.5l298.5 41c9.5 1.5 15 11 6.5 19.5l-216 216c-2 2.5-2.5 4.5-2 7.5l51 302c1.5 9.5-7.5 16.5-16 12.5l-269.5-142c-2-1-4-1-6 0L185.2 886.8zm59-98 214.5-113.5 213.5 113.5-42.5-240 172.5-172.5-237.5-34-106-219-107 219-237.5 34 173.5 172.5-43.5 240z"
  })));
};

var _circle$1;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })));
};

var _style$1, _path$d, _path2$9;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgPrimaryPositive = function SvgPrimaryPositive(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
    id: "primary-positive_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 221.34 98.39",
    style: {
      enableBackground: "new 0 0 221.34 98.39"
    },
    xmlSpace: "preserve"
  }, props), _style$1 || (_style$1 = /*#__PURE__*/React__namespace.createElement("style", null, ".primary-positive_svg__st0{fill:#192550}")), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    className: "primary-positive_svg__st0",
    d: "M201.09 64.1c7.26 0 13.99-2.78 17.99-6.86.75-.75.75-1.63 0-2.38l-4.35-4.28c-.88-.88-1.77-.88-2.78 0-1.7 1.49-5.43 4.07-10.46 4.07-6.38 0-11.47-4.35-12.22-11.27h29.6c1.56 0 2.44-.48 2.44-2.24.48-14.66-9.3-24.58-22-24.58-13.31 0-21.93 10.93-21.93 23.83.01 14.27 10.33 23.71 23.71 23.71zm-11.34-28.85c0-3.53 3.26-9.23 9.78-9.23 6.92 0 9.3 6.04 9.3 8.35 0 .41-.34.88-.95.88h-18.13zM2.4 10.93h43.86V1.5c0-.83-.67-1.5-1.5-1.5H2.4C1.57 0 .9.67.9 1.5v7.93c0 .82.67 1.5 1.5 1.5zm-.96 52.08h43.39c.79 0 1.44-.64 1.44-1.44v-8.05c0-.79-.64-1.44-1.44-1.44H0v9.49c0 .79.64 1.44 1.44 1.44z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    style: {
      fill: "#ae9ff3"
    },
    d: "M32.4 10.93 0 52.08h14.49l31.77-41.15z"
  }), _path2$9 || (_path2$9 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "primary-positive_svg__st0",
    d: "M73.3 64.1c7.26 0 13.99-2.78 17.99-6.86.75-.75.75-1.63 0-2.38l-4.35-4.28c-.88-.88-1.77-.88-2.78 0-1.7 1.49-5.43 4.07-10.46 4.07-6.38 0-11.47-4.35-12.22-11.27h29.6c1.56 0 2.44-.48 2.44-2.24.48-14.66-9.3-24.58-22-24.58-13.31 0-21.93 10.93-21.93 23.83C49.6 54.66 59.92 64.1 73.3 64.1zM61.96 35.25c0-3.53 3.26-9.23 9.78-9.23 6.92 0 9.3 6.04 9.3 8.35 0 .41-.34.88-.95.88H61.96zM169.04 63.01h-8.28c-.81 0-1.44-.63-1.44-1.44V1.44c0-.81.63-1.44 1.44-1.44h8.28c.81 0 1.44.63 1.44 1.44v60.12c0 .82-.63 1.45-1.44 1.45zm-61.03 0h8.28c.72 0 1.44-.63 1.44-1.44V27.45h15.21v34.11c0 .81.63 1.44 1.44 1.44h8.28c.81 0 1.44-.63 1.44-1.44v-33.3c0-.45.36-.81.9-.81h7.92c.81 0 1.44-.54 1.44-1.26v-7.2c0-.81-.63-1.35-1.44-1.35H145c-.54 0-.9-.45-.9-.9V6.75c0-.81-.63-1.44-1.44-1.44h-8.28c-.81 0-1.44.63-1.44 1.44v10.89h-15.21V6.75c0-.81-.72-1.44-1.44-1.44h-8.28c-.81 0-1.44.63-1.44 1.44v9.99c0 .45-.36.9-.9.9h-8.01c-.81 0-1.35.54-1.35 1.35v7.02c0 .81.54 1.44 1.35 1.44h8.01c.54 0 .9.36.9.81v33.3c0 .82.63 1.45 1.44 1.45zM121.95 92.32l-4.2 6.07h2.22l9.59-14.26h-2.18l-4.08 6.24-2.33-6.24h-2.24zM113.7 83.7c-1.49 0-2.82.78-3.82 1.98h-.03l1.61-10.23h-1.93l-2.96 18.59h1.95l.23-1.55h.06c.57 1.12 1.7 1.9 3.1 1.9 3.1 0 5.23-2.56 5.69-5.43.44-2.76-1-5.26-3.9-5.26zm1.95 5.32c-.32 1.98-1.75 3.65-3.85 3.65-2.04 0-2.9-1.75-2.59-3.65.29-1.87 1.75-3.59 3.74-3.59 2.1 0 3.02 1.63 2.7 3.59zM193.35 75.45h-6.69c-.46 0-.85.33-.92.79l-2.71 17.16c-.05.34.21.65.55.65h3.43c.32 0 .59-.23.64-.55l.77-4.87c.07-.45.46-.79.92-.79h2.12c4.41 0 6.95-2.13 7.62-6.36.3-1.85.01-3.3-.85-4.32-.95-1.11-2.64-1.71-4.88-1.71m.77 6.27c-.37 2.4-2.2 2.4-3.98 2.4h-1.01l.71-4.49c.04-.27.28-.47.55-.47h.46c1.21 0 2.35 0 2.94.69.36.42.46 1.03.33 1.87M145.61 75.45h-6.69c-.46 0-.85.33-.92.79l-2.71 17.16c-.05.34.21.65.55.65h3.2c.46 0 .85-.33.92-.79l.73-4.63c.07-.45.46-.79.92-.79h2.12c4.41 0 6.95-2.13 7.62-6.36.3-1.85.01-3.3-.85-4.32-.97-1.11-2.65-1.71-4.89-1.71m.77 6.27c-.37 2.4-2.2 2.4-3.98 2.4h-1.01l.71-4.49c.04-.27.28-.47.55-.47h.46c1.21 0 2.35 0 2.94.69.36.42.46 1.03.33 1.87M165.61 81.65h-3.21c-.28 0-.51.2-.55.47l-.14.9-.22-.32c-.69-1.01-2.24-1.34-3.79-1.34-3.54 0-6.57 2.68-7.15 6.45-.31 1.88.13 3.67 1.19 4.92.98 1.15 2.37 1.63 4.04 1.63 2.85 0 4.44-1.83 4.44-1.83l-.14.89c-.05.34.21.65.55.65h2.89c.46 0 .85-.33.92-.79l1.73-10.97a.565.565 0 0 0-.56-.66m-4.46 6.24c-.31 1.83-1.76 3.06-3.62 3.06-.93 0-1.67-.3-2.15-.87-.47-.56-.65-1.36-.5-2.25.29-1.81 1.77-3.08 3.59-3.08.91 0 1.65.3 2.14.87.48.57.68 1.38.54 2.27M213.36 81.65h-3.21c-.27 0-.51.2-.55.47l-.14.9-.22-.32c-.69-1.01-2.24-1.34-3.79-1.34-3.54 0-6.57 2.68-7.15 6.45-.31 1.88.13 3.67 1.19 4.92.98 1.15 2.37 1.63 4.04 1.63 2.85 0 4.44-1.83 4.44-1.83l-.14.89c-.05.34.21.65.55.65h2.89c.46 0 .85-.33.92-.79l1.73-10.97c.04-.36-.22-.66-.56-.66m-4.47 6.24c-.31 1.83-1.76 3.06-3.62 3.06-.93 0-1.67-.3-2.15-.87-.47-.56-.65-1.36-.5-2.25.29-1.81 1.77-3.08 3.59-3.08.91 0 1.65.3 2.14.87.49.57.68 1.38.54 2.27M182.69 81.65h-3.22c-.31 0-.6.15-.77.41l-4.44 6.55-1.88-6.29a.933.933 0 0 0-.89-.66h-3.17c-.38 0-.65.38-.53.74l3.55 10.41-3.34 4.71c-.26.37 0 .88.45.88h3.22c.31 0 .59-.15.76-.4l10.71-15.46c.26-.39 0-.89-.45-.89M217.13 75.93l-2.75 17.48c-.05.34.21.64.55.64h2.76c.46 0 .85-.33.92-.79l2.71-17.16a.556.556 0 0 0-.55-.64h-3.09c-.27 0-.5.2-.55.47"
  })));
};

var _style, _path$c, _path2$8, _path3$7;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgPrimaryNegative = function SvgPrimaryNegative(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
    id: "primary-negative_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 220.82 98.12",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React__namespace.createElement("style", null, ".primary-negative_svg__st0{fill:#fff}")), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    className: "primary-negative_svg__st0",
    d: "M45.75 53.52c0-.8-.64-1.44-1.44-1.44H0v8.97c0 .8.64 1.44 1.44 1.44h42.87c.8 0 1.44-.64 1.44-1.44v-7.53zM.88 8.89c0 .88.72 1.52 1.52 1.52h43.35V1.52c0-.88-.64-1.52-1.44-1.52H2.4C1.6 0 .88.64.88 1.52v7.37z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ae9ff3",
    d: "M32.61 10.42 0 52.08h13.86l31.89-41.66z"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React__namespace.createElement("path", {
    className: "primary-negative_svg__st0",
    d: "M117.23 26.92h15.7v34.13c0 .8.72 1.44 1.44 1.44h7.77c.8 0 1.44-.64 1.44-1.44V27.8c0-.48.4-.88.88-.88h8.01c.8 0 1.36-.56 1.36-1.44v-6.49c0-.8-.56-1.36-1.36-1.36h-8.01c-.48 0-.88-.48-.88-.88V6.73c0-.8-.64-1.44-1.44-1.44h-7.77c-.72 0-1.44.64-1.44 1.44v10.9h-15.7V6.73c0-.8-.72-1.44-1.44-1.44h-7.77c-.8 0-1.44.64-1.44 1.44v10.02c0 .4-.4.88-.88.88h-8.01c-.8 0-1.36.56-1.36 1.36v6.49c0 .88.56 1.44 1.36 1.44h8.01c.48 0 .88.4.88.88v33.25c0 .8.64 1.44 1.44 1.44h7.77c.72 0 1.44-.64 1.44-1.44V26.92zm52.74-25.48v59.61c0 .8-.64 1.44-1.44 1.44h-7.77c-.8 0-1.44-.64-1.44-1.44V1.44c0-.8.64-1.44 1.44-1.44h7.77c.8 0 1.44.64 1.44 1.44zm50.85 39.18c0-13.78-8.73-24.04-21.71-24.04-13.22 0-21.71 10.74-21.71 23.56 0 13.7 9.78 23.48 23.48 23.48 6.89 0 13.7-2.64 17.63-6.65.8-.8.8-1.52-.08-2.4l-3.93-3.93c-.88-.88-1.76-.8-2.56-.16-1.84 1.44-5.61 4.17-10.66 4.17-6.57 0-11.7-4.41-12.5-11.78h29.65c1.51 0 2.39-.48 2.39-2.25zm-12.98-5.37h-18.59c-.16-3.53 3.21-9.78 10.02-9.78 7.13 0 9.53 6.25 9.53 8.81 0 .49-.32.97-.96.97zM90.57 54.56l-3.93-3.93c-.88-.88-1.76-.8-2.56-.16-1.84 1.44-5.61 4.17-10.66 4.17-6.57 0-11.7-4.41-12.5-11.78h29.65c1.52 0 2.4-.48 2.48-2.24.64-13.78-8.81-24.04-21.79-24.04-13.22 0-21.71 10.74-21.71 23.56 0 13.7 9.78 23.48 23.48 23.48 6.89 0 13.7-2.64 17.63-6.65.79-.8.79-1.52-.09-2.41zM80 35.25H61.41c-.16-3.53 3.2-9.78 10.02-9.78 7.13 0 9.53 6.25 9.53 8.81 0 .49-.32.97-.96.97zM121.95 92.05l-4.19 6.07h2.21l9.6-14.26h-2.19l-4.08 6.24-2.32-6.24h-2.25zm-8.25-8.62c-1.49 0-2.82.78-3.82 1.98h-.03l1.61-10.23h-1.93l-2.96 18.59h1.95l.23-1.55h.06c.57 1.12 1.7 1.9 3.1 1.9 3.1 0 5.23-2.56 5.69-5.43.44-2.76-1-5.26-3.9-5.26zm1.95 5.32c-.32 1.98-1.75 3.65-3.85 3.65-2.04 0-2.9-1.75-2.59-3.65.29-1.87 1.75-3.59 3.74-3.59 2.1 0 3.02 1.63 2.7 3.59zM192.84 75.18h-6.69c-.46 0-.85.33-.92.79l-2.71 17.16c-.05.34.21.65.55.65h3.43c.32 0 .59-.23.64-.55l.77-4.87c.07-.45.46-.79.92-.79h2.12c4.41 0 6.95-2.13 7.62-6.36.3-1.85.01-3.3-.85-4.32-.96-1.11-2.64-1.71-4.88-1.71m.77 6.27c-.37 2.4-2.2 2.4-3.98 2.4h-1.01l.71-4.49c.04-.27.28-.47.55-.47h.46c1.21 0 2.35 0 2.94.69.36.42.46 1.03.33 1.87m-48.51-6.27h-6.69c-.46 0-.85.33-.92.79l-2.71 17.16c-.05.34.21.65.55.65h3.2c.46 0 .85-.33.92-.79l.73-4.63c.07-.45.46-.79.92-.79h2.12c4.41 0 6.95-2.13 7.62-6.36.3-1.85.01-3.3-.85-4.32-.97-1.11-2.65-1.71-4.89-1.71m.77 6.27c-.37 2.4-2.2 2.4-3.98 2.4h-1.01l.71-4.49c.04-.27.28-.47.55-.47h.46c1.21 0 2.35 0 2.94.69.36.42.46 1.03.33 1.87m19.23-.07h-3.21c-.28 0-.51.2-.55.47l-.14.9-.22-.32c-.69-1.01-2.24-1.34-3.79-1.34-3.54 0-6.57 2.68-7.15 6.45-.31 1.88.13 3.67 1.19 4.92.98 1.15 2.37 1.63 4.04 1.63 2.85 0 4.44-1.83 4.44-1.83l-.14.89c-.05.34.21.65.55.65H163c.46 0 .85-.33.92-.79l1.73-10.97c.06-.36-.2-.66-.55-.66m-4.46 6.24c-.31 1.83-1.76 3.06-3.62 3.06-.93 0-1.67-.3-2.15-.87-.47-.56-.65-1.36-.5-2.25.29-1.81 1.77-3.08 3.59-3.08.91 0 1.65.3 2.14.87.48.57.68 1.38.54 2.27m52.21-6.24h-3.21c-.27 0-.51.2-.55.47l-.14.9-.22-.32c-.69-1.01-2.24-1.34-3.79-1.34-3.54 0-6.57 2.68-7.15 6.45-.31 1.88.13 3.67 1.19 4.92.98 1.15 2.37 1.63 4.04 1.63 2.85 0 4.44-1.83 4.44-1.83l-.14.89c-.05.34.21.65.55.65h2.89c.46 0 .85-.33.92-.79l1.73-10.97c.04-.36-.22-.66-.56-.66m-4.47 6.24c-.31 1.83-1.76 3.06-3.62 3.06-.93 0-1.67-.3-2.15-.87-.47-.56-.65-1.36-.5-2.25.29-1.81 1.77-3.08 3.59-3.08.91 0 1.65.3 2.14.87.49.57.68 1.38.54 2.27m-26.21-6.24h-3.22c-.31 0-.6.15-.77.41l-4.44 6.55-1.88-6.29a.933.933 0 0 0-.89-.66h-3.17c-.38 0-.65.38-.53.74l3.55 10.41-3.34 4.71c-.26.37 0 .88.45.88h3.22c.31 0 .59-.15.76-.4l10.71-15.46c.27-.39.01-.89-.45-.89m34.45-5.72-2.75 17.48c-.05.34.21.64.55.64h2.76c.46 0 .85-.33.92-.79l2.71-17.16a.556.556 0 0 0-.55-.64h-3.09c-.27 0-.5.19-.55.47"
  })));
};

var _path$b, _path2$7, _path3$6;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgOnelinePrimaryPositive = function SvgOnelinePrimaryPositive(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 16"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M42.11 13.42c1.52 0 2.93-.58 3.77-1.44.16-.16.16-.34 0-.5l-.91-.9c-.18-.18-.37-.18-.58 0-.36.31-1.14.85-2.19.85-1.34 0-2.4-.91-2.56-2.36h6.2c.33 0 .51-.1.51-.47.1-3.07-1.95-5.15-4.61-5.15-2.79 0-4.59 2.29-4.59 4.99 0 3.01 2.16 4.98 4.96 4.98zm-2.38-6.04c0-.74.68-1.93 2.05-1.93 1.45 0 1.95 1.27 1.95 1.75 0 .09-.07.18-.2.18h-3.8zM.5 2.29h9.19V.31c0-.17-.14-.31-.32-.31H.5C.33 0 .19.14.19.31v1.66c0 .18.14.32.31.32zm-.2 10.9h9.09c.17 0 .3-.13.3-.3V11.2c0-.17-.13-.3-.3-.3H0v1.99c0 .17.14.3.3.3z",
    fill: "#192550"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.79 2.29 0 10.91h3.03l6.66-8.62h-2.9z",
    fill: "#AE9FF3"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.35 13.42c1.52 0 2.93-.58 3.77-1.44.16-.16.16-.34 0-.5l-.91-.9c-.18-.18-.37-.18-.58 0-.36.31-1.14.85-2.19.85-1.34 0-2.4-.91-2.56-2.36h6.2c.33 0 .51-.1.51-.47.1-3.07-1.95-5.15-4.61-5.15-2.79 0-4.59 2.29-4.59 4.99 0 3.01 2.16 4.98 4.96 4.98zm-2.38-6.04c0-.74.68-1.93 2.05-1.93 1.45 0 1.95 1.27 1.95 1.75 0 .09-.07.18-.2.18h-3.8zm22.43 5.81h-1.73c-.17 0-.3-.13-.3-.3V.3c0-.17.13-.3.3-.3h1.73c.17 0 .3.13.3.3v12.59c0 .17-.13.3-.3.3zm-12.78 0h1.73c.15 0 .3-.13.3-.3V5.75h3.19v7.14c0 .17.13.3.3.3h1.73c.17 0 .3-.13.3-.3V5.92c0-.09.08-.17.19-.17h1.66c.17 0 .3-.11.3-.26V3.98c0-.17-.13-.28-.3-.28h-1.66a.19.19 0 0 1-.19-.19v-2.1c0-.17-.13-.3-.3-.3h-1.73c-.17 0-.3.13-.3.3v2.28h-3.19V1.41c0-.17-.15-.3-.3-.3h-1.73c-.17 0-.3.13-.3.3V3.5c0 .09-.08.19-.19.19h-1.68c-.17 0-.28.11-.28.28v1.47c0 .17.11.3.28.3h1.68c.11 0 .19.08.19.17v6.97c0 .18.13.31.3.31zm38.64-1.13L58.53 16h1.44l6.23-9.26h-1.42l-2.65 4.05-1.51-4.05h-1.45l2.09 5.32zm-5.36-5.6c-.97 0-1.83.5-2.48 1.29h-.02l1.05-6.65H53.2l-1.92 12.08h1.27l.15-1.01h.04c.37.73 1.1 1.23 2.02 1.23 2.02 0 3.4-1.66 3.7-3.53.25-1.78-.68-3.41-2.56-3.41zm1.26 3.45c-.21 1.29-1.14 2.37-2.5 2.37-1.33 0-1.89-1.14-1.68-2.37.19-1.21 1.14-2.33 2.43-2.33 1.36 0 1.96 1.07 1.75 2.33zm50.471-8.81h-4.35c-.3 0-.55.22-.6.51l-1.76 11.15c-.03.22.13.42.36.42h2.23c.21 0 .39-.15.42-.36l.5-3.16c.05-.29.3-.51.6-.51h1.38c2.86 0 4.52-1.39 4.95-4.13.19-1.2.01-2.15-.55-2.81-.63-.72-1.72-1.11-3.18-1.11zm.51 4.08c-.24 1.56-1.43 1.56-2.58 1.56h-.66l.46-2.91c.03-.18.18-.31.36-.31h.3c.78 0 1.53 0 1.91.45.22.26.29.66.21 1.21zM76.62 1.1h-4.35c-.3 0-.55.22-.6.51l-1.76 11.15c-.03.22.14.42.36.42h2.08c.3 0 .55-.22.6-.51l.47-3.01c.05-.29.3-.51.6-.51h1.38c2.86 0 4.52-1.39 4.95-4.13.19-1.2.01-2.15-.56-2.81-.62-.72-1.71-1.11-3.17-1.11zm.5 4.08c-.24 1.56-1.43 1.56-2.58 1.56h-.66l.46-2.91c.03-.18.18-.31.36-.31h.3c.78 0 1.53 0 1.91.45.23.26.3.66.21 1.21zm12.5-.05h-2.08c-.18 0-.33.13-.36.31l-.09.58-.15-.22c-.45-.65-1.46-.87-2.46-.87-2.3 0-4.27 1.74-4.65 4.19-.2 1.22.08 2.38.77 3.2.64.75 1.54 1.06 2.62 1.06 1.85 0 2.88-1.19 2.88-1.19l-.09.58c-.03.22.14.42.36.42h1.87c.3 0 .55-.22.6-.51l1.13-7.13a.356.356 0 0 0-.35-.42zm-2.9 4.05c-.2 1.19-1.15 1.99-2.35 1.99-.6 0-1.09-.19-1.4-.56-.31-.36-.42-.88-.33-1.46.19-1.18 1.15-2 2.33-2 .59 0 1.07.2 1.39.57.32.36.45.88.36 1.46zm33.91-4.05h-2.08c-.18 0-.33.13-.36.31l-.09.58-.15-.21c-.45-.65-1.46-.87-2.46-.87-2.3 0-4.26 1.74-4.65 4.19-.2 1.22.08 2.38.78 3.2.64.75 1.54 1.06 2.62 1.06 1.85 0 2.88-1.19 2.88-1.19l-.09.58c-.03.22.14.42.36.42h1.88c.3 0 .55-.22.6-.51L121 5.56c.02-.23-.15-.43-.37-.43zm-2.9 4.05c-.2 1.19-1.15 1.99-2.35 1.99-.6 0-1.09-.19-1.4-.56-.31-.36-.42-.88-.33-1.46.19-1.18 1.15-2 2.33-2 .59 0 1.07.2 1.39.57.32.36.45.88.36 1.46zm-17.019-4.05h-2.09c-.2 0-.39.1-.5.26l-2.89 4.25L94 5.56a.6.6 0 0 0-.58-.43h-2.06a.36.36 0 0 0-.34.48l2.3 6.76-2.17 3.06c-.17.24 0 .57.3.57h2.09c.2 0 .38-.1.5-.26L101 5.7a.36.36 0 0 0-.29-.57zm22.369-3.72-1.78 11.35c-.03.22.14.42.36.42h1.79c.3 0 .55-.22.6-.51l1.76-11.15a.369.369 0 0 0-.36-.42h-2.01c-.18.01-.33.13-.36.31z",
    fill: "#192550"
  })));
};

var _circle, _circle2, _circle3, _path$a;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgPlayVideo = function SvgPlayVideo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    height: "70%",
    viewBox: "0 0 48 48"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 30,
    "data-highlight": "true",
    "data-outer": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 26,
    "data-highlight": "true"
  })), _circle3 || (_circle3 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24
  })), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20 17.5 31.5 24 20 30.5z"
  })));
};

var _path$9;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm30.8 18.7V32H37l.7-5.9h-6.9v-5c0-1.7.4-2.7 2.6-2.7h4.2v-5.9s-1.9-.2-4.5-.2c-6.3 0-9.4 3.6-9.4 7.8v6h-4.3V32h4.3v16.7h7.1z"
  })));
};

var _path$8;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm23.7-4.2c1.5-2 3.7-3.1 6.3-3.1s4.8 1.2 6.3 3.1h8.3v-8.2c0-1.3-1-2.3-2.3-2.3H17.7c-1.3 0-2.3 1-2.3 2.3v8.2h8.3zm18.6 18.8c1.3 0 2.3-1 2.3-2.3V29h-7c.1.4.1 1 .1 1.5 0 4.3-3.4 7.8-7.8 7.8s-7.8-3.4-7.8-7.8c0-.5.1-1 .1-1.5h-7v13.4c0 1.3 1 2.3 2.3 2.3h24.8v-.1zm-7.6-14.2c0-2.6-2.1-4.6-4.7-4.6s-4.7 2-4.7 4.6 2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7zm2.2-8.2V19c0-.5.4-1 1-1H41c.6 0 1 .4 1 1v3.1c0 .6-.4 1-1 1h-3.1c-.6.1-1-.3-1-.9z"
  })));
};

var _path$7;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30C0 13.4 13.4 0 30 0s30 13.4 30 30-13.4 30-30 30S0 46.6 0 30zm30.5-5.8c0 .5 0 1.1.1 1.5-5.6-.3-10.6-3-14-7.1-.6 1-.9 2.2-.9 3.4 0 2.3 1.2 4.5 3 5.6-1.2-.1-2.1-.3-3.1-.9v.1c0 3.4 2.3 6.1 5.4 6.7-.6.1-1.2.2-1.8.2-.5 0-.9 0-1.2-.1.8 2.7 3.4 4.8 6.3 4.8-2.3 1.8-5.3 2.9-8.5 2.9-.5 0-1 0-1.5-.1 3 1.9 6.6 3.1 10.4 3.1C37.2 44.4 44 34 44 25v-.9c1.3-1 2.5-2.2 3.4-3.5-1.2.5-2.5.9-3.9 1.1 1.4-.9 2.5-2.2 3-3.8-1.3.8-2.8 1.3-4.3 1.6-1.2-1.3-3-2.1-5-2.1-3.8 0-6.7 3.1-6.7 6.8z"
  })));
};

var _defs$2, _g$4;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgAx = function SvgAx(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "ax_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fillOpacity: 0.7,
    d: "M106.3 0h1133.3v850H106.3z"
  })))), _g$4 || (_g$4 = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#ax_svg__a)",
    transform: "matrix(.56472 0 0 .56482 -60 -.1)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0053a5",
    d: "M0 0h1300v850H0z"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#ffce00"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M400 0h250v850H400z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 300h1300v250H0z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M475 0h100v850H475z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 375h1300v100H0z"
  })))));
};

var _g$3;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgBr = function SvgBr(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React__namespace.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#229e45",
    fillRule: "evenodd",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f8e509",
    fillRule: "evenodd",
    d: "m321.4 436 301.5-195.7L319.6 44 17.1 240.7 321.4 436z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#2b49a3",
    fillRule: "evenodd",
    d: "M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m283.3 316.3-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m414 252.4 2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6 2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4zm-14.2-3.8 7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2-9-5.5zm-20.7-17 1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6-2.9-1.5zm-90.2-22.3 2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11-2.6-.4zm-14.1-1.7 1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4-10.6-1z"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f7ffff",
    d: "M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m233 198.5.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8H233z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1v3.5z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m249 185.2 5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3.7-14z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m251.7 187.7-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3h-1.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m317.6 210.2 3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2-2.8-.7z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m323 199.6-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m330.6 214.1 4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6-2.6-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m336 207.4 1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m374.3 233.1 6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2-2.5-1.3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "m380.5 227.2 1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1-1.6 3.2z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#309e3a",
    d: "m301.8 204.5 2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6-7.5-1.7z"
  }))));
};

var _path$6, _path2$6, _path3$5;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgDk = function SvgDk(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h640.1v480H0z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M205.7 0h68.6v480h-68.6z"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 205.7h640.1v68.6H0z"
  })));
};

var _path$5, _path2$5, _path3$4;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffce00",
    d: "M0 320h640v160H0z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#050505",
    d: "M0 0h640v160H0z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#d00",
    d: "M0 160h640v160H0z"
  })));
};

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 160 120"
    },
    viewBox: "0 0 160 120"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h160v120H0V0z",
    style: {
      fill: "#aa151b"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 30h160v60H0V30z",
    style: {
      fill: "#f1bf00"
    }
  }));
};

var _path$4, _path2$4, _path3$3;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgFi = function SvgFi(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#003580",
    d: "M0 174.5h640v131H0z"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#003580",
    d: "M175.5 0h130.9v480h-131z"
  })));
};

var _g$2;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgFr = function SvgFr(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  }))));
};

var _path$3, _path2$3, _path3$2, _path4$1, _path5$1;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#012169",
    d: "M0 0h640v480H0z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C8102E",
    d: "m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M241 0v480h160V0H241zM0 160v160h640V160H0z"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C8102E",
    d: "M0 193v96h640v-96H0zM273 0v480h96V0h-96z"
  })));
};

var _g$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgIt = function SvgIt(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#009246",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ce2b37",
    d: "M426.7 0H640v480H426.7z"
  }))));
};

var _image;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgMx = function SvgMx(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 120"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M106.68 0H160v120h-53.32V0Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.33 0h53.35v120H53.33V0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h53.33v120H0V0Z",
    style: {
      fill: "#006847"
    }
  }), _image || (_image = /*#__PURE__*/React__namespace.createElement("image", {
    width: 82,
    height: 75,
    transform: "matrix(.5 0 0 .5 59.51 40.86)",
    xlinkHref: "data:image/jpeg;base64,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"
  })));
};

var _path$2, _path2$2, _path3$1;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#21468b",
    d: "M0 0h640v480H0z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v320H0z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ae1c28",
    d: "M0 0h640v160H0z"
  })));
};

var _path$1, _path2$1, _path3, _path4, _path5;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ed2939",
    d: "M0 0h640v480H0z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M180 0h120v480H180z"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 180h640v120H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#002664",
    d: "M210 0h60v480h-60z"
  })), _path5 || (_path5 = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#002664",
    d: "M0 210h640v60H0z"
  })));
};

var _path, _path2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgSct = function SvgSct(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0065bd",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.6,
    d: "m0 0 5 3M0 3l5-3",
    transform: "scale(128 160)"
  })));
};

var _defs$1, _g;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgSe = function SvgSe(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "se_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fillOpacity: 0.7,
    d: "M-53.4 0h682.6v512H-53.4z"
  })))), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#se_svg__a)",
    transform: "translate(50) scale(.9375)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#006aa7",
    d: "M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M-121.1 205h256v102.4h-256z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M133.8 0h102.4v512H133.8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fecc00",
    d: "M233 205h460.8v102.4H233z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#006aa7",
    d: "M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z"
  })))));
};

var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__b",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__h",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__c",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__j",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__i",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__k",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__f",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__g",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__d",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__l",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__m",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("use", {
    id: "us_svg__e",
    href: "#us_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("image", {
    id: "us_svg__a",
    width: 30,
    height: 28,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAACXBIWXMAAAsSAAALEgHS3X78AAABZ0lEQVRIicWWPUvDUBSGT8RVCAiu9ReUTE76B6RDt64OoYO49He4dVZHJ8HBxUEUobMIBXFQRCehDiIUNdQ+DrlqGpP05t58vGNy3vc599xwiIihgHVTr7WAG2CzLvgEuKwD3CXUuA74gD95VcODCPykSnCbWb1VCT/lv6oZPfCRAD+oAhwf+Y9eTPIWgY6ILInInUb9TsrzZcDXzPBE5NhxnEcBfOAz5URl6B5o/LYCuMBtydApsJ86D2C3JPArsDH3QgBPFRelc8DV+BZmruHCEhoA29rQhCa2gHcD8ANFLB7Ca5jmAD/pZi9o1KyKiJOj35UctdkCrgzG3i4C7BqAAQY6+fPG7me8OxORUcq7NR14pkjeegHQitQcpZy+awNOGvmQhIUBtIBxrPbaBt6PBE2Ankazw1gD+pstFjZSAc9AM4evB3wpb98E3FTmw9zm0N9QzWsvnKi5Q/iTYSVgzzajNH0D8tcz3NSfMrwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h640v480H0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h640v36.16H0zm0 74.67h640v36.16H0zm0 73.06h640v36.16H0zm0 74.67h640v36.16H0zM0 296h640v36.16H0zm0 73.07h640v36.16H0zm0 74.66h640v36.16H0z",
    style: {
      fill: "#b41f30"
    }
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h364.8v258.45H0z",
    style: {
      fill: "#113d96"
    }
  }), _use || (_use = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(46 36)"
  })), _use2 || (_use2 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(107 36)"
  })), _use3 || (_use3 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(168 36)"
  })), _use4 || (_use4 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(228 36)"
  })), _use5 || (_use5 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(289 36)"
  })), _use6 || (_use6 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.1 10.07)"
  })), _use7 || (_use7 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.1 10.07)"
  })), _use8 || (_use8 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.1 10.07)"
  })), _use9 || (_use9 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.1 10.07)"
  })), _use10 || (_use10 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.1 10.07)"
  })), _use11 || (_use11 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(16 11)"
  })), _use12 || (_use12 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(45.78 87.03)"
  })), _use13 || (_use13 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(106.78 87.03)"
  })), _use14 || (_use14 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(167.78 87.03)"
  })), _use15 || (_use15 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(227.78 87.03)"
  })), _use16 || (_use16 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(288.78 87.03)"
  })), _use17 || (_use17 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(75.88 61.1)"
  })), _use18 || (_use18 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(136.88 61.1)"
  })), _use19 || (_use19 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(197.88 61.1)"
  })), _use20 || (_use20 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(257.88 61.1)"
  })), _use21 || (_use21 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(318.88 61.1)"
  })), _use22 || (_use22 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__l",
    transform: "translate(15.78 62.03)"
  })), _use23 || (_use23 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(46.12 139.37)"
  })), _use24 || (_use24 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(107.12 139.37)"
  })), _use25 || (_use25 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(168.12 139.37)"
  })), _use26 || (_use26 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(228.12 139.37)"
  })), _use27 || (_use27 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(289.12 139.37)"
  })), _use28 || (_use28 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.22 113.43)"
  })), _use29 || (_use29 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.22 113.43)"
  })), _use30 || (_use30 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.22 113.43)"
  })), _use31 || (_use31 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.22 113.43)"
  })), _use32 || (_use32 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.22 113.43)"
  })), _use33 || (_use33 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__m",
    transform: "translate(16.12 114.37)"
  })), _use34 || (_use34 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__g",
    transform: "translate(45.78 190.5)"
  })), _use35 || (_use35 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__h",
    transform: "translate(106.78 190.5)"
  })), _use36 || (_use36 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__i",
    transform: "translate(167.78 190.5)"
  })), _use37 || (_use37 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__j",
    transform: "translate(227.78 190.5)"
  })), _use38 || (_use38 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__k",
    transform: "translate(288.78 190.5)"
  })), _use39 || (_use39 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(75.88 164.57)"
  })), _use40 || (_use40 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(136.88 164.57)"
  })), _use41 || (_use41 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(197.88 164.57)"
  })), _use42 || (_use42 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(257.88 164.57)"
  })), _use43 || (_use43 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__a",
    transform: "translate(318.88 164.57)"
  })), _use44 || (_use44 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__l",
    transform: "translate(15.78 165.5)"
  })), _use45 || (_use45 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__b",
    transform: "translate(76.15 216.4)"
  })), _use46 || (_use46 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__c",
    transform: "translate(137.15 216.4)"
  })), _use47 || (_use47 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__d",
    transform: "translate(198.15 216.4)"
  })), _use48 || (_use48 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__e",
    transform: "translate(258.15 216.4)"
  })), _use49 || (_use49 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__f",
    transform: "translate(319.15 216.4)"
  })), _use50 || (_use50 = /*#__PURE__*/React__namespace.createElement("use", {
    href: "#us_svg__m",
    transform: "translate(16.05 217.33)"
  })));
};

var icons = {
    AlertCircle: SvgAlertCircle,
    ArrowRight: SvgArrowRight,
    ArrowRightOtto: SvgArrowRightOtto,
    Bank: SvgBank,
    BarDiagram: SvgBarDiagram,
    Bulb: SvgBulb,
    CardReader: SvgCardReader,
    Chat: SvgChat,
    Checkmark: SvgCheckmark,
    Cross: SvgCross,
    Edit: SvgEdit,
    Email: SvgEmail,
    ExternalLink: SvgExternalLink,
    Headphones: SvgHeadphones,
    IconDownChevron: SvgIconDownChevronS,
    IconDownChevronM: SvgIconDownChevronM,
    IconRightChevron: SvgIconRightChevron,
    LogoPayPalPrimaryPositive: SvgPrimaryPositive,
    LogoPayPalPrimaryNegetive: SvgPrimaryNegative,
    LogoPayPalPrimaryPositiveOneline: SvgOnelinePrimaryPositive,
    PlayVideo: SvgPlayVideo,
    Menu: SvgMenu,
    Minus: SvgMinus,
    Phone: SvgPhone,
    Play: SvgPlay,
    Plus: SvgPlus,
    Sad: SvgSad,
    Search: SvgSearch,
    Settings: SvgSettings,
    Sliders: SvgSliders,
    Smile: SvgSmile,
    Neutral: SvgNeutral,
    Star: SvgStar,
    Circle: SvgCircle,
    Facebook: SvgFacebook,
    Instagram: SvgInstagram,
    Twitter: SvgTwitter,
    FlagAx: SvgAx,
    FlagBr: SvgBr,
    FlagDe: SvgDe,
    FlagDk: SvgDk,
    FlagEs: SvgEs,
    FlagFi: SvgFi,
    FlagFr: SvgFr,
    FlagGb: SvgGb,
    FlagIt: SvgIt,
    FlagMx: SvgMx,
    FlagNo: SvgNo,
    FlagNl: SvgNl,
    FlagSct: SvgSct,
    FlagSe: SvgSe,
    FlagUs: SvgUs
};

var css$1d = {"icon":"styles_icon__-PHBS"};

var Svg = function (_a) {
    var name = _a.name, className = _a.className, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel;
    var svgClasses = classNames__default.default(css$1d.icon, className);
    var Icon = icons[name] || null;
    var ariaLabelAttr = ariaLabel ? { 'aria-label': ariaLabel } : undefined;
    var ariaHiddenAttr = ariaHidden || !ariaLabel ? { 'aria-hidden': true } : undefined;
    var roleImgAttr = ariaLabel ? { role: 'img' } : undefined;
    return (React__namespace.default.createElement("span", { className: svgClasses }, Icon && React__namespace.default.createElement(Icon, __assign({}, ariaHiddenAttr, ariaLabelAttr, roleImgAttr))));
};

var css$1c = {"imageContainer":"styles_imageContainer__y2Nds","image":"styles_image__9UhmU","default":"styles_default__UgSq8","twoImageContainer":"styles_twoImageContainer__fojvC","imageOne":"styles_imageOne__lXTht","imageTwo":"styles_imageTwo__azcBJ","threeImageContainer":"styles_threeImageContainer__sOM4D","sectionOne":"styles_sectionOne__dpwJm","sectionTwo":"styles_sectionTwo__86EPp","imageThree":"styles_imageThree__DSyPf","fourImageContainer":"styles_fourImageContainer__ZNw4t","columnOne":"styles_columnOne__04OZL","columnTwo":"styles_columnTwo__LimvC","row":"styles_row__ou-47","imageFour":"styles_imageFour__RA3OA"};

var ImageCluster = function (_a) {
    var _b = _a.image1, image1 = _b === void 0 ? [] : _b, _c = _a.image2, image2 = _c === void 0 ? [] : _c, _d = _a.image3, image3 = _d === void 0 ? [] : _d, _e = _a.image4, image4 = _e === void 0 ? [] : _e, _f = _a.classes, classes = _f === void 0 ? [] : _f, _editable = _a._editable;
    var filteredImages = [image1, image2, image3, image4].filter(function (image) { var _a; return checkImage((_a = image[0]) === null || _a === void 0 ? void 0 : _a.asset); });
    var Image = function (_a) {
        var _b, _c;
        var image = _a.image;
        var hasImageResizing = !!((_b = image[0]) === null || _b === void 0 ? void 0 : _b.cropAlignment);
        var hasImage = checkImage((_c = image[0]) === null || _c === void 0 ? void 0 : _c.asset);
        if (hasImageResizing) {
            return (React__namespace.default.createElement(React__namespace.default.Fragment, null, (_editable && validateBreakpointCollection(image)) ||
                image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({ className: css$1c.image }, imgResized, { key: imgResized._uid + String(index) }))); })));
        }
        else if (hasImage) {
            return (React__namespace.default.createElement(AdvanceImage, __assign({ className: css$1c.image }, image[0].asset, { src: image[0].asset.image, key: image[0]._uid })));
        }
        return null;
    };
    var getClusterVersion = function () {
        switch (filteredImages.length) {
            case 1:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$1c.imageContainer, classes[1]) },
                    React__namespace.default.createElement(Image, { image: filteredImages[0] })));
            case 2:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$1c.imageContainer, css$1c.twoImageContainer, classes[2]) },
                    React__namespace.default.createElement("div", { className: css$1c.imageOne },
                        React__namespace.default.createElement(Image, { image: filteredImages[0] })),
                    React__namespace.default.createElement("div", { className: css$1c.imageTwo },
                        React__namespace.default.createElement(Image, { image: filteredImages[1] }))));
            case 3:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$1c.imageContainer, css$1c.threeImageContainer, classes[3]) },
                    React__namespace.default.createElement("div", { className: css$1c.sectionOne },
                        React__namespace.default.createElement("div", { className: css$1c.imageOne },
                            React__namespace.default.createElement(Image, { image: filteredImages[0] }))),
                    React__namespace.default.createElement("div", { className: css$1c.sectionTwo },
                        React__namespace.default.createElement("div", { className: css$1c.imageTwo },
                            React__namespace.default.createElement(Image, { image: filteredImages[1] })),
                        React__namespace.default.createElement("div", { className: css$1c.imageThree },
                            React__namespace.default.createElement(Image, { image: filteredImages[2] })))));
            case 4:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$1c.imageContainer, css$1c.fourImageContainer, classes[4]) },
                    React__namespace.default.createElement("div", { className: css$1c.columnOne },
                        React__namespace.default.createElement("div", { className: css$1c.imageOne },
                            React__namespace.default.createElement(Image, { image: filteredImages[0] }))),
                    React__namespace.default.createElement("div", { className: css$1c.columnTwo },
                        React__namespace.default.createElement("div", { className: css$1c.row },
                            React__namespace.default.createElement("div", { className: css$1c.imageTwo },
                                React__namespace.default.createElement(Image, { image: filteredImages[1] })),
                            React__namespace.default.createElement("div", { className: css$1c.imageThree },
                                React__namespace.default.createElement(Image, { image: filteredImages[2] }))),
                        React__namespace.default.createElement("div", { className: css$1c.imageFour },
                            React__namespace.default.createElement(Image, { image: filteredImages[3] })))));
            default:
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$1c.imageContainer, classes[0]) },
                    React__namespace.default.createElement("div", { className: css$1c.default })));
        }
    };
    return getClusterVersion();
};

var css$1b = {"clusterContainer":"styles_clusterContainer__Hv0JV","one":"styles_one__DUiTX","two":"styles_two__ZesLc","three":"styles_three__dC-vj","four":"styles_four__HKA9r"};

var ImageSection = function (_a) {
    var imageCluster = _a.imageCluster, layout = _a.layout, rest = __rest(_a, ["imageCluster", "layout"]);
    var classes = ['', css$1b.one, css$1b.two, css$1b.three, css$1b.four];
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$1b.clusterContainer }, (imageCluster === null || imageCluster === void 0 ? void 0 : imageCluster[0]) && (React__namespace.default.createElement(ImageCluster, __assign({}, imageCluster[0], { classes: classes }))))));
};

var ImageStatic = function (_a) {
    var asset = _a.asset, rest = __rest(_a, ["asset"]);
    return (React__namespace.default.createElement("section", { style: { width: '100%' } }, checkImage(asset) ? (React__namespace.default.createElement(Img, __assign({}, rest, { src: asset.image, isStatic: true }))) : (React__namespace.default.createElement("div", { style: { backgroundColor: '#f8f8f8', width: '100%' } }, "Select image..."))));
};

var ActiveStoryContext = React.createContext({
    activeStory: '',
    /* eslint-disable @typescript-eslint/no-empty-function */
    setActiveStory: function () { }
});

var NavigationTreeContext = React.createContext({
    activeCategories: [],
    /* eslint-disable @typescript-eslint/no-empty-function */
    setActiveCategories: function () { },
    categoryInteraction: {
        _uid: '',
        level: 0
    },
    /* eslint-disable @typescript-eslint/no-empty-function */
    setCategoryInteraction: function () { },
    initialOpen: true,
    closeOthers: false,
    isMobile: false,
    isMobileExpanded: false,
    isExpandingMenuOpen: false,
    isMegaMenuOpen: undefined,
    treeHeight: 0,
    /* eslint-disable @typescript-eslint/no-empty-function */
    setTreeHeight: function () { },
    /* eslint-disable @typescript-eslint/no-empty-function */
    setClickedCategory: function () { },
    clickedCategory: '',
    /* eslint-disable @typescript-eslint/no-empty-function */
    setIsFixed: function () { },
    isFixed: false
});
var NavigationTreeContextProvider = function (_a) {
    var initialOpen = _a.initialOpen, closeOthers = _a.closeOthers, initialActiveCategories = _a.initialActiveCategories, children = _a.children, isMobile = _a.isMobile, isMobileExpanded = _a.isMobileExpanded, isMegaMenuOpen = _a.isMegaMenuOpen, isExpandingMenuOpen = _a.isExpandingMenuOpen;
    var _b = React.useState(initialActiveCategories || []), activeCategories = _b[0], setActiveCategories = _b[1];
    var _c = React.useState({
        _uid: '',
        level: 0
    }), categoryInteraction = _c[0], setCategoryInteraction = _c[1];
    var _d = React.useState(0), treeHeight = _d[0], setTreeHeight = _d[1];
    var _e = React.useState(''), clickedCategory = _e[0], setClickedCategory = _e[1];
    var _f = React.useState(false), isFixed = _f[0], setIsFixed = _f[1];
    return (React__namespace.default.createElement(NavigationTreeContext.Provider, { value: {
            activeCategories: activeCategories,
            setActiveCategories: setActiveCategories,
            categoryInteraction: categoryInteraction,
            setCategoryInteraction: setCategoryInteraction,
            initialOpen: initialOpen,
            closeOthers: closeOthers,
            isMobile: isMobile,
            isMobileExpanded: isMobileExpanded,
            isExpandingMenuOpen: isExpandingMenuOpen,
            isMegaMenuOpen: isMegaMenuOpen,
            treeHeight: treeHeight,
            setTreeHeight: setTreeHeight,
            setClickedCategory: setClickedCategory,
            clickedCategory: clickedCategory,
            isFixed: isFixed,
            setIsFixed: setIsFixed
        } }, children));
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var isNonEmptyArray = function (el) {
    return Array.isArray(el) && el.length > 0;
};

var isCategory = function (element) { return element.component === 'navigation-group'; };
var isPage = function (element) { return element.component === 'navigation-item'; };
function hasCategories(component) {
    if (isCategory(component)) {
        return component.body.find(function (child) { return isCategory(child); }) !== undefined;
    }
    return false;
}
function hasPages(component) {
    if (isCategory(component)) {
        return component.body.find(function (child) { return isPage(child); }) !== undefined;
    }
    return false;
}
var storyUuidMatch = function (uuid, linkId) {
    return uuid === linkId;
};
var hasPage = function (category, uuid) {
    if (!hasPages(category))
        return false;
    var match = category.body.find(function (component) {
        if (isPage(component)) {
            return storyUuidMatch(uuid, component.link.id);
        }
    });
    return match !== undefined;
};
/**
 * Find category ids of active path
 *
 * * Returns nested category ids that lead to an active path.
 * * Returns an empty array if there are no active categories.
 * * Uses Array.some() to stop recursion once a match is found.
 */
var findCatIds = function (categories, catIds, activeStory) {
    var containsActivePage = categories.some(function (category) {
        if (hasPage(category, activeStory)) {
            catIds.push(category._uid);
            return true;
        }
        if (hasCategories(category)) {
            catIds.push(category._uid);
            var subCategories = category.body.filter(isCategory);
            return isNonEmptyArray(findCatIds(subCategories, catIds, activeStory));
        }
        return false;
    });
    if (containsActivePage)
        return catIds;
    return [];
};
/**
 * Find parent category ids of the active page
 */
var findActiveCategories = function (menu, activeStory) {
    var catIds = [];
    menu.some(function (category) {
        if (!category.body) {
            return false;
        }
        var subCategories = category.body.filter(isCategory);
        // Reset category id search for each top-level category
        catIds = findCatIds(subCategories, [], activeStory);
        if (isNonEmptyArray(catIds) || hasPage(category, activeStory)) {
            catIds.unshift(category._uid);
        }
        return isNonEmptyArray(catIds);
    });
    return catIds;
};

var Html = function (_a) {
    var html = _a.html, className = _a.className;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, html && (React__namespace.default.createElement("div", { className: className, dangerouslySetInnerHTML: {
            __html: html
        } }))));
};

var ExternalLink = function (_a) {
    var href = _a.href, onClick = _a.onClick, children = _a.children, props = __rest(_a, ["href", "onClick", "children"]);
    var rel = props.target === '_blank' ? { rel: 'noopener' } : {};
    return (React__namespace.default.createElement("a", __assign({ href: href, onClick: onClick }, props, rel), children));
};

var HeaderContext = React.createContext({
    isMobileMenuOpen: false,
    isDesktopMenuOpen: false,
    headerHeight: 0,
    /* eslint-disable @typescript-eslint/no-empty-function */
    setIsMobileMenuOpen: function () { },
    setHeaderHeight: function () { },
    setActiveHeaderText: function () { },
    activeHeaderText: '',
    toggleMenu: function () { },
    closeDesktopMenu: function () { },
    closeSideMenu: function () { },
    openDesktopMenu: function () { },
    isSideMenuOpen: false,
    setIsSideMenuOpen: function () { },
    activeMenuItems: [],
    setActiveMenuItems: function () { },
    activeMainMenuItem: '',
    setActiveMainMenuItem: function () { },
    closeSideAndMobileMenu: function () { }
});
var HeaderContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(false), isMobileMenuOpen = _b[0], setIsMobileMenuOpen = _b[1];
    var _c = React.useState(false), isDesktopMenuOpen = _c[0], setIsDesktopMenuOpen = _c[1];
    var _d = React.useState(0), headerHeight = _d[0], setHeaderHeight = _d[1];
    var _e = React.useState(undefined), activeHeaderText = _e[0], setActiveHeaderText = _e[1];
    var toggleMenu = function () { return setIsMobileMenuOpen(!isMobileMenuOpen); };
    var closeDesktopMenu = function () { return setIsDesktopMenuOpen(false); };
    var openDesktopMenu = function () { return setIsDesktopMenuOpen(true); };
    var _f = React.useState(false), isSideMenuOpen = _f[0], setIsSideMenuOpen = _f[1];
    var _g = React.useState([]), activeMenuItems = _g[0], setActiveMenuItems = _g[1];
    var _h = React.useState(''), activeMainMenuItem = _h[0], setActiveMainMenuItem = _h[1];
    var closeSideMenu = function () {
        setActiveMainMenuItem('');
        closeDesktopMenu();
        setTimeout(function () {
            setIsSideMenuOpen(false);
            setActiveMenuItems([]);
        }, 300);
    };
    var closeSideAndMobileMenu = function () {
        closeSideMenu();
        setIsMobileMenuOpen(false);
    };
    return (React__namespace.default.createElement(HeaderContext.Provider, { value: {
            isMobileMenuOpen: isMobileMenuOpen,
            isDesktopMenuOpen: isDesktopMenuOpen,
            toggleMenu: toggleMenu,
            setIsMobileMenuOpen: setIsMobileMenuOpen,
            closeDesktopMenu: closeDesktopMenu,
            closeSideMenu: closeSideMenu,
            openDesktopMenu: openDesktopMenu,
            headerHeight: headerHeight,
            setHeaderHeight: setHeaderHeight,
            activeHeaderText: activeHeaderText,
            setActiveHeaderText: setActiveHeaderText,
            isSideMenuOpen: isSideMenuOpen,
            setIsSideMenuOpen: setIsSideMenuOpen,
            activeMenuItems: activeMenuItems,
            setActiveMenuItems: setActiveMenuItems,
            activeMainMenuItem: activeMainMenuItem,
            setActiveMainMenuItem: setActiveMainMenuItem,
            closeSideAndMobileMenu: closeSideAndMobileMenu
        } }, children));
};

var AnchorLink = function (_a) {
    var to = _a.to, children = _a.children, _b = _a.offset, offset = _b === void 0 ? 0 : _b, className = _a.className, props = __rest(_a, ["to", "children", "offset", "className"]);
    var headerHeight = React.useContext(HeaderContext).headerHeight;
    var _c = React.useContext(NavigationTreeContext), setActiveCategories = _c.setActiveCategories, isMobile = _c.isMobile, treeHeight = _c.treeHeight, isFixed = _c.isFixed;
    var handleNavigationTreeClick = function () {
        if (setActiveCategories && isMobile) {
            var height = treeHeight && !isFixed ? treeHeight : 0;
            var mobileMenuHeight = height + 60;
            offset = -mobileMenuHeight;
            setActiveCategories([]);
        }
    };
    var handleClick = function (e) {
        var element = document.getElementById(to);
        if (element) {
            e.preventDefault();
            handleNavigationTreeClick();
            var y = (element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) +
                window.pageYOffset +
                offset -
                headerHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };
    return (React__namespace.default.createElement(ExternalLink, __assign({ href: "#".concat(to), onClick: handleClick, className: className }, props), children));
};

var DefaultLink = function (_a) {
    var href = _a.href, children = _a.children, props = __rest(_a, ["href", "children"]);
    return (React__namespace.default.createElement("a", __assign({ href: href }, props), children));
};

var variables = {"anchorLinkOffsetY":"-56"};

var isValidInternalLink = function (url) {
    // is not an internal link type
    if (url.linktype !== 'story') {
        return false;
    }
    // no entry has been set
    if (!url.id) {
        return false;
    }
    return true;
};
var Link = function (_a) {
    var url = _a.url, anchor = _a.anchor, children = _a.children, onClick = _a.onClick, trackingId = _a.trackingId, noFocus = _a.noFocus, props = __rest(_a, ["url", "anchor", "children", "onClick", "trackingId", "noFocus"]);
    var _b = React.useContext(SiteComponentContext), provider = _b.provider, Link = _b.components.Link, internalLinks = _b.internalLinks, lang = _b.lang;
    var hiddenLink = noFocus
        ? {
            'aria-hidden': true,
            tabIndex: -1
        }
        : undefined;
    if (anchor) {
        return (React__namespace.default.createElement(AnchorLink, __assign({ to: url.url, "data-tracking": trackingId, offset: parseInt(variables.anchorLinkOffsetY) }, props, hiddenLink), children));
    }
    if (url.linktype === 'url' || !isValidInternalLink(url)) {
        return (React__namespace.default.createElement(ExternalLink, __assign({ href: url.url, onClick: onClick, "data-tracking": trackingId }, props, hiddenLink), children));
    }
    var cachedUrl = "/".concat(url.cached_url)
        .replace(/^\/{2,}/g, '/')
        .replace(/\/$/, '');
    switch (provider) {
        case 'gatsby':
            return (React__namespace.default.createElement(Link, __assign({ to: (internalLinks[url.id] && internalLinks[url.id][lang]) || cachedUrl, "data-tracking": trackingId }, props), children));
        case 'next':
            return (React__namespace.default.createElement(Link, { href: (internalLinks[url.id] && internalLinks[url.id][lang]) || cachedUrl },
                React__namespace.default.createElement("a", __assign({ className: props.className || '', "data-tracking": trackingId }, props, hiddenLink), children)));
        default:
            return (React__namespace.default.createElement(DefaultLink, __assign({ href: cachedUrl, "data-tracking": trackingId }, props, hiddenLink), children));
    }
};

var HeadingsContext = React.createContext({
    headings: [],
    /* eslint-disable @typescript-eslint/no-empty-function */
    setHeadings: function () { }
});
var HeadingsContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState([]), headings = _b[0], setHeadings = _b[1];
    return (React__namespace.default.createElement(HeadingsContext.Provider, { value: {
            headings: headings,
            setHeadings: setHeadings
        } }, children));
};

var css$1a = {"navigationTree":"styles_navigationTree__DiQfl","hasActiveChild":"styles_hasActiveChild__j1jzc","active":"styles_active__X-fh-","level-0":"styles_level-0__4SdEv","open":"styles_open__UGhhu","level-1":"styles_level-1__DCVaU","level-2":"styles_level-2__WM28B","noBorders":"styles_noBorders__ZCvoF","pages":"styles_pages__DOcbQ","icon":"styles_icon__AlcKl","transformDisabled":"styles_transformDisabled__Pd-zY","hasChildren":"styles_hasChildren__RoTk5","zeroHeight":"styles_zeroHeight__8OPUx","legal":"styles_legal__0cDWR"};

/**
 * Page Navigation Element
 *
 * Characteristics:
 * * Contains a link.
 * * Has an active state.
 * * Resets category interaction flag to show active page.
 */
var Page = React.memo(function (_a) {
    var _b;
    var element = _a.element, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var activeStory = React.useContext(ActiveStoryContext).activeStory;
    var _c = React.useContext(NavigationTreeContext), setCategoryInteraction = _c.setCategoryInteraction, isMobile = _c.isMobile;
    var toggle = React.useCallback(function () {
        isMobile && (rootToggle === null || rootToggle === void 0 ? void 0 : rootToggle());
        setCategoryInteraction({ _uid: '', level: 0 });
    }, [isMobile]);
    var isActive = React.useCallback(function () { return storyUuidMatch(activeStory, element.link.id); }, [activeStory]);
    var _d = React.useState(isActive()), active = _d[0], setActive = _d[1];
    React.useEffect(function () {
        setActive(isActive());
    }, [activeStory]);
    return (React__namespace.default.createElement("li", { key: element._uid },
        React__namespace.default.createElement(Link, { "data-testid": element.link.id, onClick: toggle, url: element.link, "aria-current": active, "aria-hidden": invisible, tabIndex: invisible ? -1 : 0, className: classNames__default.default((_b = {},
                _b[css$1a.active] = active,
                _b['color-action-inline'] = isMobile,
                _b['color-action-secondary--active'] = !isMobile,
                _b['bg-action-secondary--active'] = !isMobile,
                _b['border-action-primary--active'] = !isMobile,
                _b), 'color-default', 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated') },
            React__namespace.default.createElement(Html, { html: element.text }))));
});
var PageHeading = React.memo(function (_a) {
    var _b, _c;
    var element = _a.element, activeId = _a.activeId, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var isMobile = React.useContext(NavigationTreeContext).isMobile;
    var id = element.link.id;
    var active = activeId === id;
    var handleClick = React.useCallback(function () {
        rootToggle === null || rootToggle === void 0 ? void 0 : rootToggle();
    }, [rootToggle]);
    return (React__namespace.default.createElement("li", { "aria-hidden": invisible, key: element._uid, className: classNames__default.default((_b = {},
            _b[css$1a.active] = active,
            _b)) },
        React__namespace.default.createElement(AnchorLink, { to: id, onClick: isMobile ? handleClick : undefined, className: classNames__default.default((_c = {},
                _c[css$1a.active] = active,
                _c['color-action-inline'] = isMobile,
                _c['color-action-secondary--active'] = !isMobile,
                _c['bg-action-secondary--active'] = !isMobile,
                _c['border-action-primary--active'] = !isMobile,
                _c), 'color-default', 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated'), "aria-hidden": invisible, tabIndex: invisible ? -1 : 0 }, element.text)));
});
var PageGroup = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var headings = React.useContext(HeadingsContext).headings;
    if (headings && headings.length > 0) {
        return (React__namespace.default.createElement(PageGroupHeadings, { elements: elements, level: level, invisible: invisible, rootToggle: rootToggle }));
    }
    return (React__namespace.default.createElement(PageGroupPages, { elements: elements, invisible: invisible, rootToggle: rootToggle, level: level }));
});
var PageGroupPages = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    var isPageGroupInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { ref: ref, "aria-hidden": invisible, className: classNames__default.default(css$1a["level-".concat(level + 1)], css$1a.pages, 'bg-grouped-primary') }, elements.map(function (page) { return (React__namespace.default.createElement(Page, { key: page._uid, element: page, invisible: isPageGroupInvisible, rootToggle: rootToggle })); })));
});
var PageGroupHeadings = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    var isPageHeadingsInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { ref: ref, "aria-hidden": isPageHeadingsInvisible, className: classNames__default.default(css$1a["level-".concat(level + 1)], css$1a.pages, 'bg-grouped-primary') }, elements.map(function (heading) { return (React__namespace.default.createElement(PageHeading, { key: heading._uid, element: heading, invisible: isPageHeadingsInvisible, rootToggle: rootToggle })); })));
});

var Button = function (_a) {
    var trackingId = _a.trackingId, _b = _a.className, className = _b === void 0 ? 'styled-button styled-button-primary' : _b, tabIndex = _a.tabIndex, children = _a.children, props = __rest(_a, ["trackingId", "className", "tabIndex", "children"]);
    var ref = React.useRef(null);
    var buttonProps = button.useButton(__assign({}, props), ref).buttonProps;
    return (React__namespace.default.createElement("button", __assign({}, buttonProps, { className: className, "data-tracking": trackingId, tabIndex: tabIndex, ref: ref }), children));
};
React.forwardRef(function (_a, forwardedRef) {
    var _b = _a.tag, tag = _b === void 0 ? 'div' : _b, trackingId = _a.trackingId, className = _a.className, tabIndex = _a.tabIndex, children = _a.children, props = __rest(_a, ["tag", "trackingId", "className", "tabIndex", "children"]);
    var ref = React.useRef(null);
    ref = forwardedRef || ref;
    var buttonProps = button.useButton(__assign(__assign({}, props), { elementType: tag }), ref).buttonProps;
    // skip JSX to avoid ts errors with ElementType with refs
    // To be able to have JSX again, there might be less conflicts in later
    // versions of react, typescript, ts-jest and their type definitions.
    return React__namespace.default.createElement(tag, __assign(__assign({}, buttonProps), { className: className, 'data-tracking': trackingId, tabIndex: tabIndex, ref: ref }), children);
});

/**
 * Category Navigation Element
 *
 * Characteristics:
 * * Open and close only: no page link.
 * * On initial load, shows active path.
 * * On interaction with a category, initial load state is ignored.
 */
var Category = React.memo(function (_a) {
    var _b, _c;
    var _uid = _a._uid, element = _a.element, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useContext(NavigationTreeContext), activeCategories = _e.activeCategories, categoryInteraction = _e.categoryInteraction, setCategoryInteraction = _e.setCategoryInteraction, initialOpen = _e.initialOpen, isExpandingMenuOpen = _e.isExpandingMenuOpen, isMegaMenuOpen = _e.isMegaMenuOpen, closeOthers = _e.closeOthers, setClickedCategory = _e.setClickedCategory;
    var _f = reactUse.useMeasure(), ref = _f[0], height = _f[1].height;
    var _g = React.useState(false), transformActive = _g[0], setTransformActive = _g[1];
    var hasChildren = React.useCallback(function () {
        if (isCategory(element)) {
            return isNonEmptyArray(element.body);
        }
        return false;
    }, [element]);
    var hasActiveChild = React.useCallback(function () { return activeCategories.includes(element._uid); }, [activeCategories, element]);
    var isPeerThatShouldBeClosed = React.useCallback(function () {
        if (closeOthers) {
            return (level === categoryInteraction.level &&
                _uid !== categoryInteraction._uid);
        }
    }, [_uid, level, closeOthers, categoryInteraction]);
    var toggle = function () {
        setTransformActive(true);
        setCategoryInteraction({ _uid: _uid, level: level });
        setOpen(!open);
        if (setClickedCategory)
            setClickedCategory(_uid);
    };
    var categories = [];
    var pages = [];
    if (isCategory(element)) {
        categories = element.body.filter(isCategory);
        pages = element.body.filter(isPage);
    }
    React.useEffect(function () {
        if (initialOpen) {
            setOpen(hasActiveChild());
        }
    }, [activeCategories]);
    React.useEffect(function () {
        setOpen(function (prevOpen) {
            if (prevOpen && isPeerThatShouldBeClosed()) {
                return false;
            }
            return prevOpen;
        });
    }, [categoryInteraction]);
    // a collapsed menu has height 0
    var isCategoryInvisible = invisible ||
        height === 0 ||
        isExpandingMenuOpen === false ||
        isMegaMenuOpen === false;
    return (React__namespace.default.createElement("li", { key: element._uid, className: classNames__default.default((_b = {}, _b[css$1a.open] = open, _b)), ref: ref },
        React__namespace.default.createElement(Button, { onPress: toggle, "aria-expanded": open, "aria-hidden": isCategoryInvisible, tabIndex: isCategoryInvisible ? -1 : 0, className: classNames__default.default((_c = {},
                _c[css$1a.hasChildren] = hasChildren(),
                _c[css$1a.hasActiveChild] = hasActiveChild(),
                _c[css$1a.open] = open,
                _c[css$1a.transformDisabled] = !transformActive,
                _c), 'bg-grouped-secondary--focus', 'bg-grouped-secondary--hover', 'text_undecorated') },
            isCategory(element) && (React__namespace.default.createElement(Html, { html: element.title })),
            React__namespace.default.createElement(Svg, { name: "IconDownChevron", className: css$1a.icon })),
        isNonEmptyArray(categories) && (React__namespace.default.createElement(CategoryGroup, { elements: categories, level: level + 1, open: open, invisible: isCategoryInvisible, rootToggle: rootToggle || toggle })),
        isNonEmptyArray(pages) && (React__namespace.default.createElement(PageGroup, { elements: pages, level: level, invisible: isCategoryInvisible, rootToggle: rootToggle || toggle }))));
});
var CategoryGroup = React.memo(function (_a) {
    var elements = _a.elements, level = _a.level, invisible = _a.invisible, rootToggle = _a.rootToggle;
    var _b = reactUse.useMeasure(), ref = _b[0], height = _b[1].height;
    if (!elements)
        return null;
    // a collapsed menu has height 0
    var isCategoryGroupInvisible = invisible || height === 0;
    return (React__namespace.default.createElement("ul", { className: css$1a["level-".concat(level)], "aria-hidden": isCategoryGroupInvisible, ref: ref }, elements.map(function (element) { return (React__namespace.default.createElement(Category, { key: element._uid, _uid: element._uid, element: element, level: level, invisible: isCategoryGroupInvisible, rootToggle: rootToggle })); })));
});

var NavigationTree = React.memo(function (_a) {
    var _b;
    var initialActiveStory = _a.initialActiveStory, _c = _a.menu, menu = _c === void 0 ? [] : _c, _d = _a.initialOpen, initialOpen = _d === void 0 ? true : _d, _e = _a.closeOthers, closeOthers = _e === void 0 ? false : _e, _f = _a.noBorders, noBorders = _f === void 0 ? false : _f, _g = _a.cssClass, cssClass = _g === void 0 ? '' : _g, _h = _a.initialOpenCategories, initialOpenCategories = _h === void 0 ? [] : _h, isMobile = _a.isMobile, isMobileExpanded = _a.isMobileExpanded, isExpandingMenuOpen = _a.isExpandingMenuOpen, isMegaMenuOpen = _a.isMegaMenuOpen, isFixed = _a.isFixed, _j = _a.title, title = _j === void 0 ? '' : _j, _k = _a.ariaNavTitle, ariaNavTitle = _k === void 0 ? '' : _k, toggle = _a.toggle;
    var setActiveStory = React.useContext(ActiveStoryContext).setActiveStory;
    var initialActiveCategories = initialOpenCategories;
    if (initialActiveStory) {
        initialActiveCategories = findActiveCategories(menu, initialActiveStory);
    }
    React.useEffect(function () {
        setActiveStory(initialActiveStory);
    }, []);
    var ContainerTag = isMobile ? 'div' : 'nav';
    var isHidden = isMegaMenuOpen === false || isExpandingMenuOpen == false;
    return (React__namespace.default.createElement(ContainerTag, { "aria-label": ariaNavTitle ? ariaNavTitle : title ? title : 'navigation tree', "aria-hidden": isHidden, className: classNames__default.default(css$1a.navigationTree, (_b = {},
            _b[css$1a.noBorders] = noBorders,
            _b[css$1a.legal] = cssClass === 'legal',
            _b), 'bg-default') },
        toggle && (React__namespace.default.createElement("button", { onClick: toggle, "aria-hidden": true, className: css$1a.zeroHeight, tabIndex: -1 })),
        React__namespace.default.createElement(NavigationTreeContextProvider, { initialOpen: initialOpen, closeOthers: closeOthers, initialActiveCategories: initialActiveCategories, isMobile: isMobile, isMobileExpanded: isMobileExpanded, isMegaMenuOpen: isMegaMenuOpen, isExpandingMenuOpen: isExpandingMenuOpen },
            React__namespace.default.createElement(NavigationTreeRoot, { menu: menu, isFixed: isFixed, open: initialOpen }))));
});
var NavigationTreeRoot = React.memo(function (_a) {
    var menu = _a.menu, isFixed = _a.isFixed, open = _a.open;
    var root = React.useRef(null);
    var activeStory = React.useContext(ActiveStoryContext).activeStory;
    var _b = React.useContext(NavigationTreeContext), setActiveCategories = _b.setActiveCategories, setTreeHeight = _b.setTreeHeight, clickedCategory = _b.clickedCategory, setIsFixed = _b.setIsFixed, isMobileExpanded = _b.isMobileExpanded, isExpandingMenuOpen = _b.isExpandingMenuOpen, isMegaMenuOpen = _b.isMegaMenuOpen;
    var categories = menu.filter(isCategory);
    var pages = menu.filter(isPage);
    React.useEffect(function () {
        if (activeStory) {
            setActiveCategories(findActiveCategories(menu, activeStory));
        }
    }, [activeStory]);
    React.useEffect(function () {
        var _a;
        if (setTreeHeight && (root === null || root === void 0 ? void 0 : root.current)) {
            setTreeHeight((_a = root.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height);
        }
    }, [clickedCategory]);
    React.useEffect(function () {
        if (setIsFixed && isFixed)
            setIsFixed(isFixed);
    }, [isFixed]);
    var isHiddenByOuterMenu = isMobileExpanded === false ||
        isExpandingMenuOpen === false ||
        isMegaMenuOpen === false;
    return (React__namespace.default.createElement("div", { ref: root },
        React__namespace.default.createElement(CategoryGroup, { elements: categories, level: 0, invisible: isHiddenByOuterMenu, open: open }),
        React__namespace.default.createElement(PageGroup, { elements: pages, level: 0, invisible: isHiddenByOuterMenu })));
});

exports.OttoIconSizes = void 0;
(function (OttoIconSizes) {
    OttoIconSizes["ExtraLarge"] = "ExtraLarge";
    OttoIconSizes["Large"] = "Large";
    OttoIconSizes["ExtraSmall"] = "ExtraSmall";
    OttoIconSizes["Small"] = "Small";
    OttoIconSizes["Medium"] = "Medium";
})(exports.OttoIconSizes || (exports.OttoIconSizes = {}));
var OttoIconContext = React.createContext({
    ottoIcons: {}
});
var useOttoIcons = function () {
    var context = React.useContext(OttoIconContext);
    if (context === undefined) {
        throw new Error('useOttoIcons must be used within OttoIconProvider');
    }
    return context;
};
var OttoIconProvider = function (_a) {
    var ottoIcons = _a.ottoIcons, children = _a.children;
    return (React__namespace.default.createElement(OttoIconContext.Provider, { value: { ottoIcons: ottoIcons !== null && ottoIcons !== void 0 ? ottoIcons : {} } }, children));
};

var css$19 = {"ottoIcon":"styles_ottoIcon__EgH7u"};

var OttoIcon = function (_a) {
    var _b;
    var _c = _a.icon, icon = _c === void 0 ? { name: '', size: exports.OttoIconSizes.Medium, svg: '' } : _c, color = _a.color, nonStandardSizeOverride = _a.nonStandardSizeOverride, label = _a.label, block = _a.block, offsetX = _a.offsetX, offsetY = _a.offsetY;
    var originalSize = React.useMemo(function () { return getOriginalSize(icon); }, [icon]);
    var overriddenSize = React.useMemo(function () { return getOverriddenSize(icon, nonStandardSizeOverride); }, [icon, nonStandardSizeOverride]);
    var adjustedSvg = React.useMemo(function () {
        return getAdjustedSvg(icon, overriddenSize, originalSize, nonStandardSizeOverride, !label);
    }, [icon, overriddenSize, originalSize, nonStandardSizeOverride, label]);
    var imgRoleWithLabel = label
        ? {
            'aria-label': label,
            title: label,
            role: 'img'
        }
        : undefined;
    return (React__namespace.default.createElement("span", __assign({}, imgRoleWithLabel, { className: css$19.ottoIcon, style: (_b = {
                color: color,
                minWidth: overriddenSize,
                minHeight: overriddenSize,
                maxHeight: overriddenSize
            },
            _b[block ? 'display' : ''] = block ? 'block' : '',
            _b.transform = "translate(".concat(offsetX || 0, "px, ").concat(offsetY || 0, "px)"),
            _b), dangerouslySetInnerHTML: { __html: adjustedSvg } })));
};
var getOriginalSize = function (icon) {
    switch (icon === null || icon === void 0 ? void 0 : icon.size) {
        case exports.OttoIconSizes.ExtraSmall:
            return 16;
        case exports.OttoIconSizes.Small:
            return 20;
        case exports.OttoIconSizes.Medium:
            return 24;
        case exports.OttoIconSizes.Large:
            return 48;
        default:
        case exports.OttoIconSizes.ExtraLarge:
            return 96;
    }
};
var getOverriddenSize = function (icon, nonStandardSizeOverride) {
    switch (nonStandardSizeOverride || (icon === null || icon === void 0 ? void 0 : icon.size)) {
        case exports.OttoIconSizes.ExtraSmall:
            return 16;
        case exports.OttoIconSizes.Small:
            return 20;
        case exports.OttoIconSizes.Medium:
            return 24;
        case exports.OttoIconSizes.Large:
            return 48;
        default:
        case exports.OttoIconSizes.ExtraLarge:
            return 96;
    }
};
var getAdjustedSvg = function (icon, overriddenSize, originalSize, nonStandardSizeOverride, ariaHidden) {
    if (!nonStandardSizeOverride) {
        return icon === null || icon === void 0 ? void 0 : icon.svg;
    }
    return icon === null || icon === void 0 ? void 0 : icon.svg.replace(/\swidth="\d*"/g, " width=\"".concat(overriddenSize, "\"")).replace(/\sheight="\d*"/g, " height=\"".concat(overriddenSize, "\"")).replace(/\sviewBox="[\d|\s]*"/g, '').replace('<svg ', "<svg focusable=\"false\" viewBox=\"0 0 ".concat(originalSize, " ").concat(originalSize, "\"").concat(ariaHidden ? ' aria-hidden="true"' : '', " "));
};

var module$1 = {
    collectIcons: collectIcons,
    isOttoIconData: isOttoIconData
};
var iconSizes = Object.keys(exports.OttoIconSizes);
function isBlockTree(value) {
    var potentialBlockTree = value;
    return (isNonEmptyArray(potentialBlockTree) &&
        typeof potentialBlockTree[0].component === 'string');
}
function isGlobalReference(value) {
    return value === 'global-reference';
}
function isOttoIconField(fieldName) {
    return fieldName.startsWith('ottoIcon');
}
function isMultiSizeIcon(value) {
    return isNonEmptyArray(value) && typeof value[0] === 'string';
}
function isOttoIconBlock(value) {
    return (isNonEmptyArray(value) &&
        value[0].component === 'otto-icon');
}
function isOttoIconName(value) {
    return (typeof value === 'string' &&
        new RegExp(iconSizes.join('|') + '$').test(value));
}
function isOttoIconData(entry) {
    var icon = entry;
    return (typeof (icon === null || icon === void 0 ? void 0 : icon.name) === 'string' &&
        iconSizes.includes(icon === null || icon === void 0 ? void 0 : icon.size) &&
        typeof (icon === null || icon === void 0 ? void 0 : icon.svg) === 'string');
}
function loadOttoIcons(data, ottoModule) {
    return Array.from(collectIcons(new Set(), data)).reduce(function (acc, name) {
        acc[name] = ottoModule[name];
        return acc;
    }, {});
}
/*
 * Reduce a storyblok page json to list of otto icon names
 */
function collectIcons() {
    var _a, _b, _c, _d, _e;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var coll = args[0];
    var block = args[1];
    for (var _f = 0, _g = Object.entries(block); _f < _g.length; _f++) {
        var _h = _g[_f], fieldName = _h[0], value = _h[1];
        if (isOttoIconField(fieldName)) {
            if (isMultiSizeIcon(value)) {
                value.map(function (icon) { return isOttoIconName(icon) && coll.add(icon); });
            }
            else if (isOttoIconBlock(value)) {
                value.map(function (_a) {
                    var icon = _a.icon;
                    return isOttoIconName(icon) && coll.add(icon);
                });
            }
            else if (isOttoIconName(value)) {
                coll.add(value);
            }
        }
        if (isBlockTree(value)) {
            coll = value.reduce(module$1.collectIcons, coll);
        }
        if (isGlobalReference(value)) {
            coll =
                (_e = (_d = (_c = (_b = (_a = block.reference) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.global) === null || _c === void 0 ? void 0 : _c.reduce) === null || _d === void 0 ? void 0 : _d.call(_c, module$1.collectIcons, coll)) !== null && _e !== void 0 ? _e : coll;
        }
        if (isStoryblokRichTextField(value)) {
            coll = richTextRecurse(coll, value);
        }
    }
    return coll;
}
function isStoryblokRichTextField(data) {
    var block = data;
    return (block.type === 'doc' &&
        block.content !== undefined &&
        isNonEmptyArray(block.content));
}
function isStoryblokRichTextComponent(data) {
    var block = data;
    return (isNonEmptyArray(block) &&
        block[0].component === 'richtext' &&
        block[0].body !== undefined &&
        isNonEmptyArray(block[0].body.content));
}
function richTextRecurse(iconColl, block) {
    if (isStoryblokRichTextComponent(block)) {
        return block.reduce(function (acc, next) {
            return collectRichTextOttoIcons(acc, next.body);
        }, iconColl);
    }
    else if (Array.isArray(block)) {
        return block.reduce(function (acc, next) { return collectRichTextOttoIcons(acc, next); }, iconColl);
    }
    else if (isStoryblokRichTextField(block)) {
        collectRichTextOttoIcons(iconColl, block);
    }
    return iconColl;
}
function collectRichTextOttoIcons(iconColl, body) {
    var _a, _b, _c;
    if (!body)
        return iconColl;
    var richtextObject = body;
    switch (body.type) {
        case 'blok':
            return (((_c = (_b = ((_a = richtextObject.attrs) === null || _a === void 0 ? void 0 : _a.body)).reduce) === null || _c === void 0 ? void 0 : _c.call(_b, module$1.collectIcons, iconColl)) || iconColl);
        case 'doc':
            return richTextRecurse(iconColl, body.content);
        default:
            return iconColl;
    }
}
var ottoUtils = module$1;

var initialized = false;
var initializeStoryblok = function () {
    if (!initialized) {
        react.storyblokInit({});
        initialized = true;
    }
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
initializeStoryblok();
var richTextSchema = cloneDeep__default.default(react.RichTextSchema);
var createComponentResolver = function (Components, _a) {
    if (Components === void 0) { Components = {}; }
    var additionalProps = _a.additionalProps, _b = _a.ottoIcons, ottoIcons = _b === void 0 ? {} : _b;
    return function (component, blok) {
        if (typeof Components[component] !== 'undefined') {
            var Component = Components[component];
            return ReactDOMServer__default.default.renderToStaticMarkup(React__namespace.default.createElement(OttoIconProvider, { ottoIcons: ottoIcons },
                React__namespace.default.createElement(Component, __assign({}, blok, additionalProps))));
        }
    };
};
var isStoryblokRichText = function (data) {
    return (data === null || data === void 0 ? void 0 : data.content) && isNonEmptyArray(data.content);
};
var recursivelyFindTextContent = function (jsonObject) {
    return jsonObject.find(function (obj) {
        return (isNonEmptyArray(obj.content) &&
            recursivelyFindTextContent(obj.content)) ||
            (obj.text && obj.type === 'text');
    });
};
var filterStoryblokRichText = function (body, disallowedEmptyTextTypes) { return (__assign(__assign({}, body), { content: filterStoryblokRichTextContent(body.content, disallowedEmptyTextTypes) })); };
// Check if Storyblok component has real content
// Storyblok API sends a json even though the field might be empty
var filterStoryblokRichTextContent = function (body, disallowedEmptyTextTypes) {
    function bodyIsArray(value) {
        return Array.isArray(value);
    }
    var result = bodyIsArray(body) ? [] : {};
    var filterObject = function (jsonObject) {
        if (!jsonObject)
            return { type: 'paragraph' };
        if (disallowedEmptyTextTypes.includes(jsonObject.type)) {
            if (!Array.isArray(jsonObject.content)) {
                // stop recursion
                return { type: 'paragraph' };
            }
            else {
                // lift up and recurse nested content if there's not text-content
                var hasTextContent = recursivelyFindTextContent(jsonObject.content);
                return hasTextContent
                    ? __assign(__assign({}, cloneDeep__default.default(jsonObject)), { content: filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes) }) : filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes);
            }
        }
        else if (Array.isArray(jsonObject.content)) {
            // recurse nested content
            return __assign(__assign({}, cloneDeep__default.default(jsonObject)), { content: filterStoryblokRichTextContent(jsonObject.content, disallowedEmptyTextTypes) });
        }
        else {
            // stop recursion
            return cloneDeep__default.default(jsonObject);
        }
    };
    if (bodyIsArray(body)) {
        result = body.map(function (bodyElement) {
            return filterObject(bodyElement);
        });
    }
    else if (body) {
        result = filterObject(body);
    }
    return result;
};
var renderStoryblokRichText = function (data, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.Components, Components = _c === void 0 ? {} : _c, _d = _b.noFocus, noFocus = _d === void 0 ? false : _d, _e = _b.disallowedEmptyTextTypes, disallowedEmptyTextTypes = _e === void 0 ? ['heading'] : _e, _f = _b.ottoIcons, ottoIcons = _f === void 0 ? {} : _f;
    var filteredData = !!data && disallowedEmptyTextTypes.length >= 1
        ? filterStoryblokRichText(data, disallowedEmptyTextTypes)
        : data;
    if (isStoryblokRichText(filteredData)) {
        var result = react.renderRichText(filteredData, {
            schema: richTextSchema,
            resolver: createComponentResolver(Components, {
                additionalProps: { noFocus: noFocus },
                ottoIcons: ottoIcons
            })
        });
        return result == '<p></p>' ? '' : result;
    }
    return '';
};

var css$18 = {"statusBanner":"styles_statusBanner__Uac9s","icon-container":"styles_icon-container__vIhoE"};

var VIEWER_COUNTRY_KEY = 'viewerCountry';
var isCrawlerUserAgent = function () {
    var _a, _b;
    return /bot|crawler|spider|crawling/i.test((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : '');
};
var getCountryCodeFromCache = function () {
    var _a, _b;
    return (_b = (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(VIEWER_COUNTRY_KEY)) !== null && _b !== void 0 ? _b : null;
};
var getCountryCodeFromServer = function () {
    return fetch('/api/viewer-country', {
        method: 'GET'
    })
        .then(function (res) { return res.json(); }, function (error) {
        console.error(error);
        return null;
    })
        .then(function (response) {
        var _a;
        return (_a = response === null || response === void 0 ? void 0 : response.viewerCountry) !== null && _a !== void 0 ? _a : null;
    });
};
var getCountryCode = function () { return __awaiter(void 0, void 0, void 0, function () {
    var code, serverCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                code = getCountryCodeFromCache();
                if (!code) return [3 /*break*/, 1];
                return [2 /*return*/, code];
            case 1: return [4 /*yield*/, getCountryCodeFromServer()];
            case 2:
                serverCode = _a.sent();
                if (serverCode && window.sessionStorage) {
                    window.sessionStorage.setItem(VIEWER_COUNTRY_KEY, serverCode);
                }
                return [2 /*return*/, serverCode];
        }
    });
}); };

var StatusBanner = function (_a) {
    var ottoIcon = _a.ottoIcon, layout = _a.layout, defaultBody = _a.body, _b = _a.countryContent, countryContent = _b === void 0 ? [] : _b, rest = __rest(_a, ["ottoIcon", "layout", "body", "countryContent"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var countryContentMap = React.useMemo(function () {
        return new Map(countryContent.map(function (_a) {
            var country = _a.country, content = _a.content;
            return [
                country === null || country === void 0 ? void 0 : country.toLocaleLowerCase(),
                content
            ];
        }));
    }, [countryContent]);
    var _c = React.useState(countryContentMap.size === 0 ? defaultBody === null || defaultBody === void 0 ? void 0 : defaultBody.content : null), content = _c[0], setContent = _c[1];
    React.useEffect(function () {
        if (countryContentMap.size > 0 && !isCrawlerUserAgent()) {
            getCountryCode().then(function (code) {
                var _a, _b;
                var countryContentBlock = (_b = countryContentMap.get((_a = code === null || code === void 0 ? void 0 : code.toLocaleLowerCase()) !== null && _a !== void 0 ? _a : 'ZZ')) !== null && _b !== void 0 ? _b : null;
                var renderedContent = renderStoryblokRichText(countryContentBlock, {
                    ottoIcons: ottoIcons
                });
                setContent(renderedContent);
            });
        }
    }, [countryContentMap]);
    return content ? (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$18.statusBanner },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$18['icon-container']) }, isOttoIconBlock(ottoIcon) &&
                isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) && (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] })))),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement(Html, { html: content, className: "last-element-nospace" }))))) : null;
};

var css$17 = {"standard":"styles_standard__tzykN","standard-media-center-mobile":"styles_standard-media-center-mobile__BXQRo","standard-media-right-desktop":"styles_standard-media-right-desktop__gC3FO","standard-media-left-desktop":"styles_standard-media-left-desktop__bfogo","standard-media-center-desktop":"styles_standard-media-center-desktop__cZMk9","titleAboveMedia":"styles_titleAboveMedia__Km4xN","title":"styles_title__I84q9","subtitle":"styles_subtitle__y0iFs","body":"styles_body__LHQRq","list":"styles_list__PziT-","rounded":"styles_rounded__2G6HF","contentContainer":"styles_contentContainer__WmHt7","contentContainer-media-center-desktop":"styles_contentContainer-media-center-desktop__iR9--","contentContainer-media-center-desktop-reverse":"styles_contentContainer-media-center-desktop-reverse__zb5Ns","width-5":"styles_width-5__AzxVt","width-6":"styles_width-6__rwSaw","width-7":"styles_width-7__DFNFz","width-8":"styles_width-8__8gzqY","contentContainer-media-left-mobile":"styles_contentContainer-media-left-mobile__bJYC4","contentContainer-media-right-mobile":"styles_contentContainer-media-right-mobile__6JGOM","contentContainer-media-left-desktop":"styles_contentContainer-media-left-desktop__xBriz","contentContainer-media-right-desktop":"styles_contentContainer-media-right-desktop__H2b1D","mediaContainer":"styles_mediaContainer__cdsvz","videoContainer":"styles_videoContainer__z6EE6","roundedCorners":"styles_roundedCorners__9Lqo8","iframeContainer":"styles_iframeContainer__kKhSK","mediaContainer-full-width-mobile":"styles_mediaContainer-full-width-mobile__kz4j3","mediaContainer-media-left-mobile":"styles_mediaContainer-media-left-mobile__digiC","mediaContainer-media-right-mobile":"styles_mediaContainer-media-right-mobile__rY3w-","mediaContainer-media-left-desktop":"styles_mediaContainer-media-left-desktop__fUGau","mediaContainer-media-right-desktop":"styles_mediaContainer-media-right-desktop__Q1y3O","mediaContainer-media-center-desktop":"styles_mediaContainer-media-center-desktop__dhFKj","mediaContainer-media-center-mobile":"styles_mediaContainer-media-center-mobile__3tLq3","mediaContainer-media-center-mobile-reverse":"styles_mediaContainer-media-center-mobile-reverse__sEbly","mediaContainer-media-center-desktop-reverse":"styles_mediaContainer-media-center-desktop-reverse__KGl3O"};

var updateHtml = function (input, selectorUpdaterMap) {
    if (!input) {
        return input;
    }
    var updaters = Object.entries(selectorUpdaterMap);
    var document = htmlparser2.parseDocument(input);
    if (!document) {
        return input;
    }
    var _loop_1 = function (selector, updater) {
        cssSelect.selectAll(selector, document).forEach(function (element) {
            if (domhandler.isTag(element)) {
                var updated = updater(element);
                if (updated != null && updated != element) {
                    if (typeof updated === 'string') {
                        domutils.replaceElement(element, htmlparser2.parseDocument(updated));
                    }
                    else {
                        domutils.replaceElement(element, updated);
                    }
                }
            }
        });
    };
    for (var _i = 0, updaters_1 = updaters; _i < updaters_1.length; _i++) {
        var _a = updaters_1[_i], selector = _a[0], updater = _a[1];
        _loop_1(selector, updater);
    }
    return domSerializer.render(document, {
        emptyAttrs: false,
        selfClosingTags: true
    });
};

var css$16 = {"container":"styles_container__lNw-d","table":"styles_table__v9nLm","checkmarkIcon":"styles_checkmarkIcon__GldQR","crossIcon":"styles_crossIcon__isktC","striped":"styles_striped__gssA8","hover":"styles_hover__4Qwpw"};

var getContent = function (text) {
    switch (text) {
        case '[checkmark]':
            return (React__namespace.default.createElement("span", { "aria-label": "yes" },
                React__namespace.default.createElement(Svg, { className: css$16.checkmarkIcon, ariaHidden: true, name: 'Checkmark' })));
        case '[cross]':
            return (React__namespace.default.createElement("span", { "aria-label": "no" },
                React__namespace.default.createElement(Svg, { className: css$16.crossIcon, ariaHidden: true, name: 'Cross' })));
        default:
            return text;
    }
};
var Table = function (_a) {
    var content = _a.content, type = _a.type, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.tableHeadHidden, tableHeadHidden = _c === void 0 ? false : _c;
    return (React__namespace.default.createElement("div", { className: css$16.container },
        React__namespace.default.createElement("table", { className: classNames__default.default(css$16.table, css$16[type], className) },
            React__namespace.default.createElement("thead", { hidden: tableHeadHidden },
                React__namespace.default.createElement("tr", null, content &&
                    content.thead.map(function (th, index) { return (React__namespace.default.createElement("th", { key: index }, th.value)); }))),
            React__namespace.default.createElement("tbody", null, content &&
                content.tbody.map(function (tr) { return (React__namespace.default.createElement("tr", { key: tr._uid }, tr.body.map(function (td) { return (React__namespace.default.createElement("td", { key: td._uid, "aria-hidden": !td.value }, getContent(td.value))); }))); })))));
};

var css$15 = {"calloutBlock":"styles_calloutBlock__ArdkO"};

var _a$2, _b, _c;
var wrapTables = function (className) {
    var _a;
    return (_a = {},
        _a['table'] = function (table) {
            var _a;
            return new domhandler.Element('div', (_a = {}, _a['class'] = className, _a), [table]);
        },
        _a);
};
var setLinksHidden = (_a$2 = {},
    _a$2['a:not([tabindex])'] = function (anchorElem) {
        var _a;
        return new domhandler.Element('a', __assign(__assign({}, anchorElem.attribs), (_a = {}, _a['tabindex'] = '-1', _a['aria-hidden'] = 'true', _a)), domutils.getChildren(anchorElem));
    },
    _a$2);
(_b = {},
    _b['table'] = function (table) {
        var _a;
        return new domhandler.Element('div', (_a = {}, _a['class'] = 'table-responsive', _a), [table]);
    },
    _b);
var extractPx = function (value) {
    if (value.indexOf('px') >= 0 || /^\d+$/.test(value)) {
        return parseInt(value);
    }
    return false;
};
var getIframeAspectRatio = function (iframe) {
    var _a, _b;
    var height = extractPx((_a = domutils.getAttributeValue(iframe, 'height')) !== null && _a !== void 0 ? _a : '');
    var width = extractPx((_b = domutils.getAttributeValue(iframe, 'width')) !== null && _b !== void 0 ? _b : '');
    return height && width ? width / height : 1 / 0.5625;
};
(_c = {},
    _c['iframe'] = function (iframe) {
        var _a;
        return new domhandler.Element('div', (_a = {}, _a['style'] = "--aspect-ratio: ".concat(getIframeAspectRatio(iframe), ";"), _a), [iframe]);
    },
    _c);
var setLinkStyle = function (classNames) {
    var _a;
    return (_a = {},
        _a[[
            "a[href]",
            ":not(.styled-button)",
            ":not(.styled-link)",
            ":not(.btn)",
            ":not([class^=\"styles_\"])",
            ":not([class*=\" styles_\"])"
        ].join('')] = function (anchorElem) {
            var _a;
            return new domhandler.Element('a', __assign(__assign({}, anchorElem.attribs), (_a = {}, _a['class'] = classNames, _a)), domutils.getChildren(anchorElem));
        },
        _a);
};

var CalloutBlock = function (_a) {
    var body = _a.body, _b = _a.colorProfile, colorProfile = _b === void 0 ? 'info' : _b, _c = _a.transparentBackground, transparentBackground = _c === void 0 ? false : _c, _d = _a.layout, layout = _d === void 0 ? [] : _d, rest = __rest(_a, ["body", "colorProfile", "transparentBackground", "layout"]);
    var colorClasses = colorProfile in colors
        ? Object.values(getColorClasses(colorProfile)).filter(Boolean)
        : [colorProfile];
    var bodyHtml = body
        ? updateHtml(body.content, __assign({}, setLinkStyle('color-inherit text-underline')))
        : null;
    var calloutBlockMarkup = function () {
        return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default.apply(void 0, __spreadArray(__spreadArray([[css$15.calloutBlock]], colorClasses, false), [transparentBackground && 'bg-transparent'], false)) }, (!layout.length ? react.storyblokEditable(rest) : {})), bodyHtml && React__namespace.default.createElement(Html, { html: bodyHtml })));
    };
    if (layout.length)
        return (React__namespace.default.createElement(SectionLayout, __assign({}, layout[0], react.storyblokEditable(rest)), calloutBlockMarkup()));
    else
        return React__namespace.default.createElement(React__namespace.default.Fragment, null, calloutBlockMarkup());
};

var types = {
    primary: {
        classes: 'styled-button styled-button-primary'
    },
    secondary: {
        classes: 'styled-button styled-button-secondary'
    },
    'primary-floating': {
        classes: 'styled-button styled-button-primary-floating'
    },
    'secondary-floating': {
        classes: 'styled-button styled-button-secondary-floating'
    },
    'stand-alone': {
        classes: 'styled-link styled-link-alone'
    },
    'stand-alone-bullet': {
        classes: 'styled-link styled-link-bullet',
        icon: 'Circle'
    },
    'stand-alone-arrow': {
        classes: 'styled-link styled-link-arrow',
        icon: 'ArrowRight'
    }
};
var StyledLink = function (_a) {
    var _b, _c, _d;
    var url = _a.url, text = _a.text, type = _a.type, target = _a.target, trackingId = _a.trackingId, id = _a.id, ottoIcon = _a.ottoIcon, className = _a.className, noFocus = _a.noFocus;
    var icon = (_b = types[type]) === null || _b === void 0 ? void 0 : _b.icon;
    var ottoIcons = useOttoIcons().ottoIcons;
    var isValidOttoIcon = isOttoIconBlock(ottoIcon) &&
        isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]);
    return (React__namespace.default.createElement(Link, { url: url, id: id, className: classNames__default.default(types[type].classes, className), trackingId: trackingId, target: target, noFocus: noFocus },
        React__namespace.default.createElement("span", null, text),
        isValidOttoIcon ? (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0], { icon: ottoIcons[String((_c = ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0]) === null || _c === void 0 ? void 0 : _c.icon)], nonStandardSizeOverride: String((_d = ottoIcon === null || ottoIcon === void 0 ? void 0 : ottoIcon[0]) === null || _d === void 0 ? void 0 : _d.nonStandardSizeOverride) ||
                exports.OttoIconSizes.Small }))) : (icon && React__namespace.default.createElement(Svg, { className: "styled-link-icon", name: icon }))));
};

var FOOTNOTE_PATTERN = /\[\^[^[\]]+\]/;

var slugify = function (str) {
    return makeSlug__default.default(str, { lower: true, strict: true });
};

var getFootnoteProps = function (name) {
    if (!name) {
        return null;
    }
    var text = name.replace(/^\[\^?/, '').replace(/\]$/, '');
    if (!text) {
        return null;
    }
    var key = slugify(text);
    var refId = "fnref-".concat(key);
    var contentId = "fn-".concat(key);
    return { refId: refId, contentId: contentId, text: text };
};

var css$14 = {"ref":"styles_ref__oC-Qc","footnote":"styles_footnote__0Jtsi"};

var FootnoteRef = function (_a) {
    var name = _a.name;
    if (!name) {
        return null;
    }
    var props = getFootnoteProps(name);
    if (!props) {
        return null;
    }
    var contentId = props.contentId, refId = props.refId, text = props.text;
    var labelId = "".concat(refId, "-label");
    return (React__namespace.default.createElement("sup", { className: css$14.ref },
        React__namespace.default.createElement("a", { id: refId, href: "#".concat(contentId), rel: "footnote", "aria-labelledby": labelId, title: text },
            React__namespace.default.createElement("span", { id: labelId, className: "d-none", "aria-hidden": true }, text))));
};

var _a$1;
var replaceFootnoteRefInRichText = (_a$1 = {},
    _a$1['a:not(.styled-link):not(.styled-button)'] = function (el) {
        var text = domutils.textContent(el);
        if (text && FOOTNOTE_PATTERN.test(text)) {
            return ReactDOMServer__default.default.renderToStaticMarkup(React__namespace.default.createElement(FootnoteRef, { name: text }));
        }
        else {
            return el;
        }
    },
    _a$1);

function replaceReactString(input, pattern, render) {
    var result = [];
    if (!input) {
        result.push(input);
        return result;
    }
    if (!(pattern.source.startsWith('(') && pattern.source.endsWith(')'))) {
        pattern = new RegExp("(".concat(pattern.source, ")"), pattern.flags);
    }
    var parts = input.split(pattern);
    for (var i = 1; i < parts.length; i += 2) {
        result.push(parts[i - 1]);
        result.push(render(parts[i], i));
    }
    result.push(parts[parts.length - 1]);
    return result;
}

var replaceFootnoteRefInText = function (input) {
    return __spreadArray([], replaceReactString(input, FOOTNOTE_PATTERN, function (match, index) { return (React__namespace.default.createElement(FootnoteRef, { key: index, name: match })); }), true);
};

var css$13 = {"list":"styles_list__7ti-1","item":"styles_item__tiDLh","svgIcon":"styles_svgIcon__29ubT","mint-dark":"styles_mint-dark__Ssfun","salmon":"styles_salmon__XYMKC","text":"styles_text__ATqtl","ordered":"styles_ordered__xtreh"};

var List = function (_a) {
    var heading = _a.heading, listType = _a.listType, _b = _a.listItems, listItems = _b === void 0 ? [] : _b, className = _a.className;
    var ottoIcons = useOttoIcons().ottoIcons;
    var ListComponent = listType === 'ordered' ? 'ol' : 'ul';
    return (React__namespace.default.createElement(ListComponent, { className: classNames__default.default(css$13.list, css$13[listType], className) },
        heading && React__namespace.default.createElement("h3", { className: "mini-headline" }, heading),
        listItems.length > 0 &&
            listItems.map(function (_a) {
                var text = _a.text, ottoIcon = _a.ottoIcon, _uid = _a._uid;
                return (React__namespace.default.createElement("li", { key: _uid, className: classNames__default.default('default-text-block', css$13.item) },
                    isOttoIconBlock(ottoIcon) &&
                        isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) &&
                        listType === 'icon' && (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))),
                    text && (React__namespace.default.createElement("p", { className: css$13.text }, replaceFootnoteRefInText(text)))));
            })));
};

var css$12 = {"listCircle":"styles_listCircle__woMsA","fill":"styles_fill__4DgAG"};

var ListCircle = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'border' : _b, items = _a.items, rest = __rest(_a, ["type", "items"]);
    return (React__namespace.default.createElement("ol", __assign({ className: classNames__default.default(css$12.listCircle, css$12[type]) }, react.storyblokEditable(rest)), items.map(function (item, index) { return (React__namespace.default.createElement("li", { key: index }, item.text)); })));
};

var css$11 = {"table":"styles_table__kRUzH","bordered":"styles_bordered__lacQ-","striped":"styles_striped__TULJy","highlight-lilac":"styles_highlight-lilac__PLxmG","highlight-magnetic":"styles_highlight-magnetic__a52g5","hover":"styles_hover__bWFsl","table-responsive":"styles_table-responsive__WwFvI"};

var TableStandard = function (_a) {
    var _b;
    var _c, _d;
    var content = _a.content, type = _a.type, border = _a.border, highlightColor = _a.highlightColor;
    return (React__namespace.default.createElement("div", { className: css$11['table-responsive'] },
        React__namespace.default.createElement("table", { className: classNames__default.default(css$11.table, css$11[type], (_b = {},
                _b[css$11["highlight-".concat(highlightColor)]] = highlightColor,
                _b[css$11.bordered] = border,
                _b)) },
            React__namespace.default.createElement("thead", null,
                React__namespace.default.createElement("tr", null, (_c = content.thead) === null || _c === void 0 ? void 0 : _c.map(function (th, index) { return (React__namespace.default.createElement("th", { key: index }, th.value)); }))),
            React__namespace.default.createElement("tbody", null, (_d = content.tbody) === null || _d === void 0 ? void 0 : _d.map(function (tr) { return (React__namespace.default.createElement("tr", { key: tr._uid }, tr.body.map(function (td) { return (React__namespace.default.createElement("td", { key: td._uid }, td.value)); }))); })))));
};

var pascalCaseToKebabCase = function (str) {
    return str
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase();
};

var buildComponentsObject = function (components) {
    return Object.fromEntries(Object.entries(components).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [pascalCaseToKebabCase(k), v];
    }));
};

var Components$1 = buildComponentsObject({
    Link: Link,
    Table: Table,
    CalloutBlock: CalloutBlock,
    StyledLink: StyledLink,
    List: List,
    ListCircle: ListCircle,
    TableStandard: TableStandard
});

var css$10 = {"richtext":"styles_richtext__loLNP"};

var Richtext = function (_a) {
    var _b, _c;
    var body = _a.body, layout = _a.layout, textAlign = _a.textAlign, className = _a.className, noFocus = _a.noFocus, tableWrapperClassName = _a.tableWrapperClassName, rest = __rest(_a, ["body", "layout", "textAlign", "className", "noFocus", "tableWrapperClassName"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    var html = renderStoryblokRichText(body, { Components: Components$1, ottoIcons: ottoIcons });
    if (!html) {
        return React__namespace.default.createElement("div", null);
    }
    html = updateHtml(html, __assign(__assign(__assign(__assign({}, setLinkStyle('color-action-inline text-underline--hover text-underline--focus')), replaceFootnoteRefInRichText), wrapTables(tableWrapperClassName || 'table-responsive')), (noFocus ? setLinksHidden : {})));
    var hasContainerLayout = ((_b = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _b === void 0 ? void 0 : _b.component) === 'container-layout';
    var hasLegacyLayout = ((_c = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _c === void 0 ? void 0 : _c.component) === 'section-layout';
    return (React__namespace.default.createElement(ConditionalWrapper, { condition: isNonEmptyArray(layout), wrapper: function (children) {
            if (hasContainerLayout)
                return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)), children));
            else if (hasLegacyLayout) {
                return (React__namespace.default.createElement(SectionLayoutLegacy, __assign({}, layout[0], react.storyblokEditable(rest)), children));
            }
        } },
        React__namespace.default.createElement("div", __assign({ className: classNames__default.default('text-link-styling', [textAlign], hasLegacyLayout ? 'section-text-align' : '', css$10.richtext, className) }, (!isNonEmptyArray(layout)
            ? react.storyblokEditable(rest)
            : {})),
            React__namespace.default.createElement(Html, { html: html }))));
};

var css$$ = {"iframeContainer":"styles_iframeContainer__aCKX-","idle":"styles_idle__P4wqE","overlay":"styles_overlay__FczIo","hide":"styles_hide__kd1EM","thumbnail":"styles_thumbnail__hV8Kl","reveal":"styles_reveal__Tfc8F"};

var resizeVimeoThumbnail = function (thumbnailUrl, width) {
    var _a;
    if (!thumbnailUrl.match(/https:\/\/i.vimeocdn.com\/video\/[a-z0-9-]+_[0-9]+x[0-9]+/)) {
        return thumbnailUrl;
    }
    var extension = (_a = thumbnailUrl.match(/\.[^/.]+$/)) !== null && _a !== void 0 ? _a : '';
    var thumbnailUrlWithoutExtension = thumbnailUrl.replace(new RegExp(extension + '$'), '');
    return "".concat(thumbnailUrlWithoutExtension.replace(/_[0-9]+x[0-9]+$/, "_".concat(width, "x0"))).concat(extension);
};
var createVimeoVideoUrl = function (vimeoId, muted, autoplay) {
    var url = "https://player.vimeo.com/video/".concat(vimeoId, "?app_id=122963");
    var mutedArg = muted ? '&muted=1' : '';
    var autoplayArg = autoplay ? '&autoplay=1' : '';
    return "".concat(url).concat(autoplayArg).concat(mutedArg);
};
var createYoutubeThumbnailUrl = function (youtubeId) {
    return "https://i3.ytimg.com/vi/".concat(youtubeId, "/hqdefault.jpg");
};
var createYoutubeVideoUrl = function (youtubeId, autoplay) {
    return "https://www.youtube.com/embed/".concat(youtubeId).concat(autoplay ? '?autoplay=1' : '');
};

var aspectRatio = 0.5625;
var LazyloadIframeVimeo = function (_a) {
    var vimeoOembed = _a.vimeoOembed, title = _a.title, width = _a.width, _b = _a.muted, muted = _b === void 0 ? false : _b, props = __rest(_a, ["vimeoOembed", "title", "width", "muted"]);
    var autoplay = true;
    var iframeWidth = width || vimeoOembed.response.width;
    var url = createVimeoVideoUrl("".concat(vimeoOembed.response.video_id), muted, autoplay);
    var thumbnail = width
        ? resizeVimeoThumbnail(vimeoOembed.response.thumbnail_url, width)
        : vimeoOembed.response.thumbnail_url;
    aspectRatio = vimeoOembed.response.height / vimeoOembed.response.width;
    return (React__namespace.default.createElement(LazyloadIframe, __assign({ width: iframeWidth, aspectRatio: aspectRatio, thumbnail: thumbnail, url: url, title: title || vimeoOembed.response.title || '' }, props)));
};
var LazyloadIframeYoutube = function (_a) {
    var youtubeId = _a.youtubeId, width = _a.width, props = __rest(_a, ["youtubeId", "width"]);
    var autoplay = true;
    var url = createYoutubeVideoUrl(youtubeId, autoplay), thumbnail = createYoutubeThumbnailUrl(youtubeId);
    return (React__namespace.default.createElement(LazyloadIframe, __assign({ width: width, aspectRatio: aspectRatio, thumbnail: thumbnail, url: url }, props)));
};
var LazyloadIframe = function (_a) {
    var _b = _a.aspectRatio, aspectRatio = _b === void 0 ? 0.5625 : _b, thumbnail = _a.thumbnail, url = _a.url, title = _a.title, buttonLabel = _a.buttonLabel, width = _a.width;
    var _c = React.useState(false), isClicked = _c[0], setClicked = _c[1];
    var style = { '--aspect-ratio': 1 / aspectRatio };
    var wrapperRef = React.useRef(null);
    var _d = useIntersectionObserver(wrapperRef), isVisible = _d.isVisible, shouldReveal = _d.shouldReveal, setShouldReveal = _d.setShouldReveal;
    React.useEffect(function () {
        var _a, _b;
        if (isClicked) {
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'vimeoTrackerActivate' });
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
                event: 'video',
                eventCategory: 'video interacted',
                eventAction: 'Played video',
                eventLabel: title
            });
            setTimeout(function () { var _a; return (_a = document.getElementById("iframeId-".concat(url))) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
        }
    }, [isClicked]);
    React.useEffect(function () {
        if (isVisible) {
            var img = new Image();
            img.onload = function () { return setShouldReveal(true); };
            img.src = thumbnail;
        }
    }, [isVisible]);
    return (React__namespace.default.createElement("div", { style: style, className: classNames__default.default(css$$.iframeContainer, isClicked ? '' : css$$.idle), ref: wrapperRef },
        React__namespace.default.createElement("iframe", { "data-testid": "iframe", width: width, height: width * aspectRatio, src: isClicked ? url : '', frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: title, "aria-hidden": !isClicked, tabIndex: -1, id: "iframeId-".concat(url) }),
        !isClicked && (React__namespace.default.createElement("button", { className: classNames__default.default(css$$.overlay, 'focus-play-icon', isClicked ? css$$.hide : ''), onClick: function () { return setClicked(true); }, "aria-label": buttonLabel },
            React__namespace.default.createElement("img", { src: isVisible ? thumbnail : undefined, alt: title, id: "playbutton-iframeId-".concat(url), className: classNames__default.default(css$$.thumbnail, shouldReveal ? css$$.reveal : '') }),
            React__namespace.default.createElement(Svg, { name: 'PlayVideo', ariaHidden: true })))));
};

var VideoSource = function (_a) {
    var format = _a.format, url = _a.url, minBreakpoint = _a.minBreakpoint, maxBreakpoint = _a.maxBreakpoint;
    var query = constructQuery({
        minBreakpoint: minBreakpoint,
        maxBreakpoint: maxBreakpoint
    });
    var show = reactResponsive.useMediaQuery({ query: query });
    if (show) {
        return React__namespace.default.createElement("source", { src: url, type: format });
    }
    return null;
};

var _a;
var mediaQuery;
if (typeof window !== 'undefined') {
    mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-reduced-motion: reduce)');
}
var handleReduceMotionChanged = function (videoRef) {
    var _a, _b;
    var video = videoRef.current;
    if (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches)
        (_a = video === null || video === void 0 ? void 0 : video.pause) === null || _a === void 0 ? void 0 : _a.call(video);
    else
        (_b = video === null || video === void 0 ? void 0 : video.play) === null || _b === void 0 ? void 0 : _b.call(video);
};
var ResponsiveVideoSource = function (_a) {
    var responsiveSourceList = _a.responsiveSourceList, _editable = _a._editable;
    var videoRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (mediaQuery.matches)
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('autoplay');
        var mqEventHandler = function () { return handleReduceMotionChanged(videoRef); };
        mediaQuery.addEventListener('change', mqEventHandler);
        return function () { return mediaQuery.removeEventListener('change', mqEventHandler); };
    }, []);
    return ((isNonEmptyArray(responsiveSourceList) &&
        _editable &&
        validateBreakpointCollection(responsiveSourceList)) || (React__namespace.default.createElement("video", { autoPlay: true, loop: true, muted: true, playsInline: true, ref: videoRef }, responsiveSourceList.map(function (link) { return (React__namespace.default.createElement(VideoSource, __assign({}, link, { key: link._uid }))); }))));
};

var css$_ = {"pricingSectionItem":"styles_pricingSectionItem__XY3wH","imageContainer":"styles_imageContainer__3bi7w","contentContainer":"styles_contentContainer__Vlj0l","row":"styles_row__CmLm8","pricingColumn":"styles_pricingColumn__4Ol-a","total":"styles_total__No5q-","pos":"styles_pos__00GAY","cta":"styles_cta__bSz1P","disclaimer":"styles_disclaimer__rB15f","disclaimerRichtext":"styles_disclaimerRichtext__lppRt","image":"styles_image__-VDes"};

var PricingSectionItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var totalCostTitle = _a.totalCostTitle, totalCostSmallText = _a.totalCostSmallText, totalCost = _a.totalCost, firstTitle = _a.firstTitle, firstPrice = _a.firstPrice, secondTitle = _a.secondTitle, secondPrice = _a.secondPrice, thirdTitle = _a.thirdTitle, thirdPrice = _a.thirdPrice, fourthTitle = _a.fourthTitle, fourthPrice = _a.fourthPrice, cta = _a.cta, disclaimer = _a.disclaimer, disclaimerRichtext = _a.disclaimerRichtext, image = _a.image, className = _a.className, noFocus = _a.noFocus;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$_.pricingSectionItem, 'px-grid-margin', className) },
        React__namespace.default.createElement("div", { className: css$_.contentContainer },
            totalCostTitle && (React__namespace.default.createElement("div", { className: css$_.row },
                React__namespace.default.createElement("div", null,
                    React__namespace.default.createElement("h3", { className: 'small-headline' }, totalCostTitle)),
                React__namespace.default.createElement("div", { className: css$_.pricingColumn },
                    ((_b = totalCost === null || totalCost === void 0 ? void 0 : totalCost.product) === null || _b === void 0 ? void 0 : _b.price) && (React__namespace.default.createElement("div", { className: classNames__default.default(css$_.total, 'mega-text-block') },
                        pricing.getPrice(totalCost.location, totalCost.product.product),
                        React__namespace.default.createElement(FootnoteRef, { name: totalCost === null || totalCost === void 0 ? void 0 : totalCost.disclaimer }))),
                    totalCostSmallText && (React__namespace.default.createElement("div", { className: classNames__default.default(css$_.total, 'small-text-block') }, totalCostSmallText))))),
            firstTitle && (React__namespace.default.createElement("div", { className: css$_.row },
                React__namespace.default.createElement("div", null, firstTitle),
                ((_c = firstPrice === null || firstPrice === void 0 ? void 0 : firstPrice.product) === null || _c === void 0 ? void 0 : _c.price) && (React__namespace.default.createElement("div", { className: 'mini-headline' },
                    pricing.getPrice(firstPrice.location, firstPrice.product.product),
                    React__namespace.default.createElement(FootnoteRef, { name: firstPrice === null || firstPrice === void 0 ? void 0 : firstPrice.disclaimer }))))),
            secondTitle && (React__namespace.default.createElement("div", { className: css$_.row },
                React__namespace.default.createElement("div", null, secondTitle),
                ((_d = secondPrice === null || secondPrice === void 0 ? void 0 : secondPrice.product) === null || _d === void 0 ? void 0 : _d.price) && (React__namespace.default.createElement("div", { className: 'mini-headline' },
                    pricing.getPrice(secondPrice.location, secondPrice.product.product),
                    React__namespace.default.createElement(FootnoteRef, { name: secondPrice === null || secondPrice === void 0 ? void 0 : secondPrice.disclaimer }))))),
            thirdTitle && (React__namespace.default.createElement("div", { className: css$_.row },
                React__namespace.default.createElement("div", null, thirdTitle),
                ((_e = thirdPrice === null || thirdPrice === void 0 ? void 0 : thirdPrice.product) === null || _e === void 0 ? void 0 : _e.price) && (React__namespace.default.createElement("div", { className: 'mini-headline' },
                    pricing.getPrice(thirdPrice.location, thirdPrice.product.product),
                    React__namespace.default.createElement(FootnoteRef, { name: thirdPrice === null || thirdPrice === void 0 ? void 0 : thirdPrice.disclaimer }))))),
            fourthTitle && (React__namespace.default.createElement("div", { className: css$_.row },
                React__namespace.default.createElement("div", null, fourthTitle),
                ((_f = fourthPrice === null || fourthPrice === void 0 ? void 0 : fourthPrice.product) === null || _f === void 0 ? void 0 : _f.price) && (React__namespace.default.createElement("div", { className: 'mini-headline' },
                    pricing.getPrice(fourthPrice.location, fourthPrice.product.product),
                    React__namespace.default.createElement(FootnoteRef, { name: fourthPrice === null || fourthPrice === void 0 ? void 0 : fourthPrice.disclaimer }))))),
            cta && cta[0] && (React__namespace.default.createElement("div", { className: css$_.cta },
                React__namespace.default.createElement(StyledLink, __assign({}, cta[0], { className: css$_.cta, noFocus: noFocus })))),
            disclaimer && (React__namespace.default.createElement("div", { className: classNames__default.default(css$_.disclaimer, 'small-text-block') }, disclaimer)),
            disclaimerRichtext && (React__namespace.default.createElement("div", { className: classNames__default.default(css$_.disclaimer, css$_.disclaimerRichtext, 'small-text-block') },
                React__namespace.default.createElement(Richtext, { body: disclaimerRichtext })))),
        React__namespace.default.createElement("div", { className: css$_.imageContainer }, image && image.image && (React__namespace.default.createElement("div", { className: css$_.row },
            React__namespace.default.createElement(AdvanceImage, __assign({ className: css$_.image }, image, { src: image.image })))))));
};

var css$Z = {"accordionItem":"styles_accordionItem__5--zN","accordionButton":"styles_accordionButton__41xdl","subTitle":"styles_subTitle__Z4Ynx","title":"styles_title__FS-mT","open":"styles_open__-M8h4","content":"styles_content__yUbJF","richtextAccordion":"styles_richtextAccordion__P88K2","tableAccordion":"styles_tableAccordion__KDNCX"};

var contentComponents = {
    table: Table,
    richtext: Richtext,
    'pricing-section-item': PricingSectionItem
};
var AccordionItem = function (props) {
    var _a, _b, _c, _d;
    var _e;
    var title = props.title, subTitle = props.subTitle, ottoIcon = props.ottoIcon, content = props.content, _f = props.isItemOpen, isItemOpen = _f === void 0 ? false : _f, onItemOpen = props.onItemOpen, gtmEvent = props.gtmEvent, _g = props.classNameContent, classNameContent = _g === void 0 ? '' : _g, ottoIconDropdown = props.ottoIconDropdown, _uid = props._uid;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _h = React.useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var _j = React.useState('0px'), contentHeight = _j[0], setContentHeight = _j[1];
    var contentContainer = React.useRef(null);
    React.useEffect(function () {
        var _a;
        setContentHeight(isItemOpen ? "".concat((_a = contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px") : '0px');
        setIsOpen(isItemOpen);
    }, [isItemOpen]);
    var clickHandler = function () {
        var _a, _b;
        setContentHeight(!isOpen ? "".concat((_a = contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px") : '0px');
        setIsOpen(!isOpen);
        var _c = (gtmEvent === null || gtmEvent === void 0 ? void 0 : gtmEvent[0]) || {}, event = _c.event, eventCategory = _c.eventCategory, eventAction = _c.eventAction, eventLabel = _c.eventLabel;
        eventLabel &&
            ((_b = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
                event: event,
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: props[eventLabel] || eventLabel
            }));
        onItemOpen === null || onItemOpen === void 0 ? void 0 : onItemOpen(_uid || '');
    };
    var Component = ((_e = content[0]) === null || _e === void 0 ? void 0 : _e.component) && contentComponents[content[0].component];
    var itemId = "item".concat(_uid);
    var itemTitleId = "title".concat(_uid);
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$Z.accordionItem, 'focus-pp') },
        React__namespace.default.createElement(Button, { className: classNames__default.default(css$Z.accordionButton, (_a = {}, _a[css$Z.open] = isOpen, _a)), onPress: clickHandler, "aria-expanded": isOpen, "aria-controls": itemId },
            isOttoIconBlock(ottoIcon) &&
                isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) && (React__namespace.default.createElement("span", { className: classNames__default.default((_b = {}, _b[css$Z.subTitle] = subTitle, _b)) },
                React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] })))),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$Z.title, (_c = {}, _c[css$Z.subTitle] = subTitle, _c)) },
                React__namespace.default.createElement("p", { className: "mini-headline", id: itemTitleId }, title),
                subTitle && React__namespace.default.createElement("p", null, subTitle)),
            React__namespace.default.createElement(OttoIcon, { icon: ottoIcons[String(ottoIconDropdown)] })),
        Component && (React__namespace.default.createElement("div", { className: classNames__default.default(css$Z.content), ref: contentContainer, style: { maxHeight: contentHeight }, "data-testid": "accordion-content", id: itemId, "aria-hidden": !isOpen, "aria-labelledby": itemTitleId, role: 'region' },
            React__namespace.default.createElement(Component, __assign({}, content[0], { tableHeadHidden: true, className: classNames__default.default(classNameContent, (_d = {},
                    _d[css$Z.richtextAccordion] = content[0].component === 'richtext',
                    _d[css$Z.tableAccordion] = content[0].component === 'table',
                    _d)), noFocus: !isOpen }))))));
};

var css$Y = {"accordion":"styles_accordion__e87Bx","transparent":"styles_transparent__PhFup","heading":"styles_heading__CUkMN","overrideSectionPadding":"styles_overrideSectionPadding__sy2-J"};

var makeStructuredData$1 = function (_a) {
    var items = _a.items;
    return ({
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        mainEntity: isNonEmptyArray(items)
            ? items
                .filter(function (_a) {
                var title = _a.title, body = _a.body;
                return title && body && renderStoryblokRichText(body);
            })
                .map(function (_a) {
                var title = _a.title, body = _a.body;
                return ({
                    '@type': 'Question',
                    name: title,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: renderStoryblokRichText(body)
                    }
                });
            })
            : undefined
    });
};
var FaqStructuredData = React.memo(function (props) { return (React__namespace.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
        __html: "\n      ".concat(JSON.stringify(makeStructuredData$1(props), undefined, 2).replace(/\n/g, "\n      "), "\n      ")
    } })); });

var transformAccordionItemPropsToFaqItem = function (items) {
    return items.map(function (_a) {
        var _b;
        var title = _a.title, content = _a.content;
        return ({
            title: title,
            body: (_b = content[0]) === null || _b === void 0 ? void 0 : _b.body
        });
    });
};
var Accordion = function (_a) {
    var _b, _c;
    var _d, _e;
    var heading = _a.heading, _f = _a.items, items = _f === void 0 ? [] : _f, layout = _a.layout, headingAlign = _a.headingAlign, _g = _a.openedItemID, openedItemID = _g === void 0 ? '' : _g, onItemOpen = _a.onItemOpen, _h = _a.variant, variant = _h === void 0 ? '' : _h, _j = _a.classNameContent, classNameContent = _j === void 0 ? '' : _j, ottoIconDropdown = _a.ottoIconDropdown, enableFaqStructuredData = _a.enableFaqStructuredData, rest = __rest(_a, ["heading", "items", "layout", "headingAlign", "openedItemID", "onItemOpen", "variant", "classNameContent", "ottoIconDropdown", "enableFaqStructuredData"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        heading && (React__namespace.default.createElement("h2", { className: classNames__default.default('default-headline', css$Y.heading, [headingAlign], (_b = {},
                _b[css$Y.overrideSectionPadding] = (_d = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _d === void 0 ? void 0 : _d.overrideSectionPadding,
                _b)) }, heading)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$Y.accordion, css$Y[variant], (_c = {},
                _c[css$Y.overrideSectionPadding] = (_e = layout === null || layout === void 0 ? void 0 : layout[0]) === null || _e === void 0 ? void 0 : _e.overrideSectionPadding,
                _c)) }, items.length > 0 &&
            items.map(function (_a) {
                var _uid = _a._uid, data = __rest(_a, ["_uid"]);
                return (React__namespace.default.createElement(AccordionItem, __assign({ key: _uid, _uid: _uid, isItemOpen: openedItemID === _uid, onItemOpen: onItemOpen }, data, { classNameContent: classNameContent, ottoIconDropdown: ottoIconDropdown })));
            })),
        enableFaqStructuredData ? (React__namespace.default.createElement(FaqStructuredData, { items: transformAccordionItemPropsToFaqItem(items) })) : ('')));
};

var css$X = {"transcript":"styles_transcript__GVZ-2","richtextFixedPadding":"styles_richtextFixedPadding__8HVCv"};

var Transcript = function (_a) {
    var _b, _c;
    var transcript = _a.transcript, manualTitle = _a.manualTitle;
    return ((_c = (_b = transcript === null || transcript === void 0 ? void 0 : transcript[0]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c[0]) ? (React__namespace.default.createElement("div", { className: css$X.transcript },
        React__namespace.default.createElement(Accordion, __assign({}, __assign(__assign({}, transcript[0]), { items: [
                __assign(__assign({}, transcript[0].items[0]), { subTitle: transcript[0].items[0].subTitle || manualTitle })
            ], classNameContent: css$X.richtextFixedPadding }), { layout: [
                __assign(__assign({}, transcript[0].layout[0]), { paddingTop: 'none', paddingBottom: 'none' })
            ], headingAlign: "text-left" })))) : null;
};

var VideoContainer = function (_a) {
    var _b, _c;
    var source = _a.source, playButtonLabel = _a.playButtonLabel, manualTitle = _a.manualTitle, maxWidth = _a.maxWidth, transcript = _a.transcript, _editable = _a._editable;
    var sourceType = (_b = source === null || source === void 0 ? void 0 : source[0]) === null || _b === void 0 ? void 0 : _b.component;
    var videoComponent;
    switch (sourceType) {
        case 'youtube':
            videoComponent = (React__namespace.default.createElement(LazyloadIframeYoutube, { youtubeId: source[0].youtubeId, title: manualTitle || '', buttonLabel: playButtonLabel, width: maxWidth || 650 }));
            break;
        case 'vimeo':
            videoComponent = (React__namespace.default.createElement(LazyloadIframeVimeo, { vimeoOembed: source[0].settings.vimeo_oembed, title: manualTitle ||
                    ((_c = source[0].settings.vimeo_oembed) === null || _c === void 0 ? void 0 : _c.response.title) ||
                    '', width: maxWidth || 650, buttonLabel: playButtonLabel, muted: true }));
            break;
        case 'video-source':
            videoComponent = (React__namespace.default.createElement(ResponsiveVideoSource, { responsiveSourceList: source, _editable: _editable }));
            break;
        default:
            videoComponent = null;
            break;
    }
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        videoComponent,
        React__namespace.default.createElement(Transcript, { transcript: transcript, manualTitle: manualTitle })));
};

var Media$1 = function (_a) {
    var _b, _c;
    var vimeo = _a.vimeo, youtube = _a.youtube, videoContainer = _a.videoContainer, titleAboveMedia = _a.titleAboveMedia, className = _a.className, classNameHeadline = _a.classNameHeadline, image = _a.image, setHeight = _a.setHeight;
    var hasImage = checkImage((_b = image[0]) === null || _b === void 0 ? void 0 : _b.asset);
    var hasImageResizing = !!((_c = image[0]) === null || _c === void 0 ? void 0 : _c.cropAlignment);
    var getMedia = function () {
        if (videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) {
            return React__namespace.default.createElement(VideoContainer, __assign({}, videoContainer[0]));
        }
        else if (vimeo && vimeo.vimeo_oembed) {
            return (React__namespace.default.createElement("div", { className: css$17.videoContainer },
                React__namespace.default.createElement(LazyloadIframeVimeo, { vimeoOembed: vimeo.vimeo_oembed, width: 650, muted: true })));
        }
        else if (youtube) {
            return (React__namespace.default.createElement("div", { className: css$17.videoContainer },
                React__namespace.default.createElement(LazyloadIframeYoutube, { youtubeId: youtube, title: '', width: 650 })));
        }
        else if (hasImage && hasImageResizing) {
            return (validateBreakpointCollection(image) || (React__namespace.default.createElement(React__namespace.default.Fragment, null, image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({}, imgResized, { key: imgResized._uid + String(index) }))); }))));
        }
        else if (hasImage) {
            return React__namespace.default.createElement(AdvanceImage, __assign({}, image[0].asset, { src: image[0].asset.image }));
        }
        return null;
    };
    var mediaRef = React.createRef();
    reactUse.useIsomorphicLayoutEffect(function () {
        mediaRef.current && setHeight(mediaRef.current.clientHeight);
    }, []);
    var media = getMedia();
    return media ? (React__namespace.default.createElement("div", { className: className, ref: mediaRef },
        titleAboveMedia && (React__namespace.default.createElement(Richtext, { body: titleAboveMedia, className: classNameHeadline })),
        media)) : null;
};

var AccessibilityRender = function (_a) {
    var elementsOrder = _a.elementsOrder, elements = _a.elements, _b = _a.tabletBreakpoint, tabletBreakpoint = _b === void 0 ? 'm1' : _b, _c = _a.desktopBreakpoint, desktopBreakpoint = _c === void 0 ? 'lg' : _c;
    var _d = React.useState([]), renderOrder = _d[0], setRenderOrder = _d[1];
    var isTablet = reactResponsive.useMediaQuery({
        minWidth: breakpoints[tabletBreakpoint],
        maxWidth: breakpoints[desktopBreakpoint]
    });
    var isDesktop = reactResponsive.useMediaQuery({
        minWidth: breakpoints[desktopBreakpoint]
    });
    var getRenderOrder = function () {
        if (isDesktop) {
            return elementsOrder.desktop;
        }
        else if (isTablet) {
            return elementsOrder.tablet;
        }
        else {
            return elementsOrder.mobile;
        }
    };
    reactUse.useDeepCompareEffect(function () {
        setRenderOrder(getRenderOrder());
    }, [elementsOrder, isDesktop, isTablet]);
    return renderOrder.map(function (elementName) { return (React__namespace.default.createElement(React__namespace.default.Fragment, { key: elementName }, elements[elementName])); });
};

var StandardModule = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g;
    var title = _a.title, subtitle = _a.subtitle, body = _a.body, list = _a.list, cta = _a.cta, image = _a.image, videoContainer = _a.videoContainer, vimeo = _a.vimeo, youtube = _a.youtube, mediaPositionMobile = _a.mediaPositionMobile, mediaPositionDesktop = _a.mediaPositionDesktop, roundedBackground = _a.roundedBackground, roundedCorners = _a.roundedCorners, titleAboveMedia = _a.titleAboveMedia, mediaWidth = _a.mediaWidth, textAlign = _a.textAlign, _h = _a.layout, layout = _h === void 0 ? [] : _h, rest = __rest(_a, ["title", "subtitle", "body", "list", "cta", "image", "videoContainer", "vimeo", "youtube", "mediaPositionMobile", "mediaPositionDesktop", "roundedBackground", "roundedCorners", "titleAboveMedia", "mediaWidth", "textAlign", "layout"]);
    var roundedBackgroundColor = '';
    if (roundedBackground && layout[0]) {
        roundedBackgroundColor = layout[0].backgroundColor;
        layout[0].backgroundColor = '';
    }
    var _j = React.useState(480), mediaHeight = _j[0], setMediaHeight = _j[1];
    var isDesktop = reactResponsive.useMediaQuery({
        minWidth: breakpoints['m2']
    });
    var mediaProps = {
        vimeo: vimeo,
        youtube: youtube,
        videoContainer: videoContainer,
        titleAboveMedia: titleAboveMedia,
        classNameHeadline: classNames__default.default('default-headline', css$17.titleAboveMedia, textAlign),
        className: classNames__default.default(css$17.mediaContainer, css$17["mediaContainer-".concat(mediaPositionMobile)], css$17["mediaContainer-".concat(mediaPositionDesktop)], css$17[mediaWidth], (_b = {},
            _b[css$17.roundedCorners] = roundedCorners,
            _b[css$17['mediaContainer-media-center-mobile']] = mediaPositionMobile === 'media-center-mobile-reverse',
            _b[css$17['mediaContainer-media-center-desktop']] = mediaPositionDesktop === 'media-center-desktop-reverse',
            _b[css$17['mediaContainer-full-width-mobile']] = (_e = (_d = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _d === void 0 ? void 0 : _d.transcript) === null || _e === void 0 ? void 0 : _e[0],
            _b)),
        image: image,
        setHeight: setMediaHeight
    };
    var elementsOrder = { mobile: [], tablet: [], desktop: [] };
    switch (mediaPositionMobile) {
        case 'media-center-mobile-reverse':
            elementsOrder.mobile = elementsOrder.tablet = ['content', 'media'];
            break;
        default:
            elementsOrder.mobile = elementsOrder.tablet = ['media', 'content'];
            break;
    }
    switch (mediaPositionDesktop) {
        case 'media-center-desktop-reverse':
            elementsOrder.desktop = ['content', 'media'];
            break;
        case 'media-right-desktop':
            elementsOrder.desktop = ['content', 'media'];
            break;
        case 'media-left-desktop':
            elementsOrder.desktop = ['media', 'content'];
            break;
        case 'media-center-desktop':
            elementsOrder.desktop = ['media', 'content'];
            break;
    }
    var mediaElement = React__namespace.default.createElement(Media$1, __assign({}, mediaProps));
    var contentElement = (React__namespace.default.createElement("div", __assign({ className: classNames__default.default(css$17.contentContainer, css$17["contentContainer-".concat(mediaPositionMobile)], css$17["contentContainer-".concat(mediaPositionDesktop)], textAlign, css$17[mediaWidth]) }, (isDesktop && mediaPositionDesktop !== 'media-center-desktop'
        ? {
            style: {
                minHeight: mediaHeight - (((_g = (_f = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]) === null || _f === void 0 ? void 0 : _f.transcript) === null || _g === void 0 ? void 0 : _g[0]) ? 100 : 0)
            }
        }
        : undefined)),
        title && (React__namespace.default.createElement(Richtext, { body: title, className: classNames__default.default('default-headline', css$17.title) })),
        subtitle && (React__namespace.default.createElement(Richtext, { body: subtitle, className: classNames__default.default('large-text-block', css$17.subtitle) })),
        body && React__namespace.default.createElement(Richtext, { body: body, className: css$17.body }),
        list[0] && React__namespace.default.createElement(List, __assign({}, list[0], { className: css$17.list })),
        cta[0] && React__namespace.default.createElement(StyledLink, __assign({}, cta[0]))));
    var standardModuleElements = {
        media: mediaElement,
        content: contentElement
    };
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$17.standard, css$17["standard-".concat(mediaPositionMobile)], css$17["standard-".concat(mediaPositionDesktop)], (_c = {},
                _c[css$17['standard-media-center-mobile']] = mediaPositionMobile === 'media-center-mobile-reverse',
                _c[css$17['standard-media-center-desktop']] = mediaPositionDesktop === 'media-center-desktop-reverse',
                _c[roundedBackgroundColor] = roundedBackground,
                _c[css$17.rounded] = roundedBackground,
                _c)) },
            React__namespace.default.createElement(AccessibilityRender, { elementsOrder: elementsOrder, elements: standardModuleElements, desktopBreakpoint: "m2" }))));
};

var css$W = {"cardWrapper":"styles_cardWrapper__QRcqQ","cards-2":"styles_cards-2__htXzZ","miniCardWrapper":"styles_miniCardWrapper__vV07v","cards-4":"styles_cards-4__UISbT","cards-3":"styles_cards-3__WL-ol","cards-1":"styles_cards-1__GJlZM","largeCard":"styles_largeCard__4-gx2","largeCards-1":"styles_largeCards-1__xVN5t","largeCards-2":"styles_largeCards-2__mhiT-","card":"styles_card__9xBJ1","miniCard":"styles_miniCard__j-IKg","content":"styles_content__4ZtUo","iconArrow":"styles_iconArrow__Jcf6Q","headlineContainer":"styles_headlineContainer__9GWwa","imageContainer":"styles_imageContainer__oDIyD","fullWidth":"styles_fullWidth__LVlIC","magnetic":"styles_magnetic__QTXV-","title":"styles_title__Biyff","cardContent":"styles_cardContent__eLKJW","noMedia":"styles_noMedia__FZ4a1","textColor-white":"styles_textColor-white__yWbg7","textColor-dark":"styles_textColor-dark__zf1Qm","icon-headline-color":"styles_icon-headline-color__6NZLd","cards-2-large-1":"styles_cards-2-large-1__TzALx","cards-2-large-2":"styles_cards-2-large-2__pitsf","mediaLeft":"styles_mediaLeft__t88Ln","image":"styles_image__14dsS","cards-1-large-1":"styles_cards-1-large-1__BH8-t","cards-3-large-1":"styles_cards-3-large-1__48g5p","imageBackground":"styles_imageBackground__Tv-iD","infoInsideCard":"styles_infoInsideCard__B2myd"};

var css$V = {"content":"styles_content__SoWQ5","infoInsideCard":"styles_infoInsideCard__OIuU7","miniCard":"styles_miniCard__LVVF4","title":"styles_title__MgmxE","text":"styles_text__RG4Nb","list":"styles_list__PezGT","link":"styles_link__TQFBq"};

var Info = function (_a) {
    var _b;
    var infoTitle = _a.infoTitle, link = _a.link, list = _a.list, miniCard = _a.miniCard, infoInsideCard = _a.infoInsideCard, text = _a.text, richtext = _a.richtext;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$V.content, (_b = {},
            _b[css$V.miniCard] = miniCard,
            _b[css$V.infoInsideCard] = infoInsideCard,
            _b)) },
        infoTitle && (React__namespace.default.createElement("h2", { className: classNames__default.default(css$V.title, 'mini-headline') }, infoTitle)),
        text && (React__namespace.default.createElement("p", { className: classNames__default.default(css$V.text, 'default-text-block') }, replaceFootnoteRefInText(text))),
        richtext && React__namespace.default.createElement(Richtext, { body: richtext }),
        list[0] && (React__namespace.default.createElement("div", { className: css$V.list },
            React__namespace.default.createElement(List, __assign({}, list[0])))),
        link.length > 0 && React__namespace.default.createElement(StyledLink, __assign({ className: css$V.link }, link[0]))));
};

var StandardCard = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j, _k;
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, fullWidthImage = _a.fullWidthImage, image = _a.image, infoTitle = _a.infoTitle, largeCard = _a.largeCard, link = _a.link, list = _a.list, mediaPosition = _a.mediaPosition, miniCard = _a.miniCard, infoInsideCard = _a.infoInsideCard, numberOfCards = _a.numberOfCards, numberOfLargeCards = _a.numberOfLargeCards, text = _a.text, richtext = _a.richtext, textColor = _a.textColor, title = _a.title, url = _a.url, rest = __rest(_a, ["backgroundColor", "backgroundImage", "fullWidthImage", "image", "infoTitle", "largeCard", "link", "list", "mediaPosition", "miniCard", "infoInsideCard", "numberOfCards", "numberOfLargeCards", "text", "richtext", "textColor", "title", "url"]);
    var hasBackgroundImage = checkImage(backgroundImage);
    var hasImage = checkImage((_j = image[0]) === null || _j === void 0 ? void 0 : _j.asset);
    var hasImageResizing = !!((_k = image[0]) === null || _k === void 0 ? void 0 : _k.cropAlignment);
    var hasInfoContent = infoTitle.length > 0 ||
        text.length > 0 ||
        list.length > 0 ||
        link.length > 0;
    var hasInfoOutsideCard = hasInfoContent && !infoInsideCard;
    var hasInfoInsideCard = hasInfoContent && infoInsideCard;
    return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default('focus-pp', css$W.cardWrapper, css$W["cards-".concat(numberOfCards)], css$W["largeCards-".concat(numberOfLargeCards)], (_b = {},
            _b[css$W.largeCard] = largeCard,
            _b[css$W.miniCardWrapper] = miniCard && numberOfCards !== 1,
            _b)) }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$W.card, [backgroundColor], css$W["cards-".concat(numberOfCards)], (_c = {},
                _c[css$W.miniCard] = miniCard && numberOfCards !== 1,
                _c[css$W.infoInsideCard] = infoInsideCard,
                _c[css$W.standardCard] = !largeCard,
                _c[css$W.largeCard] = largeCard && numberOfCards !== 4,
                _c[css$W.noMedia] = !hasImage && !hasBackgroundImage,
                _c)) },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$W.cardContent, css$W["cards-".concat(numberOfCards, "-large-").concat(numberOfLargeCards)], (_d = {},
                    _d[css$W.largeCard] = largeCard && numberOfCards !== 4,
                    _d[css$W.noMedia] = !hasImage && !hasBackgroundImage,
                    _d[css$W["textColor-".concat(textColor)]] = hasBackgroundImage,
                    _d)) },
                React__namespace.default.createElement(ConditionalWrapper, { condition: hasBackgroundImage, wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: (backgroundImage && backgroundImage.image) || '', base64: backgroundImage && backgroundImage.base64, quality: 90, loading: "lazy", className: css$W.imageBackground }, children)); } },
                    React__namespace.default.createElement(Link, { url: url },
                        React__namespace.default.createElement("div", { className: classNames__default.default(css$W.content, (_e = {},
                                _e[css$W.mediaLeft] = mediaPosition === 'left',
                                _e)) },
                            React__namespace.default.createElement("div", { className: classNames__default.default(css$W.headlineContainer, (_f = {},
                                    _f[css$W.whiteText] = hasBackgroundImage,
                                    _f)) },
                                React__namespace.default.createElement("h2", { className: classNames__default.default(css$W.title) }, title),
                                React__namespace.default.createElement(Svg, { className: classNames__default.default('icon-headline-color', css$W.iconArrow, (_g = {},
                                        _g[css$W.magnetic] = backgroundColor === 'white',
                                        _g)), name: 'ArrowRightOtto' })),
                            hasInfoInsideCard && (React__namespace.default.createElement(Info, { infoTitle: infoTitle, link: link, list: list, miniCard: miniCard, infoInsideCard: infoInsideCard, text: text, richtext: richtext })),
                            hasImage && (React__namespace.default.createElement("div", { className: classNames__default.default(css$W.imageContainer, (_h = {},
                                    _h[css$W.fullWidth] = fullWidthImage,
                                    _h[css$W.mediaLeft] = mediaPosition === 'left',
                                    _h)) }, hasImageResizing ? (validateBreakpointCollection(image) ||
                                image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({ className: css$W.image }, imgResized, { key: imgResized._uid + String(index) }))); })) : (React__namespace.default.createElement(AdvanceImage, __assign({ className: css$W.image }, image[0].asset, { src: image[0].asset.image, key: image[0].asset.image })))))))))),
        React__namespace.default.createElement("div", null, hasInfoOutsideCard && (React__namespace.default.createElement(Info, { infoTitle: infoTitle, link: link, list: list, miniCard: miniCard, infoInsideCard: infoInsideCard, text: text, richtext: richtext })))));
};

var css$U = {"cardGroup":"styles_cardGroup__mS5x0","miniCards":"styles_miniCards__l6cCs","cards-3":"styles_cards-3__-IDyz"};

var StandardCardGroup = function (_a) {
    var _b;
    var _c = _a.cards, cards = _c === void 0 ? [] : _c, layout = _a.layout, miniCards = _a.miniCards, infoInsideCard = _a.infoInsideCard, rest = __rest(_a, ["cards", "layout", "miniCards", "infoInsideCard"]);
    var isAllowedLargeCardConfiguration = function (index) {
        if (index === 0 && cards.length === 3 && cards[2].largeCard) {
            return false;
        }
        if (index === 1 && cards.length === 3) {
            return false;
        }
        return true;
    };
    var getNumberOfLargeCards = function () {
        var largeCards = 0;
        cards.map(function (card, index) {
            return card.largeCard && isAllowedLargeCardConfiguration(index) && largeCards++;
        });
        return largeCards;
    };
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$U.cardGroup, css$U["cards-".concat(cards.length)], (_b = {},
                _b[css$U.miniCards] = miniCards,
                _b)) }, cards.map(function (card, index) { return (React__namespace.default.createElement(StandardCard, __assign({}, card, { largeCard: card.largeCard && isAllowedLargeCardConfiguration(index), miniCard: miniCards, infoInsideCard: infoInsideCard, numberOfCards: cards.length, numberOfLargeCards: getNumberOfLargeCards(), key: card._uid }))); }))));
};

var css$T = {"column":"styles_column__sIwX6","icon":"styles_icon__iRUnw","flag":"styles_flag__fZnP9","deprecated":"styles_deprecated__wbz5C","textContainer":"styles_textContainer__OTxQN","noIcon":"styles_noIcon__0sbEP","large":"styles_large__fXFTx","withHeading":"styles_withHeading__B7eOy","center":"styles_center__zANrR","withIllustration":"styles_withIllustration__Avuds","illustration":"styles_illustration__9FILe","withImage":"styles_withImage__GZm2l","nrColumns2":"styles_nrColumns2__NcnFT","nrColumns4":"styles_nrColumns4__NI2bs"};

var TextGridItem = function (_a) {
    var _b, _c;
    var heading = _a.heading, icon = _a.icon, ottoIcon = _a.ottoIcon, iconSize = _a.iconSize, flag = _a.flag, text = _a.text, illustration = _a.illustration, _d = _a.center, center = _d === void 0 ? false : _d, _e = _a.withImage, withImage = _e === void 0 ? false : _e, _f = _a.nrColumns, nrColumns = _f === void 0 ? 0 : _f;
    var ottoIcons = useOttoIcons().ottoIcons;
    var renderVisual = function () {
        if (illustration === null || illustration === void 0 ? void 0 : illustration.image) {
            return (React__namespace.default.createElement(Img, __assign({ className: css$T.illustration }, illustration, { src: illustration.image, key: illustration._uid })));
        }
        else if (flag) {
            return (React__namespace.default.createElement(Svg, { name: flag, className: classNames__default.default(css$T.icon, css$T.flag) }));
        }
        else if (isOttoIconBlock(ottoIcon) &&
            isOttoIconData(ottoIcons[String(ottoIcon[0].icon)])) {
            return (React__namespace.default.createElement("span", { className: css$T.icon },
                React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))));
        }
        return null;
    };
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$T.column, css$T["nrColumns".concat(nrColumns)], css$T[iconSize], (_b = {},
            _b[css$T.withHeading] = heading === null || heading === void 0 ? void 0 : heading.length,
            _b[css$T.center] = center,
            _b[css$T.withIllustration] = illustration === null || illustration === void 0 ? void 0 : illustration.image,
            _b[css$T.withImage] = withImage,
            _b)) },
        renderVisual(),
        React__namespace.default.createElement("div", { className: css$T.textContainer },
            heading && (React__namespace.default.createElement("h3", { className: classNames__default.default('small-headline', (_c = {}, _c[css$T.noIcon] = !icon, _c)) }, heading)),
            React__namespace.default.createElement(Richtext, { body: text, className: classNames__default.default(css$T.richtext) }))));
};

var css$S = {"container":"styles_container__KdnYc","gridWidth":"styles_gridWidth__XLl-V","topContainer":"styles_topContainer__cvVDv","heading":"styles_heading__DYK3E","topLink":"styles_topLink__BQauB","bottomLink":"styles_bottomLink__sc59D","center":"styles_center__ubSy8","withIllustrations":"styles_withIllustrations__Bwhwq","withImage":"styles_withImage__BtNVh","imageContainer":"styles_imageContainer__lVdjt","columns":"styles_columns__nG19k","image":"styles_image__isSgW","noTopPadding":"styles_noTopPadding__ctN5x"};

var TextGrid = function (_a) {
    var _b;
    var _c, _d;
    var heading = _a.heading, link = _a.link, image = _a.image, enableImage = _a.enableImage, _e = _a.textGridItems, textGridItems = _e === void 0 ? [] : _e, layout = _a.layout, iconSize = _a.iconSize, alignment = _a.alignment, backgroundColor = _a.backgroundColor, noTopPadding = _a.noTopPadding, rest = __rest(_a, ["heading", "link", "image", "enableImage", "textGridItems", "layout", "iconSize", "alignment", "backgroundColor", "noTopPadding"]);
    var gridProfile = (layout[0] || {}).gridProfile;
    var centerAlign = alignment === 'center';
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement(ConditionalWrapper, { condition: enableImage, wrapper: function (children) {
                var _a;
                return (React__namespace.default.createElement("div", { className: css$S.withImage },
                    React__namespace.default.createElement("div", { className: classNames__default.default(css$S.imageContainer, [backgroundColor], (_a = {},
                            _a[css$S.withImage] = enableImage,
                            _a)) },
                        React__namespace.default.createElement(Img, __assign({ className: css$S.image }, image, { src: image === null || image === void 0 ? void 0 : image.image, key: image === null || image === void 0 ? void 0 : image._uid }))),
                    children));
            } },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$S.container, [backgroundColor], (_b = {},
                    _b['px-grid-margin'] = gridProfile === 'full-width-no-margins',
                    _b[css$S.gridWidth] = gridProfile === 'full-width-with-margins',
                    _b[css$S.center] = centerAlign,
                    _b[css$S.withIllustrations] = (_d = (_c = textGridItems === null || textGridItems === void 0 ? void 0 : textGridItems[0]) === null || _c === void 0 ? void 0 : _c.illustration) === null || _d === void 0 ? void 0 : _d.image,
                    _b[css$S.noTopPadding] = noTopPadding,
                    _b)) },
                React__namespace.default.createElement("div", { className: css$S.topContainer },
                    heading && React__namespace.default.createElement(Richtext, { body: heading, className: css$S.heading }),
                    link[0] && React__namespace.default.createElement(StyledLink, __assign({}, link[0], { className: css$S.topLink }))),
                React__namespace.default.createElement("div", { className: css$S.columns }, textGridItems.length > 0 &&
                    textGridItems.map(function (_a) {
                        var _uid = _a._uid, item = __rest(_a, ["_uid"]);
                        return (React__namespace.default.createElement(TextGridItem, __assign({ key: _uid }, item, { center: centerAlign, withImage: enableImage, nrColumns: textGridItems.length, iconSize: iconSize })));
                    })),
                link[0] && React__namespace.default.createElement(StyledLink, __assign({}, link[0], { className: css$S.bottomLink }))))));
};

var css$R = {"cookieSettingWrapper":"styles_cookieSettingWrapper__xIdpD"};

var OnetrustCookieSettings = function (_a) {
    var settingsButton = _a.settingsButton, layout = _a.layout;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
        React__namespace.default.createElement("div", { className: css$R.cookieSettingWrapper },
            React__namespace.default.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings" }, settingsButton[0] && settingsButton[0].text))));
};

var css$Q = {"cookieListWrapper":"styles_cookieListWrapper__5U8PK"};

var OnetrustCookieList = function (_a) {
    var title = _a.title, layout = _a.layout;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
        title && React__namespace.default.createElement("h2", null, title),
        React__namespace.default.createElement("div", { className: css$Q.cookieListWrapper },
            React__namespace.default.createElement("div", { id: "ot-sdk-cookie-policy" }))));
};

var sharedComponents = {
    Accordion: Accordion,
    Image: Image$1,
    ImgResized: ImgResized,
    ImageSection: ImageSection,
    ImageStatic: ImageStatic,
    List: List,
    ListCircle: ListCircle,
    NavigationTree: NavigationTree,
    StatusBanner: StatusBanner,
    CalloutBlock: CalloutBlock,
    OnetrustCookieSettings: OnetrustCookieSettings,
    OnetrustCookieList: OnetrustCookieList,
    Richtext: Richtext,
    StandardCard: StandardCard,
    StandardCardGroup: StandardCardGroup,
    StandardModule: StandardModule,
    Table: Table,
    TableStandard: TableStandard,
    TextGrid: TextGrid,
    VideoContainer: VideoContainer
};
var sharedUtils = {
    ottoUtils: ottoUtils
};

var FootnoteContent = function (_a) {
    var name = _a.name, content = _a.content;
    var ottoIcons = useOttoIcons().ottoIcons;
    if (!name) {
        return null;
    }
    var props = getFootnoteProps(name);
    if (!props) {
        return null;
    }
    var contentId = props.contentId, refId = props.refId, text = props.text;
    var labelId = "".concat(contentId, "-label");
    return (React__namespace.default.createElement("div", { id: contentId, className: css$14.footnote },
        React__namespace.default.createElement(Richtext, { body: content }),
        React__namespace.default.createElement("a", { href: "#".concat(refId), "aria-labelledby": labelId },
            React__namespace.default.createElement("span", { id: labelId, className: "d-none", "aria-hidden": true }, text),
            React__namespace.default.createElement(OttoIcon, { icon: ottoIcons['IconUndoExtraSmall'] }))));
};

var css$P = {"wrapper":"styles_wrapper__3tbbj","container":"styles_container__CrJ1X","hack":"styles_hack__InqoJ"};

var Disclaimer = function (_a) {
    var content = _a.content, rest = __rest(_a, ["content"]);
    return (React__namespace.default.createElement("div", __assign({ className: css$P.wrapper }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$P.container }, content.map(function (c) {
            switch (c.component) {
                case 'richtext':
                    return React__namespace.default.createElement(Richtext, __assign({ key: c._uid }, c));
                case 'footnote-item':
                    return React__namespace.default.createElement(FootnoteContent, __assign({ key: c._uid }, c));
                default:
                    return null;
            }
        })),
        React__namespace.default.createElement("span", { className: css$P.hack })));
};

var css$O = {"container":"styles_container__Et4le","highlighted":"styles_highlighted__w7M-n","logo":"styles_logo__5vv5p","highlightedLink":"styles_highlightedLink__gloPy","highlightedLinkText":"styles_highlightedLinkText__SMNnq","arrowIcon":"styles_arrowIcon__BWLGl","linkGroup":"styles_linkGroup__AsVoG","linkGroupTitle":"styles_linkGroupTitle__fbB-4","link":"styles_link__WpDwx"};

var FooterTop = function (_a) {
    var _b = _a.highlightedLinks, highlightedLinks = _b === void 0 ? [] : _b, _c = _a.linkGroups, linkGroups = _c === void 0 ? [] : _c, endorsedLogoLabel = _a.endorsedLogoLabel;
    return (React__namespace.default.createElement("div", { className: css$O.container },
        React__namespace.default.createElement("div", { className: css$O.highlighted },
            React__namespace.default.createElement(Svg, { name: "LogoPayPalPrimaryPositive", ariaLabel: endorsedLogoLabel, className: css$O.logo }),
            highlightedLinks.length > 0 &&
                highlightedLinks.map(function (_a) {
                    var _uid = _a._uid, text = _a.text, url = _a.url, target = _a.target;
                    return (React__namespace.default.createElement("div", { key: _uid },
                        React__namespace.default.createElement(Link, { url: url, target: target, className: css$O.highlightedLink },
                            React__namespace.default.createElement("span", { className: css$O.highlightedLinkText }, text),
                            React__namespace.default.createElement(Svg, { name: "ArrowRight", className: css$O.arrowIcon }))));
                })),
        (linkGroups === null || linkGroups === void 0 ? void 0 : linkGroups.length) > 0 &&
            linkGroups.map(function (_a) {
                var title = _a.title, _b = _a.links, links = _b === void 0 ? [] : _b, _uid = _a._uid;
                return (React__namespace.default.createElement("div", { key: _uid, className: css$O.linkGroup },
                    React__namespace.default.createElement("h3", { className: css$O.linkGroupTitle }, title),
                    links.length > 0 &&
                        links.map(function (_a) {
                            var text = _a.text, linkUid = _a._uid, url = _a.url, target = _a.target;
                            return (React__namespace.default.createElement(Link, { key: linkUid, url: url, target: target, className: css$O.link }, text));
                        })));
            })));
};

var prependSlash = function (string) {
    return string.startsWith('/') || string.startsWith('http') ? string : "/".concat(string);
};

var css$N = {"dropdownContainer":"styles_dropdownContainer__TeJ5a","hide":"styles_hide__3kate","chevron":"styles_chevron__tVmXj","flagIcon":"styles_flagIcon__OdXvA","currentCountry":"styles_currentCountry__BbXO3","iconDown":"styles_iconDown__TGH0y","isOpen":"styles_isOpen__zivQy","countryListContainer":"styles_countryListContainer__YWhZu","countryItem":"styles_countryItem__WXUcH","iconFlag":"styles_iconFlag__rhuXS","webNextTheme":"styles_webNextTheme__CVmWX","noHover":"styles_noHover__n0iwQ","currentCountryText":"styles_currentCountryText__sSeKl"};

var sortAlphabeticallyByKey = function (arrayToSort, key) {
    return __spreadArray([], arrayToSort, true).sort(function (a, b) {
        if (a[key] < b[key]) {
            return -1;
        }
        if (a[key] > b[key]) {
            return 1;
        }
        return 0;
    });
};
var CountrySelectDropDown = function (_a) {
    var _b;
    var currentCountry = _a.currentCountry, countries = _a.countries, _c = _a.isWebNext, isWebNext = _c === void 0 ? false : _c, router = _a.router;
    var selectRef = React.useRef(null);
    var _d = React.useState(currentCountry), selectedCountry = _d[0], setSelectedCountry = _d[1];
    var allCountries = __spreadArray([], countries, true);
    var sortedCountries = sortAlphabeticallyByKey(allCountries, 'text');
    React.useEffect(function () {
        if (currentCountry._uid !== selectedCountry._uid) {
            setSelectedCountry(currentCountry);
        }
    }, [currentCountry._uid]);
    var handleSelect = function (e) {
        var _a;
        if (router) {
            router.push(sortedCountries[e.target.selectedIndex].url.url);
            (_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.blur(); // Blur the select element on select
        }
    };
    var ListItem = function (_a) {
        var url = _a.url, children = _a.children;
        return (React__namespace.default.createElement("li", null,
            React__namespace.default.createElement("a", { href: prependSlash(url) }, children)));
    };
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$N.dropdownContainer, (_b = {},
            _b[css$N.webNextTheme] = isWebNext,
            _b)) },
        React__namespace.default.createElement(Svg, { className: css$N.flagIcon, name: selectedCountry.icon, ariaHidden: true }),
        React__namespace.default.createElement(Svg, { className: css$N.chevron, name: "IconDownChevron", ariaHidden: true }),
        React__namespace.default.createElement("ul", { className: css$N.hide, "aria-hidden": true }, sortedCountries.map(function (_a) {
            var text = _a.text, url = _a.url, _uid = _a._uid;
            return (React__namespace.default.createElement(ListItem, { key: _uid, url: url.url }, text));
        })),
        React__namespace.default.createElement("select", { ref: selectRef, className: css$N.currentCountry, onChange: handleSelect, onBlur: function () {
                return;
            }, "aria-label": "Select country", "data-testid": "currentCountry", value: selectedCountry.text }, sortedCountries.map(function (_a) {
            var text = _a.text, _uid = _a._uid;
            return (React__namespace.default.createElement("option", { key: _uid, className: classNames__default.default(css$N.countryItem, 'focus-darken'), "data-testid": "countrySelectOption", value: text }, text));
        }))));
};

var getCurrentAndRemainingLocations = function (locations, initialLocation, fullSlug) {
    var locale = fullSlug.slice(0, 2);
    return locations.reduce(function (_a, currLocation) {
        var _b;
        var currentLocation = _a[0], filteredLocations = _a[1];
        return locale === ((_b = currLocation === null || currLocation === void 0 ? void 0 : currLocation.url) === null || _b === void 0 ? void 0 : _b.url.slice(1, 3))
            ? [currLocation, filteredLocations]
            : [currentLocation, __spreadArray(__spreadArray([], filteredLocations, true), [currLocation], false)];
    }, [initialLocation, []]);
};

var LocationSelector = function (_a) {
    var _b = _a.locationData, locationData = _b === void 0 ? {} : _b, locations = _a.locations, buttonLabel = _a.buttonLabel;
    var useRouter = React.useContext(SiteComponentContext).hooks.useRouter;
    var initialLocation = {
        url: {
            id: '',
            url: 'gb',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: '#'
        },
        _uid: '0615e6e0-747d-412e-b01e-982738d883de',
        icon: 'FlagGb',
        text: 'Great Britain'
    };
    var router = useRouter();
    var _c = locationData.fullSlug, fullSlug = _c === void 0 ? '' : _c;
    var updatedCurrentLocation = getCurrentAndRemainingLocations(locations, initialLocation, fullSlug)[0];
    return (React__namespace.default.createElement(CountrySelectDropDown, { isWebNext: true, buttonLabel: buttonLabel, currentCountry: updatedCurrentLocation, countries: locations, router: router }));
};

var css$M = {"container":"styles_container__LqS97","RTRLinks":"styles_RTRLinks__Mpr9V","RTRLink":"styles_RTRLink__80DMq","locationSelector":"styles_locationSelector__XKoKb","socialLinks":"styles_socialLinks__tQB88","iconText":"styles_iconText__mpEEk","icon":"styles_icon__cVrkR"};

var FooterBottom = function (_a) {
    var locationData = _a.locationData, _b = _a.RTRLinks, RTRLinks = _b === void 0 ? [] : _b, _c = _a.socialLinks, socialLinks = _c === void 0 ? [] : _c, locationSelectTitle = _a.locationSelectTitle, countriesNavLabel = _a.countriesNavLabel, locations = _a.locations;
    var rtrLinksElement = (React__namespace.default.createElement("div", { className: css$M.RTRLinks }, RTRLinks.length > 0 &&
        RTRLinks.map(function (_a) {
            var text = _a.text, url = _a.url, target = _a.target, _uid = _a._uid;
            return (React__namespace.default.createElement(Link, { key: _uid, url: url, target: target, className: css$M.RTRLink }, text));
        })));
    var locationSelectorElement = (React__namespace.default.createElement("nav", { className: css$M.locationSelector, "aria-label": countriesNavLabel || locationSelectTitle },
        locationSelectTitle && React__namespace.default.createElement("h4", null, locationSelectTitle),
        React__namespace.default.createElement(LocationSelector, { buttonLabel: countriesNavLabel || locationSelectTitle, locations: locations, locationData: locationData })));
    var socialLinksElement = (React__namespace.default.createElement("div", { className: css$M.socialLinks }, socialLinks.length > 0 &&
        socialLinks.map(function (_a) {
            var url = _a.url, icon = _a.icon, target = _a.target, text = _a.text, socialUid = _a._uid;
            return (React__namespace.default.createElement(Link, { key: socialUid, url: url, target: target, "aria-labelledby": "social-".concat(text) },
                React__namespace.default.createElement(Svg, { name: icon, className: css$M.icon, ariaHidden: true }),
                React__namespace.default.createElement("span", { id: "social-".concat(text), className: css$M.iconText }, text)));
        })));
    var footerElementsOrder = {
        mobile: ['rtrLinks', 'locationSelector', 'socialLinks'],
        tablet: ['rtrLinks', 'socialLinks', 'locationSelector'],
        desktop: ['socialLinks', 'rtrLinks', 'locationSelector']
    };
    var footerElements = {
        rtrLinks: rtrLinksElement,
        locationSelector: locationSelectorElement,
        socialLinks: socialLinksElement
    };
    return (React__namespace.default.createElement("div", { className: css$M.container },
        React__namespace.default.createElement(AccessibilityRender, { elementsOrder: footerElementsOrder, elements: footerElements })));
};

var css$L = {"footer":"styles_footer__t9ikp","copyright":"styles_copyright__pVLio","divider":"styles_divider__v9Rik"};

var Footer = function (_a) {
    var locationData = _a.locationData, highlightedLinks = _a.highlightedLinks, linkGroups = _a.linkGroups, copyrightText = _a.copyrightText, RTRLinks = _a.RTRLinks, socialLinks = _a.socialLinks, locationSelectTitle = _a.locationSelectTitle, locations = _a.locations, _b = _a.countriesNavLabel, countriesNavLabel = _b === void 0 ? 'Countries' : _b, _c = _a.endorsedLogoLabel, endorsedLogoLabel = _c === void 0 ? 'Zettle by PayPal logo' : _c, rest = __rest(_a, ["locationData", "highlightedLinks", "linkGroups", "copyrightText", "RTRLinks", "socialLinks", "locationSelectTitle", "locations", "countriesNavLabel", "endorsedLogoLabel"]);
    var footerElementsOrder = {
        mobile: ['footerTop', 'divider', 'footerBottom', 'copyright'],
        tablet: ['footerTop', 'copyright', 'divider', 'footerBottom'],
        desktop: ['footerTop', 'copyright', 'divider', 'footerBottom']
    };
    var footerTopElement = (React__namespace.default.createElement(FooterTop, { highlightedLinks: highlightedLinks, linkGroups: linkGroups, endorsedLogoLabel: endorsedLogoLabel }));
    var copyrightElement = copyrightText && (React__namespace.default.createElement("div", { className: css$L.copyright },
        React__namespace.default.createElement(Html, { html: copyrightText.content })));
    var dividerElement = React__namespace.default.createElement("div", { className: css$L.divider });
    var footerBottomElement = (React__namespace.default.createElement(FooterBottom, { RTRLinks: RTRLinks, socialLinks: socialLinks, countriesNavLabel: countriesNavLabel, locationSelectTitle: locationSelectTitle, locationData: locationData, locations: locations }));
    var footerElements = {
        footerTop: footerTopElement,
        copyright: copyrightElement,
        divider: dividerElement,
        footerBottom: footerBottomElement
    };
    return (React__namespace.default.createElement("footer", __assign({ role: "contentinfo", className: css$L.footer }, react.storyblokEditable(rest)),
        React__namespace.default.createElement(AccessibilityRender, { elementsOrder: footerElementsOrder, elements: footerElements })));
};

var css$K = {"breadcrumbs":"styles_breadcrumbs__Mb6Bl","current":"styles_current__HVA8F"};

var MIN_PAGE_DEPTH = 3;
var splitAndCapitalize = function (slug) {
    return slug
        .split('-')
        .map(function (part, index) {
        return index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part;
    })
        .join(' ');
};
var generateBreadcrumbs = function (slugs, customBreadcrumbs) {
    if (customBreadcrumbs === void 0) { customBreadcrumbs = []; }
    return slugs.reduce(function (acc, slug, i) {
        if (i === 0) {
            acc.push({
                url: "/".concat(slug),
                page: 'Home'
            });
        }
        else {
            acc.push({
                url: "".concat(acc[i - 1].url, "/").concat(slug),
                page: customBreadcrumbs[i - 1]
                    ? customBreadcrumbs[i - 1].text
                    : "".concat(splitAndCapitalize(slug))
            });
        }
        return acc;
    }, []);
};
var generateStructuredData = function (baseUrl, breadcrumbsData) { return "\n  {\n    \"@context\": \"http://schema.org\",\n    \"@type\": \"BreadcrumbList\",\n    \"itemListElement\": [".concat(breadcrumbsData.map(function (breadcrumb, i) { return "\n      {\n        \"@type\": \"ListItem\",\n        \"position\": ".concat(i + 1, ",\n        \"item\": {\n          \"@id\": \"").concat(baseUrl + breadcrumb.url, "\",\n          \"name\": \"").concat(breadcrumb.page, "\"\n        }\n      }\n    "); }), "]\n  }\n  "); };
var Breadcrumbs = function (_a) {
    var _b = _a.fullSlug, fullSlug = _b === void 0 ? '' : _b, className = _a.className, _c = _a.baseUrl, baseUrl = _c === void 0 ? '' : _c, _d = _a.navLabelBreadcrumbs, navLabelBreadcrumbs = _d === void 0 ? 'breadcrumbs' : _d, customBreadcrumbs = _a.customBreadcrumbs, ottoIcon = _a.ottoIcon;
    var slugs = fullSlug.replace(/\/$/, '').split('/');
    var ottoIcons = useOttoIcons().ottoIcons;
    if (slugs.length < MIN_PAGE_DEPTH) {
        return null;
    }
    var breadcrumbsData = generateBreadcrumbs(slugs, customBreadcrumbs).slice(1);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("nav", { className: classNames__default.default(className, css$K.breadcrumbs), "aria-label": navLabelBreadcrumbs },
            React__namespace.default.createElement("ol", null, breadcrumbsData.map(function (_a, i) {
                var url = _a.url, page = _a.page;
                return i < breadcrumbsData.length - 1 ? (React__namespace.default.createElement("li", { key: url },
                    React__namespace.default.createElement("a", { className: "breadcrumb styled-link-arrow", href: url }, page),
                    isOttoIconBlock(ottoIcon) &&
                        isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) ? (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))) : (React__namespace.default.createElement("span", { "aria-hidden": "true" }, "\u00A0>\u00A0")))) : (React__namespace.default.createElement("li", { key: url },
                    React__namespace.default.createElement("a", { href: url, onClick: function (e) { return e.preventDefault(); }, className: classNames__default.default(css$K.current, 'styled-link-arrow'), "aria-current": "location" }, page)));
            }))),
        React__namespace.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
                __html: generateStructuredData(baseUrl, breadcrumbsData)
            } })));
};

var css$J = {"content":"styles_content__FWr8p","content-center":"styles_content-center__ghJwA","marginBottom":"styles_marginBottom__6yycB","centerAligned":"styles_centerAligned__DdMd7","top":"styles_top__6F-0F","center":"styles_center__Z3in8","textAlignmentMobile-left":"styles_textAlignmentMobile-left__fQX5x","textAlignmentMobile-center":"styles_textAlignmentMobile-center__-u7-u","title":"styles_title__e7Kxz","price":"styles_price__zO3BH","noMargin":"styles_noMargin__l5cBd","info":"styles_info__mFo-M","linksBelow":"styles_linksBelow__uE2rS","subtitle":"styles_subtitle__lrPOu","marginMobile":"styles_marginMobile__DKWqH","textColor-white":"styles_textColor-white__xdP-H","textColor-dark":"styles_textColor-dark__TXurv","marginDesktop":"styles_marginDesktop__646fX","bottom":"styles_bottom__du-dv","noImage":"styles_noImage__hjttq","linkContainer":"styles_linkContainer__OROqN","floating":"styles_floating__Q1-uE"};

var Content = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g, _h, _j;
    var children = _a.children, contentVerticalPosition = _a.contentVerticalPosition, contentHorizontalPosition = _a.contentHorizontalPosition, imagePosition = _a.imagePosition, links = _a.links, noImage = _a.noImage, subtitle = _a.subtitle, price = _a.price, title = _a.title, textColor = _a.textColor, textAlignmentMobile = _a.textAlignmentMobile, showTitle = _a.showTitle;
    var pricing = React.useContext(SiteComponentContext).pricing;
    var priceValue = pricing.getPrice(price === null || price === void 0 ? void 0 : price.location, price === null || price === void 0 ? void 0 : price.product.product);
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$J.content, css$J["content-".concat(contentHorizontalPosition)], css$J["textAlignmentMobile-".concat(textAlignmentMobile)], (_b = {},
            _b[css$J.centerAligned] = contentHorizontalPosition === 'center',
            _b[css$J["".concat(contentVerticalPosition)]] = contentHorizontalPosition !== 'center',
            _b[css$J.noImage] = noImage,
            _b[css$J.marginBottom] = !noImage && imagePosition === 'bottom',
            _b)) },
        children,
        title && showTitle && (React__namespace.default.createElement(Richtext, { body: title, className: classNames__default.default(css$J.backgroundColor, css$J.title, (_c = {},
                _c[css$J.price] = (_g = price === null || price === void 0 ? void 0 : price.product) === null || _g === void 0 ? void 0 : _g.price,
                _c[css$J.noMargin] = !subtitle,
                _c)) })),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$J.info, (_d = {},
                _d[css$J.linksBelow] = links && links.length > 0,
                _d)) },
            subtitle && (React__namespace.default.createElement(Richtext, { body: subtitle, className: classNames__default.default(css$J.subtitle, css$J["content-".concat(contentHorizontalPosition)], (_e = {},
                    _e[css$J.marginMobile] = (_h = price === null || price === void 0 ? void 0 : price.product) === null || _h === void 0 ? void 0 : _h.price,
                    _e)) })),
            ((_j = price === null || price === void 0 ? void 0 : price.product) === null || _j === void 0 ? void 0 : _j.price) && (React__namespace.default.createElement("span", { className: classNames__default.default(css$J.price, css$J["textColor-".concat(textColor)], (_f = {},
                    _f[css$J.marginDesktop] = subtitle,
                    _f)) },
                priceValue && React__namespace.default.createElement("strong", null, priceValue),
                React__namespace.default.createElement(FootnoteRef, { name: price === null || price === void 0 ? void 0 : price.disclaimer })))),
        React__namespace.default.createElement("div", { className: css$J.linkGroup }, links &&
            links.map(function (link) {
                var _a;
                return (React__namespace.default.createElement("div", { className: classNames__default.default(css$J.linkContainer, css$J["textColor-".concat(textColor)], (_a = {},
                        _a[css$J.floating] = link.type.includes('floating'),
                        _a)), key: link._uid },
                    React__namespace.default.createElement(StyledLink, __assign({}, link))));
            }))));
};

var css$I = {"mediaWrapper":"styles_mediaWrapper__539-b","fullWidth":"styles_fullWidth__7Tw-I","noMargin":"styles_noMargin__ggFKN","content-left":"styles_content-left__GUe6B","content-right":"styles_content-right__BDvTx","content-center":"styles_content-center__nAB5J","image-top":"styles_image-top__I9Y7e","image-bottom":"styles_image-bottom__A96FO","image-center":"styles_image-center__ieuSB","extraPadding":"styles_extraPadding__1nURT","padding-5":"styles_padding-5__3ggnQ","padding-10":"styles_padding-10__dL1Bu","padding-15":"styles_padding-15__-yxKm","padding-20":"styles_padding-20__90FEw","padding-25":"styles_padding-25__4Mn2A"};

var Media = function (_a) {
    var _b;
    var contentHorizontalPosition = _a.contentHorizontalPosition, imageFullWidth = _a.imageFullWidth, imageNoMargin = _a.imageNoMargin, imagePadding = _a.imagePadding, imagePosition = _a.imagePosition, images = _a.images;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$I.mediaWrapper, css$I["content-".concat(contentHorizontalPosition)], css$I["image-".concat(imagePosition)], (_b = {},
            _b[css$I.fullWidth] = imageFullWidth,
            _b[css$I.noMargin] = imageNoMargin,
            _b)) },
        React__namespace.default.createElement("div", { className: classNames__default.default(css$I.extraPadding, css$I["padding-".concat(imagePadding)]) },
            React__namespace.default.createElement(ImageCluster, __assign({}, images)))));
};

var css$H = {"heroContainer":"styles_heroContainer__iKpNp","imageNoMargin":"styles_imageNoMargin__BX2tm","content-left":"styles_content-left__ldigM","content-right":"styles_content-right__UUgze","innerContainer":"styles_innerContainer__Kz0Wq","content":"styles_content__B5gpL","hero":"styles_hero__fUJBl","noImage":"styles_noImage__H-lej","largeHero":"styles_largeHero__6u9sk","imageTop":"styles_imageTop__jYqOb","contentWrapper":"styles_contentWrapper__s7TAj","textColor-white":"styles_textColor-white__SWlvE","textColor-dark":"styles_textColor-dark__fMo3W","content-center":"styles_content-center__tWJiP","breadcrumbs":"styles_breadcrumbs__al60-","hideInMobile":"styles_hideInMobile__vhiPj","hide":"styles_hide__YlMZ2","titleContainer":"styles_titleContainer__ef2kj","textAlignmentMobileCenter":"styles_textAlignmentMobileCenter__M9EAB","title":"styles_title__APnE3"};

var Hero = function (props) {
    var _a, _b;
    var _c, _d, _e, _f;
    if (props === void 0) { props = {}; }
    var isMediaTitleActive = props.imagePosition === 'center' &&
        props.contentHorizontalPosition !== 'center';
    var _g = React.useState(false), showMediaTitle = _g[0], setShowMediaTitle = _g[1];
    var handleMediaQueryChange = function (isMobile) {
        var show = isMediaTitleActive && !isMobile;
        if (props.contentHorizontalPosition === 'right' &&
            props.imagePosition === 'center') {
            show = !show;
        }
        else if (props.contentHorizontalPosition === 'left' &&
            props.imagePosition === 'center') {
            show = !show;
        }
        setShowMediaTitle(show);
    };
    var isMobile = reactResponsive.useMediaQuery({ maxWidth: breakpoints.m2 }, undefined, handleMediaQueryChange);
    React.useEffect(function () {
        // Trigger re-render based on media query when available
        handleMediaQueryChange(isMobile);
    }, []);
    var imageArray = (((_c = props.images) === null || _c === void 0 ? void 0 : _c[0]) &&
        [
            props.images[0].image1,
            props.images[0].image2,
            props.images[0].image3,
            props.images[0].image4
        ].filter(function (image) { var _a; return checkImage((_a = image[0]) === null || _a === void 0 ? void 0 : _a.asset); })) ||
        [];
    var bgColor = ((_d = props.layout) === null || _d === void 0 ? void 0 : _d[0]) &&
        (checkImage(props.layout[0].backgroundImage)
            ? 'transparent'
            : props.layout[0].backgroundColor);
    var noImage = !imageArray.length;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, (_e = props.layout) === null || _e === void 0 ? void 0 : _e[0], { backgroundColor: bgColor, className: classNames__default.default(css$H.heroContainer, css$H["content-".concat(props.contentHorizontalPosition)], (_a = {},
            _a[css$H.imageNoMargin] = imageArray.length && props.imageNoMargin,
            _a)) }, react.storyblokEditable(props)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$H.hero, css$H["content-".concat(props.contentHorizontalPosition)], (_b = {},
                _b[css$H.imageTop] = props.imagePosition === 'top' || props.imagePosition === 'center',
                _b[css$H.noImage] = !imageArray.length,
                _b[css$H.largeHero] = props.largeHero,
                _b[css$H["textColor-".concat(props.textColor)]] = ((_f = props.layout) === null || _f === void 0 ? void 0 : _f[0]) && checkImage(props.layout[0].backgroundImage),
                _b)) },
            React__namespace.default.createElement(HeroBase, __assign({}, props, { bgColor: bgColor, noImage: noImage, showTitle: !showMediaTitle })),
            !noImage && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(HeroWithImages, __assign({}, props, { bgColor: bgColor, imageArray: imageArray })),
                showMediaTitle && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                    React__namespace.default.createElement(MediaAlignedTitle, { baseUrl: props.baseUrl, contentHorizontalPosition: props.contentHorizontalPosition, customBreadcrumbs: props.customBreadcrumbs, fullSlug: props.fullSlug, hideBreadcrumbs: props.hideBreadcrumbs, navLabelBreadcrumbs: props.navLabelBreadcrumbs, title: props.title, textAlignmentMobile: props.textAlignmentMobile, bgColor: bgColor, ottoIconBreadcrumbs: props.ottoIconBreadcrumbs }))))))));
};
var HeroBase = function (_a) {
    var _b;
    var baseUrl = _a.baseUrl, contentHorizontalPosition = _a.contentHorizontalPosition, contentVerticalPosition = _a.contentVerticalPosition, customBreadcrumbs = _a.customBreadcrumbs, fullSlug = _a.fullSlug, hideBreadcrumbs = _a.hideBreadcrumbs, imagePosition = _a.imagePosition, layout = _a.layout, links = _a.links, subtitle = _a.subtitle, price = _a.price, title = _a.title, textColor = _a.textColor, textAlignmentMobile = _a.textAlignmentMobile, bgColor = _a.bgColor, noImage = _a.noImage, showTitle = _a.showTitle, ottoIconBreadcrumbs = _a.ottoIconBreadcrumbs, navLabelBreadcrumbs = _a.navLabelBreadcrumbs;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$H.contentWrapper, css$H["content-".concat(contentHorizontalPosition)]) },
        React__namespace.default.createElement(Content, { contentVerticalPosition: contentVerticalPosition, contentHorizontalPosition: contentHorizontalPosition, imagePosition: imagePosition, links: links, noImage: noImage, subtitle: subtitle, price: price, title: title, showTitle: showTitle, textColor: (layout === null || layout === void 0 ? void 0 : layout[0]) && checkImage(layout[0].backgroundImage) ? textColor : '', textAlignmentMobile: textAlignmentMobile }, !hideBreadcrumbs && (React__namespace.default.createElement(Breadcrumbs, { className: classNames__default.default(bgColor, css$H.breadcrumbs, (_b = {},
                _b[css$H.hideInMobile] = contentHorizontalPosition !== 'center' &&
                    imagePosition === 'center',
                _b[css$H.hide] = contentHorizontalPosition === 'center' &&
                    imagePosition === 'center',
                _b)), fullSlug: fullSlug, baseUrl: baseUrl, navLabelBreadcrumbs: navLabelBreadcrumbs, customBreadcrumbs: customBreadcrumbs, ottoIcon: ottoIconBreadcrumbs })))));
};
var HeroWithImages = function (_a) {
    var contentHorizontalPosition = _a.contentHorizontalPosition, imageFullWidth = _a.imageFullWidth, imageNoMargin = _a.imageNoMargin, images = _a.images, imagePadding = _a.imagePadding, imagePosition = _a.imagePosition;
    return (React__namespace.default.createElement(Media, { contentHorizontalPosition: contentHorizontalPosition, imageFullWidth: imageFullWidth, imageNoMargin: imageNoMargin, imagePadding: imagePadding, imagePosition: imagePosition, images: images[0] }));
};
var MediaAlignedTitle = function (_a) {
    var _b;
    var baseUrl = _a.baseUrl, contentHorizontalPosition = _a.contentHorizontalPosition, customBreadcrumbs = _a.customBreadcrumbs, fullSlug = _a.fullSlug, hideBreadcrumbs = _a.hideBreadcrumbs, title = _a.title, textAlignmentMobile = _a.textAlignmentMobile, bgColor = _a.bgColor, ottoIconBreadcrumbs = _a.ottoIconBreadcrumbs, navLabelBreadcrumbs = _a.navLabelBreadcrumbs;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$H.titleContainer, css$H["content-".concat(contentHorizontalPosition)], (_b = {},
            _b[css$H.textAlignmentMobileCenter] = textAlignmentMobile === 'center',
            _b)) },
        !hideBreadcrumbs && (React__namespace.default.createElement(Breadcrumbs, { className: bgColor, fullSlug: fullSlug, baseUrl: baseUrl, navLabelBreadcrumbs: navLabelBreadcrumbs, customBreadcrumbs: customBreadcrumbs, ottoIcon: ottoIconBreadcrumbs })),
        React__namespace.default.createElement(Richtext, { body: title, className: classNames__default.default(css$H.backgroundColor, css$H.title) })));
};

var css$G = {"brandContainer":"styles_brandContainer__aInKS","logo":"styles_logo__so17z","title":"styles_title__j6gir"};

var defaultLink = {
    id: '123',
    url: 'https://www.izettle.com/gb/help',
    linktype: 'url',
    fieldtype: 'multilink',
    cached_url: 'https://www.izettle.com/gb/help'
};
var Brand = function (_a) {
    var _b = _a.logoLink, logoLink = _b === void 0 ? defaultLink : _b, _c = _a.logo, logo = _c === void 0 ? 'LogoPayPalPrimaryPositive' : _c, title = _a.title, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, tabIndex = _a.tabIndex;
    return (React__namespace.default.createElement("div", { className: css$G.brandContainer, "data-testid": "header-brand" },
        React__namespace.default.createElement(Link, __assign({ url: logoLink, tabIndex: tabIndex }, (title
            ? undefined
            : {
                'aria-label': ariaLabel
            }), { "aria-hidden": ariaHidden, className: 'focus-otto' }),
            React__namespace.default.createElement(Svg, { name: logo, className: css$G.logo, ariaLabel: ariaLabel }),
            title && React__namespace.default.createElement("span", { className: css$G.title }, title))));
};

var css$F = {"container":"styles_container__ncJh1","group":"styles_group__-cLsE","searchIcon":"styles_searchIcon__sza-C","menuItem":"styles_menuItem__MzD1a","active":"styles_active__B76Oq","cramHeaderItems":"styles_cramHeaderItems__GWDF0","linkGroup":"styles_linkGroup__nPp-e","menuLink":"styles_menuLink__PyZgg"};

var DesktopNav = function (_a) {
    var activeMainMenuItem = _a.activeMainMenuItem, closeSideMenu = _a.closeSideMenu, handleHover = _a.handleHover, linkGroup = _a.linkGroup, logo = _a.logo, logoLink = _a.logoLink, logoLinkLabel = _a.logoLinkLabel, mainNavItems = _a.mainNavItems, isDisabled = _a.isDisabled, cramHeaderItems = _a.cramHeaderItems;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: classNames__default.default(css$F.container, cramHeaderItems ? css$F.cramHeaderItems : '') },
            React__namespace.default.createElement("div", { className: css$F.group },
                React__namespace.default.createElement(Brand, { logo: logo, logoLink: logoLink, ariaLabel: logoLinkLabel, ariaHidden: isDisabled, tabIndex: isDisabled ? -1 : 0 }),
                mainNavItems &&
                    mainNavItems.map(function (_a) {
                        var _b;
                        var text = _a.text, topLevelMenuItems = _a.topLevelMenuItems, url = _a.url, _uid = _a._uid;
                        return topLevelMenuItems ? (React__namespace.default.createElement("button", { className: classNames__default.default(css$F.menuItem, (_b = {},
                                _b[css$F.active] = activeMainMenuItem === text,
                                _b)), onMouseOver: function () { return handleHover(topLevelMenuItems, text); }, key: _uid, tabIndex: -1, "aria-hidden": true }, text)) : (url && (React__namespace.default.createElement(Link, { className: classNames__default.default(css$F.menuItem, css$F.menuLink), url: url, key: _uid, onMouseOver: function () { return closeSideMenu(); }, tabIndex: -1, "aria-hidden": true }, text)));
                    })),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement("div", { className: css$F.group },
                    React__namespace.default.createElement("div", { className: css$F.linkGroup }, linkGroup &&
                        linkGroup.map(function (_a) {
                            var text = _a.text, url = _a.url, _uid = _a._uid;
                            return (React__namespace.default.createElement(Link, { className: classNames__default.default(css$F.menuItem, css$F.menuLink), url: url, key: _uid, onMouseOver: function () { return closeSideMenu(); }, tabIndex: isDisabled ? -1 : 0, "aria-hidden": isDisabled }, text));
                        })))))));
};

var css$E = {"container":"styles_container__Ry6XA","item":"styles_item__63AcJ","styledLink":"styles_styledLink__NnZbG"};

var css$D = {"hamburgerButton":"styles_hamburgerButton__2uwXg","closeButton":"styles_closeButton__6Ypxd"};

var KeyboardEventKeys;
(function (KeyboardEventKeys) {
    KeyboardEventKeys["TAB"] = "Tab";
})(KeyboardEventKeys || (KeyboardEventKeys = {}));
var TRANSLATION_EFFECT_DURATION = 300;

var Hamburger = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.enableShiftTabClose, enableShiftTabClose = _c === void 0 ? false : _c, _d = _a.toggleNavMenuLabel, toggleNavMenuLabel = _d === void 0 ? 'Toggle navigation menu' : _d, _e = _a.behaviorVariant, behaviorVariant = _e === void 0 ? '' : _e;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _f = React.useContext(HeaderContext), isMobileMenuOpen = _f.isMobileMenuOpen, closeDesktopMenu = _f.closeDesktopMenu, toggleMenu = _f.toggleMenu;
    var handleClick = function () {
        var _a;
        toggleMenu();
        if (isMobileMenuOpen) {
            closeDesktopMenu();
            (_a = document.getElementById('toggle-navigation-menu')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    React.useEffect(function () {
        var _a;
        isMobileMenuOpen &&
            ((_a = document.getElementById('toggle-navigation-menu-overlay')) === null || _a === void 0 ? void 0 : _a.focus());
    }, [isMobileMenuOpen]);
    var handleKeyboard = enableShiftTabClose &&
        (function (e) {
            if (e.shiftKey && e.key === KeyboardEventKeys.TAB) {
                e.preventDefault();
                isMobileMenuOpen && handleClick();
            }
        });
    return (React__namespace.default.createElement(Button, { onPress: handleClick, className: classNames__default.default(css$D.hamburgerButton, 'focus-otto-icon', className, isMobileMenuOpen ? css$D.closeButton : ''), "aria-label": toggleNavMenuLabel, "aria-expanded": isMobileMenuOpen, onKeyDown: handleKeyboard || undefined, id: "toggle-navigation-menu".concat(behaviorVariant ? "-".concat(behaviorVariant) : '') },
        React__namespace.default.createElement(OttoIcon, { icon: ottoIcons[isMobileMenuOpen ? 'IconCrossMedium' : 'IconMenuMedium'] })));
};

var MobileNav = function (_a) {
    var logo = _a.logo, logoLink = _a.logoLink, logoLinkLabel = _a.logoLinkLabel, toggleNavMenuLabel = _a.toggleNavMenuLabel, pagesNavLabel = _a.pagesNavLabel, linkGroup = _a.linkGroup;
    var lastItem = linkGroup[linkGroup.length - 1];
    return (React__namespace.default.createElement("div", { className: css$E.container },
        React__namespace.default.createElement("nav", { "aria-label": pagesNavLabel, className: css$E.item },
            React__namespace.default.createElement(Hamburger, { toggleNavMenuLabel: toggleNavMenuLabel })),
        React__namespace.default.createElement("div", { className: css$E.item },
            React__namespace.default.createElement(Brand, { logo: logo, logoLink: logoLink, ariaLabel: logoLinkLabel })),
        React__namespace.default.createElement("div", { className: css$E.item },
            React__namespace.default.createElement(Link, { className: css$E.styledLink, url: lastItem.url }, lastItem.text))));
};

var css$C = {"contentContainer":"styles_contentContainer__FIaP8","menuItem":"styles_menuItem__sxufa","imageMenuItem":"styles_imageMenuItem__xapi6","linkMenuItem":"styles_linkMenuItem__aBgw4","textMenuItem":"styles_textMenuItem__o0YVD","iconChevron":"styles_iconChevron__fblCY","buttonWrapper":"styles_buttonWrapper__AFhjv","imageButtonWrapper":"styles_imageButtonWrapper__TqdXs","buttonItem":"styles_buttonItem__cQP86","itemImage":"styles_itemImage__s0j9U","linkGroup":"styles_linkGroup__DxX3o","signupButton":"styles_signupButton__UnG1k","searchItem":"styles_searchItem__nq1y9","searchIcon":"styles_searchIcon__ZUkcZ","onelineLogo":"styles_onelineLogo__-sBtc"};

var css$B = {"mobileOverlay":"styles_mobileOverlay__KP08T","open":"styles_open__1qOHi","buttonBack":"styles_buttonBack__k2gX2"};

var BACK_BUTTON_ID = 'mobile-back-button';
var MobileOverlay = function (_a) {
    var _b;
    var handleBackClick = _a.handleBackClick, _c = _a.backButtonLabel, backButtonLabel = _c === void 0 ? 'back' : _c;
    var _d = React.useContext(HeaderContext), isMobileMenuOpen = _d.isMobileMenuOpen, activeHeaderText = _d.activeHeaderText;
    var ottoIcons = useOttoIcons().ottoIcons;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$B.mobileOverlay, (_b = {},
            _b[css$B.open] = isMobileMenuOpen,
            _b)) },
        activeHeaderText && (React__namespace.default.createElement(Button, { className: classNames__default.default(css$B.buttonBack, 'focus-otto-icon'), id: BACK_BUTTON_ID, onPress: function () { return handleBackClick(activeHeaderText); }, onKeyDown: function (e) {
                return e.shiftKey &&
                    e.key === KeyboardEventKeys.TAB &&
                    handleBackClick(activeHeaderText);
            }, tabIndex: 0, "aria-label": backButtonLabel },
            React__namespace.default.createElement(OttoIcon, { icon: ottoIcons['IconArrowLeftMedium'] }))),
        activeHeaderText && React__namespace.default.createElement("span", { "aria-hidden": true }, activeHeaderText),
        activeHeaderText ? (React__namespace.default.createElement("div", null)) : (React__namespace.default.createElement(Hamburger, { enableShiftTabClose: true, behaviorVariant: "overlay" }))));
};

var ItemContent = function (_a) {
    var _b;
    var item = _a.item, children = _a.children;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$C.buttonWrapper, (_b = {},
            _b[css$C.imageButtonWrapper] = item.image,
            _b)) },
        React__namespace.default.createElement("div", { className: css$C.buttonItem },
            item.image && (React__namespace.default.createElement("div", { className: css$C.itemImage, style: {
                    backgroundImage: "url(".concat(item.image.image, ")")
                } })),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement("span", null, item.text),
                children))));
};
var TopLevelItem = function (_a) {
    var handleClick = _a.handleClick, item = _a.item, className = _a.className, isActiveLevel = _a.isActiveLevel;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$C.menuItem, className) }, item.url ? (React__namespace.default.createElement(Link, { url: item.url, className: 'focus-darken', tabIndex: isActiveLevel ? 0 : -1, "aria-hidden": !isActiveLevel }, item.text)) : (React__namespace.default.createElement("button", { className: classNames__default.default(css$C.buttonWrapper, 'focus-darken'), tabIndex: isActiveLevel ? 0 : -1, "aria-hidden": !isActiveLevel, id: "menuItem-".concat(item.text), onClick: function () { return isActiveLevel && handleClick(item); }, onKeyDown: function (e) {
            if (['Enter', 'Space'].includes(e.key)) {
                e.preventDefault();
                isActiveLevel && handleClick(item);
            }
        } },
        React__namespace.default.createElement("div", null,
            React__namespace.default.createElement("span", null, item.text),
            React__namespace.default.createElement(Svg, { name: 'IconRightChevron' }))))));
};
var SubLevelItem = function (props) {
    var _a;
    var item = props.item, isActiveLevel = props.isActiveLevel, handleClick = props.handleClick;
    var isButton = item.subMenuItems && item.subMenuItems.length > 0;
    var isLink = !isButton && !!item.url;
    var linkProps = {
        className: classNames__default.default(css$C.menuItem, 'focus-darken', (_a = {},
            _a[css$C.textMenuItem] = !item.image,
            _a[css$C.imageMenuItem] = item.image,
            _a[css$C.linkMenuItem] = item.url,
            _a)),
        tabIndex: isActiveLevel ? 0 : -1,
        id: "menuItem-".concat(item.text)
    };
    var buttonProps = __assign(__assign({}, linkProps), { onPress: function () { return handleClick(item); } });
    if (isLink) {
        return (React__namespace.default.createElement(Link, __assign({ url: item.url }, linkProps),
            React__namespace.default.createElement(ItemContent, __assign({}, props), !isLink && (React__namespace.default.createElement(Svg, { className: css$C.iconChevron, name: 'IconRightChevron' })))));
    }
    return (React__namespace.default.createElement(Button, __assign({}, buttonProps),
        React__namespace.default.createElement(ItemContent, __assign({}, props), !isLink && (React__namespace.default.createElement(Svg, { className: css$C.iconChevron, name: 'IconRightChevron' })))));
};
var MobileMenuContent = function (_a) {
    var handleButtonClick = _a.handleButtonClick, linkGroup = _a.linkGroup, mainNavItems = _a.mainNavItems, menuItems = _a.menuItems, isActiveLevel = _a.isActiveLevel, _b = _a.endorsedLogoLabel, endorsedLogoLabel = _b === void 0 ? '' : _b;
    var activeHeaderText = React.useContext(HeaderContext).activeHeaderText;
    React.useEffect(function () {
        var _a;
        var activeElement = ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id) || '';
        if (isActiveLevel && activeElement && activeElement !== BACK_BUTTON_ID) {
            setTimeout(function () { var _a; return (_a = document.getElementById(BACK_BUTTON_ID)) === null || _a === void 0 ? void 0 : _a.focus(); }, TRANSLATION_EFFECT_DURATION);
        }
    }, [isActiveLevel]);
    return (React__namespace.default.createElement("nav", { className: classNames__default.default(css$C.contentContainer), "aria-label": activeHeaderText },
        React__namespace.default.createElement("div", null, menuItems
            ? menuItems.map(function (item) { return (React__namespace.default.createElement(SubLevelItem, { handleClick: handleButtonClick, item: item, key: item._uid, isActiveLevel: isActiveLevel })); })
            : mainNavItems &&
                mainNavItems.map(function (item) { return (React__namespace.default.createElement(TopLevelItem, { handleClick: handleButtonClick, item: item, key: item._uid, isActiveLevel: isActiveLevel })); })),
        linkGroup && isActiveLevel && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement("div", { className: css$C.linkGroup }, linkGroup.map(function (link, index) {
                return index === linkGroup.length - 1 ? (React__namespace.default.createElement("div", { className: css$C.signupButton, key: link._uid },
                    React__namespace.default.createElement(StyledLink, __assign({}, link, { type: 'primary' })))) : (React__namespace.default.createElement(TopLevelItem, { handleClick: handleButtonClick, item: link, key: link._uid, className: css$C.mobileMenuLink, isActiveLevel: isActiveLevel }));
            })),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$C.onelineLogo, 'text-center', 'remove-outline') },
                React__namespace.default.createElement(Svg, { name: 'LogoPayPalPrimaryPositiveOneline', ariaLabel: endorsedLogoLabel }))))));
};

var css$A = {"mobileMenu":"styles_mobileMenu__wPVhb","content":"styles_content__KmQIh","levelTwo":"styles_levelTwo__8d528","levelThree":"styles_levelThree__8W2jZ","menuLevelOne":"styles_menuLevelOne__lvHdE","menuLevelTwo":"styles_menuLevelTwo__07iGa","menuLevelThree":"styles_menuLevelThree__y8Dw4","item":"styles_item__KJrgA"};

var MobileMenu = function (_a) {
    var _b;
    var linkGroup = _a.linkGroup, mainNavItems = _a.mainNavItems, backButtonLabel = _a.backButtonLabel, endorsedLogoLabel = _a.endorsedLogoLabel;
    var _c = React.useState(1), activeMenuLevel = _c[0], setActiveMenuLevel = _c[1];
    var _d = React.useState(undefined), previousHeaderText = _d[0], setPreviousHeaderText = _d[1];
    var _e = React.useState([]), activeItemsLevelTwo = _e[0], setActiveItemsLevelTwo = _e[1];
    var _f = React.useState([]), activeItemsLevelThree = _f[0], setActiveItemsLevelThree = _f[1];
    var _g = React.useState(false), levelTwo = _g[0], setLevelTwo = _g[1];
    var _h = React.useState(false), levelThree = _h[0], setLevelThree = _h[1];
    var _j = React.useContext(HeaderContext), activeHeaderText = _j.activeHeaderText, setActiveHeaderText = _j.setActiveHeaderText;
    React.useEffect(function () {
        setActiveHeaderText(undefined);
        setActiveItemsLevelTwo([]);
        setActiveItemsLevelThree([]);
        setActiveMenuLevel(1);
        setLevelTwo(false);
        setLevelThree(false);
    }, []);
    var handleButtonClick = function (items) {
        setActiveHeaderText(items.text);
        switch (activeMenuLevel) {
            case 1:
                setLevelTwo(true);
                setActiveMenuLevel(activeMenuLevel + 1);
                setActiveItemsLevelTwo(items.topLevelMenuItems);
                break;
            case 2:
                setLevelTwo(false);
                setLevelThree(true);
                setActiveMenuLevel(activeMenuLevel + 1);
                setPreviousHeaderText(activeHeaderText);
                setActiveItemsLevelThree(items.subMenuItems);
                break;
        }
    };
    var handleBackClick = function (currentHeaderText) {
        if (activeMenuLevel > 1) {
            setActiveMenuLevel(activeMenuLevel - 1);
            switch (activeMenuLevel) {
                case 2:
                    setLevelTwo(false);
                    setTimeout(function () {
                        var _a;
                        setActiveHeaderText(undefined);
                        setActiveItemsLevelTwo([]);
                        (_a = document.getElementById("menuItem-".concat(currentHeaderText))) === null || _a === void 0 ? void 0 : _a.focus();
                    }, (TRANSLATION_EFFECT_DURATION * 2) / 3);
                    break;
                case 3:
                    setLevelTwo(true);
                    setLevelThree(false);
                    setTimeout(function () {
                        var _a;
                        setActiveHeaderText(previousHeaderText);
                        setPreviousHeaderText(undefined);
                        setActiveItemsLevelThree([]);
                        (_a = document.getElementById("menuItem-".concat(currentHeaderText))) === null || _a === void 0 ? void 0 : _a.focus();
                    }, (TRANSLATION_EFFECT_DURATION * 2) / 3);
            }
        }
    };
    return (React__namespace.default.createElement("div", null,
        React__namespace.default.createElement(MobileOverlay, { handleBackClick: handleBackClick, backButtonLabel: backButtonLabel }),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$A.mobileMenu) },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$A.content, (_b = {},
                    _b[css$A.levelTwo] = levelTwo,
                    _b[css$A.levelThree] = levelThree,
                    _b)) },
                React__namespace.default.createElement("div", { className: classNames__default.default(css$A.menuLevelOne, css$A.item), "aria-hidden": activeMenuLevel !== 1 },
                    React__namespace.default.createElement(MobileMenuContent, { handleButtonClick: handleButtonClick, linkGroup: linkGroup, mainNavItems: mainNavItems, isActiveLevel: activeMenuLevel === 1, endorsedLogoLabel: endorsedLogoLabel })),
                React__namespace.default.createElement("div", { className: classNames__default.default(css$A.menuLevelTwo, css$A.item), "aria-hidden": activeMenuLevel !== 2 },
                    React__namespace.default.createElement(MobileMenuContent, { handleButtonClick: handleButtonClick, menuItems: activeItemsLevelTwo, isActiveLevel: activeMenuLevel === 2 })),
                React__namespace.default.createElement("div", { className: classNames__default.default(css$A.menuLevelThree, css$A.item), "aria-hidden": activeMenuLevel !== 3 },
                    React__namespace.default.createElement(MobileMenuContent, { handleButtonClick: handleButtonClick, menuItems: activeItemsLevelThree, isActiveLevel: activeMenuLevel === 3 }))))));
};

var css$z = {"sideMenuContainer":"styles_sideMenuContainer__OBHu9","overlay":"styles_overlay__lW6en","closed":"styles_closed__Uwge1","open":"styles_open__GmQXO","sideMenu":"styles_sideMenu__xXu8e","topLevelMenu":"styles_topLevelMenu__qgThD","menuContent":"styles_menuContent__fuSAj","slideOut":"styles_slideOut__jlmPi","subLevelMenu":"styles_subLevelMenu__gjerV","hidden":"styles_hidden__aPNuZ","menuItem":"styles_menuItem__7M06T"};

var css$y = {"content":"styles_content__c9xsL","textMenuItem":"styles_textMenuItem__OoEsT","imageMenuItem":"styles_imageMenuItem__4U3o2","menuItem":"styles_menuItem__LAvy7","menuItemContainer":"styles_menuItemContainer__yhewj","active":"styles_active__gjGNg","fontSizeSmall":"styles_fontSizeSmall__HveRt","itemImage":"styles_itemImage__Sg-2Z","iconChevron":"styles_iconChevron__XAsm-"};

var SideMenuContent = function (_a) {
    var buttonHover = _a.buttonHover, _b = _a.fontSizeSmall, fontSizeSmall = _b === void 0 ? false : _b, linkHover = _a.linkHover, items = _a.items;
    var _c = React.useState(undefined), activeItemId = _c[0], setActiveItemId = _c[1];
    React.useEffect(function () {
        setActiveItemId(undefined);
    }, [items]);
    var handleButtonHover = function (item) {
        if (item.subMenuItems.length > 0) {
            setActiveItemId(item._uid);
            buttonHover(item.subMenuItems);
        }
    };
    var handleLinkHover = function () {
        setActiveItemId(undefined);
        linkHover && linkHover();
    };
    /* eslint-disable jsx-a11y/mouse-events-have-key-events */
    return (React__namespace.default.createElement("div", { className: css$y.content }, items.map(function (item) {
        var _a, _b, _c;
        return (React__namespace.default.createElement("div", { className: classNames__default.default(css$y.menuItem, (_a = {},
                _a[css$y.imageMenuItem] = item.image,
                _a[css$y.textMenuItem] = !item.image,
                _a[css$y.fontSizeSmall] = fontSizeSmall,
                _a[css$y.active] = item._uid === activeItemId,
                _a)), key: item._uid },
            item.image && (React__namespace.default.createElement("div", { className: css$y.itemImage, style: {
                    backgroundImage: "url(".concat(item.image.image, ")")
                } })),
            React__namespace.default.createElement("div", { className: classNames__default.default((_b = {},
                    _b[css$y.menuItemContainer] = item.subMenuItems,
                    _b)) }, item.subMenuItems && item.subMenuItems.length > 0 ? (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement("button", null,
                    React__namespace.default.createElement("span", { onMouseOver: function () { return handleButtonHover(item); } }, item.text)),
                React__namespace.default.createElement(Svg, { className: classNames__default.default(css$y.iconChevron, (_c = {},
                        _c[css$y.active] = item._uid === activeItemId,
                        _c)), name: 'IconRightChevron' }))) : (item.url && (React__namespace.default.createElement(Link, { url: item.url, onMouseOver: handleLinkHover }, item.text))))));
    })));
};

var SideMenu = function (_a) {
    var _b, _c, _d, _e, _f;
    var items = _a.items;
    var _g = React.useState(items), activeMenuItems = _g[0], setActiveMenuItems = _g[1];
    var _h = React.useState(false), isSubSideMenuOpen = _h[0], setIsSubSideMenuOpen = _h[1];
    var _j = React.useState(true), hideSubSideMenuOnClose = _j[0], setHideSubSideMenuOnClose = _j[1];
    var _k = React.useState(false), slideOutSubLevel = _k[0], setSlideOutSubLevel = _k[1];
    var _l = React.useState(true), slideOutTopLevel = _l[0], setSlideOutTopLevel = _l[1];
    var _m = React.useState([]), subMenuItems = _m[0], setSubMenuItems = _m[1];
    var _o = React.useContext(HeaderContext), isDesktopMenuOpen = _o.isDesktopMenuOpen, openDesktopMenu = _o.openDesktopMenu, closeSideMenu = _o.closeSideMenu, closeDesktopMenu = _o.closeDesktopMenu;
    React.useEffect(function () {
        var timer1 = setTimeout(function () {
            setSlideOutTopLevel(true);
            openDesktopMenu();
        }, 150);
        var timer2 = setTimeout(function () {
            setHideSubSideMenuOnClose(false);
        }, 600);
        return function () {
            clearTimeout(timer1);
            clearTimeout(timer2);
            closeDesktopMenu();
            closeSideMenu();
        };
    }, []);
    React.useEffect(function () {
        setSubMenuItems([]);
        setIsSubSideMenuOpen(false);
        var timer = setTimeout(function () {
            setSlideOutTopLevel(true);
            setTimeout(function () {
                setActiveMenuItems(items);
                setSlideOutTopLevel(false);
            }, 150);
        }, 150);
        return function () { return clearTimeout(timer); };
    }, [items]);
    var handleButtonHover = function (items) {
        setIsSubSideMenuOpen(true);
        setSlideOutSubLevel(true);
        setTimeout(function () {
            setSubMenuItems(items);
            setSlideOutSubLevel(false);
        }, 150);
    };
    var handleTopLevelLinkHover = function () {
        setSlideOutSubLevel(true);
        setIsSubSideMenuOpen(false);
    };
    var handleOverlayHover = function () {
        closeDesktopMenu();
        closeSideMenu();
    };
    /* eslint-disable jsx-a11y/mouse-events-have-key-events */
    return (React__namespace.default.createElement("div", { className: css$z.sideMenuContainer },
        React__namespace.default.createElement("div", { className: classNames__default.default(css$z.sideMenu, (_b = {},
                _b[css$z.open] = isDesktopMenuOpen,
                _b[css$z.closed] = !isDesktopMenuOpen,
                _b)) },
            React__namespace.default.createElement("div", { className: css$z.topLevelMenu },
                React__namespace.default.createElement("div", { className: classNames__default.default(css$z.menuContent, (_c = {},
                        _c[css$z.slideOut] = slideOutTopLevel,
                        _c)) },
                    React__namespace.default.createElement(SideMenuContent, { buttonHover: handleButtonHover, fontSizeSmall: false, linkHover: handleTopLevelLinkHover, items: activeMenuItems })))),
        isDesktopMenuOpen && (React__namespace.default.createElement("div", { className: classNames__default.default(css$z.subLevelMenu, (_d = {},
                _d[css$z.open] = isSubSideMenuOpen,
                _d[css$z.closed] = !isSubSideMenuOpen,
                _d[css$z.hidden] = hideSubSideMenuOnClose,
                _d)) },
            React__namespace.default.createElement("div", { className: classNames__default.default(css$z.menuContent, (_e = {},
                    _e[css$z.slideOut] = slideOutSubLevel,
                    _e)) },
                React__namespace.default.createElement(SideMenuContent, { buttonHover: handleButtonHover, fontSizeSmall: true, items: subMenuItems })))),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$z.overlay, (_f = {},
                _f[css$z.open] = isDesktopMenuOpen,
                _f[css$z.closed] = !isDesktopMenuOpen,
                _f)), onMouseOver: handleOverlayHover })));
};

var css$x = {"seoContent":"styles_seoContent__72WLl"};

var SeoContent = function (_a) {
    var linkGroup = _a.linkGroup, mainNavItems = _a.mainNavItems;
    return (React__namespace.default.createElement("div", { className: css$x.seoContent },
        linkGroup &&
            linkGroup.map(function (_a) {
                var text = _a.text, url = _a.url, _uid = _a._uid;
                return (React__namespace.default.createElement(Link, { url: url, key: _uid, tabIndex: -1, "aria-hidden": true }, text));
            }),
        mainNavItems.map(function (_a) {
            var topLevelMenuItems = _a.topLevelMenuItems, text = _a.text, url = _a.url, _uid = _a._uid;
            return (React__namespace.default.createElement(React__namespace.default.Fragment, { key: _uid },
                url && (url.url || url.cached_url) && (React__namespace.default.createElement(Link, { url: url, tabIndex: -1, "aria-hidden": true }, text)),
                topLevelMenuItems &&
                    topLevelMenuItems.length > 0 &&
                    topLevelMenuItems.map(function (_a) {
                        var subMenuItems = _a.subMenuItems, text = _a.text, url = _a.url, _uid = _a._uid;
                        return (React__namespace.default.createElement(React__namespace.default.Fragment, { key: _uid },
                            url && (url.url || url.cached_url) && (React__namespace.default.createElement(Link, { url: url, tabIndex: -1, "aria-hidden": true }, text)),
                            subMenuItems &&
                                subMenuItems.length > 0 &&
                                subMenuItems.map(function (_a) {
                                    var text = _a.text, url = _a.url, _uid = _a._uid;
                                    return url && (React__namespace.default.createElement(Link, { url: url, key: _uid, tabIndex: -1, "aria-hidden": true }, text));
                                })));
                    })));
        })));
};

var css$w = {"header":"styles_header__i8HNO","headerContainer":"styles_headerContainer__2J-8X","desktopHeader":"styles_desktopHeader__aEHyZ","mobileHeader":"styles_mobileHeader__bKO-0","skipLinks":"styles_skipLinks__UQaQp","overlay":"styles_overlay__Ixnwf","mobileMenuOpen":"styles_mobileMenuOpen__cJg8B","desktopMenuOpen":"styles_desktopMenuOpen__hORWi"};

var Header = function (_a) {
    var _b;
    var linkGroup = _a.linkGroup, logo = _a.logo, logoLink = _a.logoLink, logoLinkLabel = _a.logoLinkLabel, mainNavItems = _a.mainNavItems, cramHeaderItems = _a.cramHeaderItems, _c = _a.toggleNavMenuLabel, toggleNavMenuLabel = _c === void 0 ? 'Toggle navigation menu' : _c, backButtonLabel = _a.backButtonLabel, _d = _a.pagesNavLabel, pagesNavLabel = _d === void 0 ? 'Pages' : _d, _e = _a.skipToContentLabel, skipToContentLabel = _e === void 0 ? 'Skip to main content' : _e, _f = _a.endorsedLogoLabel, endorsedLogoLabel = _f === void 0 ? 'Zettle by PayPal Logo' : _f, _g = _a.rootNode, rootNode = _g === void 0 ? '#__next' : _g, rest = __rest(_a, ["linkGroup", "logo", "logoLink", "logoLinkLabel", "mainNavItems", "cramHeaderItems", "toggleNavMenuLabel", "backButtonLabel", "pagesNavLabel", "skipToContentLabel", "endorsedLogoLabel", "rootNode"]);
    var _h = React.useContext(HeaderContext), isMobileMenuOpen = _h.isMobileMenuOpen, setIsMobileMenuOpen = _h.setIsMobileMenuOpen, closeSideMenu = _h.closeSideMenu, setHeaderHeight = _h.setHeaderHeight, isSideMenuOpen = _h.isSideMenuOpen, setIsSideMenuOpen = _h.setIsSideMenuOpen, activeMenuItems = _h.activeMenuItems, setActiveMenuItems = _h.setActiveMenuItems, activeMainMenuItem = _h.activeMainMenuItem, setActiveMainMenuItem = _h.setActiveMainMenuItem;
    var headerRef = React.createRef();
    React.useEffect(function () {
        var body = document.body;
        isSideMenuOpen
            ? body.classList.add('isDesktopMenuOpen')
            : body.classList.remove('isDesktopMenuOpen');
        isMobileMenuOpen
            ? body.classList.add('isMobileMenuOpen')
            : body.classList.remove('isMobileMenuOpen');
    }, [isMobileMenuOpen, isSideMenuOpen]);
    React.useEffect(function () {
        if (isMobileMenuOpen) {
            closeSideMenu();
        }
    }, [isMobileMenuOpen]);
    React.useEffect(function () {
        headerRef.current && setHeaderHeight(headerRef.current.clientHeight);
    }, [headerRef]);
    var handleHover = function (items, item) {
        setIsSideMenuOpen(true);
        setActiveMenuItems(items);
        setActiveMainMenuItem(item);
    };
    React.useEffect(function () {
        Modal__default.default.setAppElement(rootNode);
    }, []);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("header", __assign({ className: css$w.header, ref: headerRef }, react.storyblokEditable(rest)),
            React__namespace.default.createElement("div", { className: css$w.skipLinks },
                React__namespace.default.createElement("a", { href: "#main", className: classNames__default.default('styled-button', 'styled-button-primary-floating'), tabIndex: 0 }, skipToContentLabel),
                React__namespace.default.createElement(Button, { tabIndex: 0, className: classNames__default.default('styled-button', 'styled-button-secondary-floating'), onPress: function () {
                        setIsMobileMenuOpen(true);
                    } }, toggleNavMenuLabel)),
            React__namespace.default.createElement(SeoContent, { linkGroup: linkGroup, mainNavItems: mainNavItems }),
            React__namespace.default.createElement("div", { className: css$w.headerContainer },
                React__namespace.default.createElement("div", { className: css$w.desktopHeader },
                    React__namespace.default.createElement(DesktopNav, { closeSideMenu: closeSideMenu, handleHover: handleHover, linkGroup: linkGroup, logo: logo, logoLink: logoLink, mainNavItems: mainNavItems, activeMainMenuItem: activeMainMenuItem, cramHeaderItems: cramHeaderItems, logoLinkLabel: logoLinkLabel, isDisabled: isMobileMenuOpen })),
                React__namespace.default.createElement("div", { className: css$w.mobileHeader },
                    React__namespace.default.createElement(MobileNav, { linkGroup: linkGroup, logoLink: logoLink, logoLinkLabel: logoLinkLabel, toggleNavMenuLabel: toggleNavMenuLabel, pagesNavLabel: pagesNavLabel })))),
        isSideMenuOpen && (React__namespace.default.createElement("div", { "aria-hidden": true, className: classNames__default.default((_b = {},
                _b[css$w.desktopMenuOpen] = isSideMenuOpen,
                _b)) },
            React__namespace.default.createElement(SideMenu, { items: activeMenuItems }))),
        React__namespace.default.createElement(Modal__default.default, { isOpen: isMobileMenuOpen, onRequestClose: function () { return setIsMobileMenuOpen(false); }, overlayClassName: css$w.overlay, className: css$w.mobileMenuOpen },
            React__namespace.default.createElement(MobileMenu, { linkGroup: linkGroup, mainNavItems: mainNavItems, backButtonLabel: backButtonLabel, endorsedLogoLabel: endorsedLogoLabel }))));
};

var WebNextComponents$1 = buildComponentsObject(__assign(__assign({}, sharedComponents), { Accordion: Accordion, Disclaimer: Disclaimer, Footer: Footer, Header: Header }));
var Global = function (_a) {
    var _b = _a.global, global = _b === void 0 ? [] : _b;
    if (global.length === 0) {
        return React__namespace.default.createElement("div", null);
    }
    return global.map(function (content) {
        return React__namespace.default.createElement(WebNextComponents$1[content.component], __assign({ key: content._uid }, content));
    });
};

var GlobalReference = function (_a) {
    var _b;
    var reference = _a.reference, locationData = _a.locationData;
    if (typeof reference === 'string') {
        if (reference !== '') {
            return React__namespace.default.createElement("div", null, "You need to save to load in the reference");
        }
        return React__namespace.default.createElement("div", null);
    }
    var content = reference ? __assign({}, reference.content) : undefined;
    if (((_b = content === null || content === void 0 ? void 0 : content.global) === null || _b === void 0 ? void 0 : _b[0]) && locationData) {
        content.global[0].locationData = locationData;
    }
    return React__namespace.default.createElement(Global, __assign({}, content));
};

var css$v = {"iframeContainer":"styles_iframeContainer__5jAYg","iframe":"styles_iframe__i5o6H","onetrustdsr":"styles_onetrustdsr__Eeq45"};

var Iframe = function (_a) {
    var _b;
    var url = _a.url, theme = _a.theme, title = _a.title, layout = _a.layout, rest = __rest(_a, ["url", "theme", "title", "layout"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$v.iframeContainer, (_b = {},
                _b[css$v.onetrustdsr] = theme === 'onetrustdsr',
                _b)) },
            React__namespace.default.createElement("iframe", { src: url, className: css$v.iframe, title: title }))));
};

var css$u = {"spinner":"styles_spinner__GXaiE","circle":"styles_circle__Ju6eG","circle1":"styles_circle1__uqdIl","circle2":"styles_circle2__NzNjh","circle3":"styles_circle3__QHi5a","circle4":"styles_circle4__cSuU3","load":"styles_load__6-DWM"};

var Spinner = function () { return (React__namespace.default.createElement("div", { className: css$u.spinner },
    React__namespace.default.createElement("div", { className: classNames__default.default(css$u.circle, css$u.circle1) }),
    React__namespace.default.createElement("div", { className: classNames__default.default(css$u.circle, css$u.circle2) }),
    React__namespace.default.createElement("div", { className: classNames__default.default(css$u.circle, css$u.circle3) }),
    React__namespace.default.createElement("div", { className: classNames__default.default(css$u.circle, css$u.circle4) }))); };

var ComponentLoader = function (_a) {
    var load = _a.load, _b = _a.throwOnLoadError, throwOnLoadError = _b === void 0 ? true : _b, _c = _a.loadErrorMessage, loadErrorMessage = _c === void 0 ? 'Could not load the component.' : _c, children = _a.children;
    var _d = React.useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = React.useState(false), failedToLoad = _e[0], setFailedToLoad = _e[1];
    var _f = React.useState({}), result = _f[0], setResult = _f[1];
    React.useEffect(function () {
        var isMounted = true;
        var promises = Object.keys(load).map(function (key) {
            return load[key].then(function (data) { return [key, data]; });
        });
        Promise.all(promises)
            .then(function (results) {
            if (isMounted) {
                setIsLoading(false);
                setResult(results.reduce(function (agg, _a) {
                    var _b;
                    var key = _a[0], data = _a[1];
                    return (__assign(__assign({}, agg), (_b = {}, _b[key] = data, _b)));
                }, {}));
            }
        })
            .catch(function (err) {
            if (isMounted) {
                setIsLoading(false);
                setFailedToLoad(true);
                if (throwOnLoadError) {
                    throw err;
                }
            }
        });
        return function () {
            isMounted = false;
        };
    }, []);
    if (failedToLoad) {
        return React__namespace.default.createElement("p", null, loadErrorMessage);
    }
    if (isLoading) {
        return React__namespace.default.createElement(Spinner, null);
    }
    if (React__namespace.default.isValidElement(children)) {
        return React__namespace.default.cloneElement(React.Children.only(children), result);
    }
    return React__namespace.default.createElement(React__namespace.default.Fragment, null);
};

var extractOrigin = function (url) {
    var parsedUrl = queryString__default.default.parseUrl(url);
    return parsedUrl.url;
};
var addTrackingQueryParams = function (url, queryParams) {
    var parsedUrl = queryString__default.default.parseUrl(url, { parseFragmentIdentifier: true });
    var mergedQueryParams = __assign(__assign(__assign({}, parsedUrl.query), queryString__default.default.parse(window.location.search)), queryParams);
    return queryString__default.default.stringifyUrl({
        url: parsedUrl.url,
        query: mergedQueryParams,
        fragmentIdentifier: parsedUrl.fragmentIdentifier
    });
};

var iframeOrigins = [
    'https://pi.pardot.com',
    'https://discover.zettle.com',
    'https://no.zettle.com',
    'https://se.zettle.com',
    'https://dk.zettle.com',
    'https://fi.zettle.com',
    'https://de.zettle.com',
    'https://nl.zettle.com',
    'https://gb.zettle.com',
    'https://fr.zettle.com',
    'https://es.zettle.com',
    'https://it.zettle.com',
    'https://br.zettle.com',
    'https://mx.zettle.com'
];
var IframeAutoresize = function (_a) {
    var title = _a.title, src = _a.src, className = _a.className;
    var _b = React.useState(true), scrolling = _b[0], setScrolling = _b[1];
    var onMessage = function () {
        setScrolling(false);
    };
    return (React__namespace.default.createElement(IframeResizer__default.default, { title: title, src: src, className: className, scrolling: scrolling, onMessage: onMessage, checkOrigin: iframeOrigins, style: { overflowX: scrolling ? 'hidden' : 'auto' } }));
};

var IframeWithTracking = function (_a) {
    var url = _a.url, sessionId = _a.sessionId, clientId = _a.clientId, className = _a.className;
    return (React__namespace.default.createElement(IframeAutoresize, { className: className, src: addTrackingQueryParams(url, {
            session_id: sessionId,
            client_id: clientId,
            referrer: extractOrigin(window.location.href)
        }) }));
};

/*
 * Wrap setTimeout in a promise
 *
 * resolve is called without arguments. No value is returned from
 * the later function. Only the delay is ensured.
 */
var later = function (delay, param) {
    return new Promise(function (resolve, reject) {
        return setTimeout(function () {
            try {
                resolve(param);
            }
            catch (err) {
                reject(err);
            }
        }, delay);
    });
};

// Attempt an action in intervals over a set duration
var attempt = function (totalTime, delay, action) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1, timeLeft_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 1, , 3]);
                return [2 /*return*/, action()];
            case 1:
                err_1 = _a.sent();
                timeLeft_1 = totalTime - delay;
                if (timeLeft_1 <= 0) {
                    throw err_1;
                }
                return [4 /*yield*/, later(delay).then(function () { return attempt(timeLeft_1, delay, action); })];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/];
        }
    });
}); };

var getClientId = function () {
    return attempt(10000, 300, function () { return window.ga.getAll().map(function (tracker) { return tracker.get('clientId'); })[0]; }).catch(function () { return 'not-available'; });
};
var generateRandomId = function () {
    return "".concat(new Date().getTime(), ".").concat(Math.random().toString(36).substring(5));
};
var sessionIdCookieName = 'ga_session_id';
var getSessionId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var sessionId;
    return __generator(this, function (_a) {
        sessionId = Cookies__default.default.get(sessionIdCookieName);
        if (!sessionId) {
            sessionId = generateRandomId();
            Cookies__default.default.set(sessionIdCookieName, sessionId);
        }
        return [2 /*return*/, sessionId];
    });
}); };
var getVisitorId = function () {
    return attempt(10000, 300, function () { return window.pi.tracker.visitor_id; }).catch(function () { return 'not-available'; });
};

var css$t = {"pardotIframe":"styles_pardotIframe__-DdW-","iframe":"styles_iframe__IG3Xx","hasContent":"styles_hasContent__-pd-h","description":"styles_description__-yx7M"};

var PardotIframe = function (_a) {
    var _b;
    var url = _a.url, content = _a.content, loadErrorMessage = _a.loadErrorMessage, layout = _a.layout, rest = __rest(_a, ["url", "content", "loadErrorMessage", "layout"]);
    var html = renderStoryblokRichText(content);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$t.pardotIframe, (_b = {},
                _b[css$t.hasContent] = html,
                _b)) },
            html && (React__namespace.default.createElement("div", { className: css$t.description },
                React__namespace.default.createElement(Html, { html: html }))),
            React__namespace.default.createElement(ComponentLoader, { load: {
                    sessionId: getSessionId(),
                    clientId: getClientId(),
                    visitorId: getVisitorId()
                }, throwOnLoadError: true, loadErrorMessage: loadErrorMessage },
                React__namespace.default.createElement(IframeWithTracking, { url: url, className: css$t.iframe })))));
};

var css$s = {"heading":"styles_heading__gKuu-","cardContainer":"styles_cardContainer__miOqN","link":"styles_link__Rn0Bq","card":"styles_card__KH8o0","cardText":"styles_cardText__xRSQy","arrow":"styles_arrow__61ZIc"};

var QuickStart = function (_a) {
    var heading = _a.heading, layout = _a.layout, _b = _a.links, links = _b === void 0 ? [] : _b, rest = __rest(_a, ["heading", "layout", "links"]);
    var ottoIcons = useOttoIcons().ottoIcons;
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        heading && React__namespace.default.createElement("h2", { className: css$s.heading }, heading),
        React__namespace.default.createElement("div", { className: css$s.cardContainer }, links.length > 0 &&
            links.map(function (_a) {
                var text = _a.text, url = _a.url, _uid = _a._uid, ottoIcon = _a.ottoIcon;
                return (React__namespace.default.createElement(Link, { key: _uid, url: url, className: classNames__default.default(css$s.link, 'focus-otto') },
                    React__namespace.default.createElement("div", { className: css$s.card },
                        React__namespace.default.createElement("span", { className: css$s.cardText }, text),
                        isOttoIconBlock(ottoIcon) &&
                            isOttoIconData(ottoIcons[String(ottoIcon[0].icon)]) ? (React__namespace.default.createElement(OttoIcon, __assign({}, ottoIcon[0], { icon: ottoIcons[String(ottoIcon[0].icon)] }))) : null)));
            }))));
};

var css$r = {"container":"styles_container__j7ctC","textContainer":"styles_textContainer__G7A7C","headline":"styles_headline__nqC0R","subTitle":"styles_subTitle__YUfec","linkText":"styles_linkText__Q1M-h","arrowButton":"styles_arrowButton__QCMTM","arrowIcon":"styles_arrowIcon__1mOxQ","videoContainer":"styles_videoContainer__EDKrY"};

var VideoHero = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, videoContainer = _a.videoContainer, anchorLinkText = _a.anchorLinkText, anchorLinkSectionId = _a.anchorLinkSectionId, layout = _a.layout, rest = __rest(_a, ["title", "subTitle", "videoContainer", "anchorLinkText", "anchorLinkSectionId", "layout"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], { noMaxWidth: true }, react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$r.container },
            React__namespace.default.createElement("div", { className: css$r.textContainer },
                title && (React__namespace.default.createElement("h1", { className: classNames__default.default('large-headline', css$r.headline) }, title)),
                subTitle && (React__namespace.default.createElement("p", { className: classNames__default.default('large-text-block', css$r.subTitle) }, subTitle)),
                anchorLinkText && anchorLinkSectionId && (React__namespace.default.createElement(AnchorLink, { to: anchorLinkSectionId },
                    React__namespace.default.createElement("p", { className: css$r.linkText }, anchorLinkText),
                    React__namespace.default.createElement("div", { className: css$r.arrowButton },
                        React__namespace.default.createElement(Svg, { name: 'ArrowRight', className: css$r.arrowIcon }))))),
            React__namespace.default.createElement("div", { className: css$r.videoContainer },
                React__namespace.default.createElement(VideoContainer, __assign({}, videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer[0]))))));
};

var css$q = {"styledLinkSection":"styles_styledLinkSection__jh1-Y","left":"styles_left__qKbvV","center":"styles_center__UfkiB","right":"styles_right__DZZCD"};

var StyledLinkSection = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b, _c = _a.layout, layout = _c === void 0 ? [] : _c, alignment = _a.alignment, rest = __rest(_a, ["links", "layout", "alignment"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$q.styledLinkSection, css$q[alignment]) }, links.map(function (link) { return (React__namespace.default.createElement(StyledLink, __assign({ key: link._uid }, link))); }))));
};

var Components = buildComponentsObject({
    Hero: Hero,
    Iframe: Iframe,
    PardotIframe: PardotIframe,
    QuickStart: QuickStart,
    Richtext: Richtext,
    VideoHero: VideoHero,
    StyledLinkSection: StyledLinkSection
});

var EmbeddedComponents = function (_a) {
    var blocks = _a.blocks, fullSlug = _a.fullSlug, baseUrl = _a.baseUrl;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, blocks &&
        blocks.map(function (block) {
            return React__namespace.default.createElement(Components[block.component], __assign(__assign({ key: block._uid }, block), { fullSlug: fullSlug, baseUrl: baseUrl }));
        })));
};

var GoogleOptimizeVariant = function (_a) {
    var variantId = _a.variantId, blocks = _a.blocks, fullSlug = _a.fullSlug, baseUrl = _a.baseUrl;
    // skip JSX to avoid TS errors
    return React__namespace.default.createElement(reactOptimize.Variant, { id: variantId }, React__namespace.default.createElement(EmbeddedComponents, { blocks: blocks, fullSlug: fullSlug, baseUrl: baseUrl }));
};

var isStoryblok = function () {
    return typeof window !== 'undefined' && 'storyblok' in window;
};

var css$p = {"internalMessage":"styles_internalMessage__NWOtQ","disclaimer":"styles_disclaimer__ZG2sO"};

var InternalMessage = function (_a) {
    var title = _a.title, description = _a.description;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$p.internalMessage, 'salmon-dark', 'last-element-nospace') },
        React__namespace.default.createElement("h2", null, title),
        description && React__namespace.default.createElement("h3", null, description),
        React__namespace.default.createElement("p", { className: css$p.disclaimer }, "This is an internal message and will not be visible on published pages.")));
};

var GoogleOptimizeExperiment = function (_a) {
    var experimentId = _a.experimentId, original = _a.original, variants = _a.variants, _b = _a.fullSlug, fullSlug = _b === void 0 ? '' : _b, _c = _a.baseUrl, baseUrl = _c === void 0 ? '' : _c, _d = _a.internal, internal = _d === void 0 ? false : _d;
    var _e = React.useState(false), isMounted = _e[0], setIsMounted = _e[1];
    var _f = React.useState(internal), inEditor = _f[0], setInEditor = _f[1];
    React.useEffect(function () {
        if (experimentId) {
            setIsMounted(true);
        }
        if (isStoryblok()) {
            setInEditor(true);
        }
    }, []);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        !isMounted && (React__namespace.default.createElement(EmbeddedComponents, { blocks: original, fullSlug: fullSlug, baseUrl: baseUrl })),
        isMounted && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            inEditor && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(InternalMessage, { title: "Google Optimize Experiment ".concat(experimentId), description: "Original (Variant 0)" }),
                React__namespace.default.createElement(EmbeddedComponents, { blocks: original, fullSlug: fullSlug, baseUrl: baseUrl }),
                variants &&
                    variants.map(function (variant, index) { return (React__namespace.default.createElement("div", { key: index + 1 },
                        React__namespace.default.createElement(InternalMessage, { title: "Google Optimize Experiment ".concat(experimentId), description: "Variant ".concat(index + 1) }),
                        React__namespace.default.createElement(EmbeddedComponents, __assign({}, variant, { fullSlug: fullSlug, baseUrl: baseUrl })))); }))),
            !inEditor &&
                // skip JSX to avoid TS errors
                React__namespace.default.createElement(reactOptimize.Experiment, { id: experimentId }, React__namespace.default.createElement(React__namespace.default.Fragment, null,
                    React__namespace.default.createElement(GoogleOptimizeVariant, { blocks: original, variantId: "0", fullSlug: fullSlug, baseUrl: baseUrl }),
                    variants &&
                        variants.map(function (variant, index) { return (React__namespace.default.createElement(GoogleOptimizeVariant, __assign({ key: index + 1 }, variant, { variantId: "".concat(index + 1), fullSlug: fullSlug, baseUrl: baseUrl }))); })))))));
};

var useClickOutside = function (ref, cb) {
    React.useEffect(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            cb(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, cb]);
};

var css$o = {"variableLilac80":"#5538ba","container":"styles_container__JrRJU","tooltip":"styles_tooltip__oBxDp","left":"styles_left__pcBq8","right":"styles_right__f-PAN","showTooltip":"styles_showTooltip__qzHVH"};

var Tooltip = function (_a) {
    var _b;
    var text = _a.text, id = _a.id, _c = _a.align, align = _c === void 0 ? 'right' : _c, iconName = _a.iconName, className = _a.className, iconLabel = _a.iconLabel;
    var ottoIcons = useOttoIcons().ottoIcons;
    var _d = React.useState(false), showTooltip = _d[0], setShowTooltip = _d[1];
    var tooltipRef = React.useRef(null);
    useClickOutside(tooltipRef, function () { return setShowTooltip(false); });
    reactUse.useKey('Escape', function () { return setShowTooltip(false); });
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$o.container, className, (_b = {},
            _b[css$o.showTooltip] = showTooltip,
            _b)), onTouchStart: function () { return setShowTooltip(!showTooltip); }, onFocus: function () { return setShowTooltip(true); }, onBlur: function () { return setShowTooltip(false); }, tabIndex: 0, role: "button", "aria-label": iconLabel, "aria-describedby": id },
        React__namespace.default.createElement("span", { className: classNames__default.default(css$o.tooltip, css$o[align]), id: id, ref: tooltipRef, "aria-hidden": true, role: "tooltip" }, text),
        isOttoIconName(iconName) && (React__namespace.default.createElement(OttoIcon, { color: css$o.variableLilac80, nonStandardSizeOverride: exports.OttoIconSizes.ExtraSmall, icon: ottoIcons[iconName] }))));
};

var css$n = {"item":"styles_item__twzA1","labelContainer":"styles_labelContainer__8fEUa","label":"styles_label__db84y","price":"styles_price__Elv-a"};

var PriceItem = function (_a) {
    var _b;
    var label = _a.label, price = _a.price, suffix = _a.suffix, tooltip = _a.tooltip, alignTooltip = _a.alignTooltip, _c = _a.iconLabelTooltip, iconLabelTooltip = _c === void 0 ? 'info' : _c, ottoIconTooltip = _a.ottoIconTooltip, _uid = _a._uid;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: css$n.item },
        React__namespace.default.createElement("div", { className: css$n.labelContainer },
            React__namespace.default.createElement("p", { className: classNames__default.default('mini-headline', css$n.label) }, label),
            tooltip && (React__namespace.default.createElement(Tooltip, { text: tooltip, align: alignTooltip, id: 'tooltip' + _uid, iconLabel: iconLabelTooltip, iconName: ottoIconTooltip }))),
        React__namespace.default.createElement("p", { className: classNames__default.default('mega-text-block', css$n.price) },
            pricing.getPrice(price === null || price === void 0 ? void 0 : price.location, (_b = price === null || price === void 0 ? void 0 : price.product) === null || _b === void 0 ? void 0 : _b.product),
            React__namespace.default.createElement(FootnoteRef, { name: price === null || price === void 0 ? void 0 : price.disclaimer }),
            suffix && suffix)));
};

var css$m = {"item":"styles_item__dyqCR","label":"styles_label__CNnIz","labelContainer":"styles_labelContainer__VflIu","price":"styles_price__IIz5-"};

var PriceItemSmall = function (_a) {
    var _b;
    var label = _a.label, price = _a.price, suffix = _a.suffix;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: css$m.item },
        React__namespace.default.createElement("div", { className: css$m.labelContainer },
            React__namespace.default.createElement("p", { className: css$m.label }, label)),
        React__namespace.default.createElement("p", { className: css$m.price },
            pricing.getPrice(price === null || price === void 0 ? void 0 : price.location, (_b = price === null || price === void 0 ? void 0 : price.product) === null || _b === void 0 ? void 0 : _b.product),
            suffix && suffix)));
};

var css$l = {"item":"styles_item__fa3rD","priceOnly":"styles_priceOnly__qGl5G"};

var PriceItemOnly = function (_a) {
    var _b;
    var price = _a.price, suffix = _a.suffix;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: css$l.item },
        React__namespace.default.createElement("p", { className: classNames__default.default('large-headline', css$l.priceOnly) },
            pricing.getPrice(price === null || price === void 0 ? void 0 : price.location, (_b = price === null || price === void 0 ? void 0 : price.product) === null || _b === void 0 ? void 0 : _b.product),
            suffix && suffix)));
};

var css$k = {"container":"styles_container__nExNY","heading":"styles_heading__KpVxf","infoHeading":"styles_infoHeading__lJGSK","text":"styles_text__kx9Nj"};

var posterItemComponents = {
    list: List,
    'price-item': PriceItem,
    'price-item-small': PriceItemSmall,
    'price-item-only': PriceItemOnly,
    richtext: Richtext
};
var InfoPoster = function (_a) {
    var heading = _a.heading, text = _a.text, posterItems = _a.posterItems, link = _a.link, infoHeading = _a.infoHeading, infoText = _a.infoText;
    return (React__namespace.default.createElement("div", { className: classNames__default.default('white', css$k.container) },
        React__namespace.default.createElement("h2", { className: classNames__default.default('default-headline', css$k.heading) }, heading),
        React__namespace.default.createElement("p", { className: classNames__default.default('default-text-block', css$k.text) }, text),
        posterItems[0] &&
            posterItems.map(function (_a) {
                var component = _a.component, _uid = _a._uid, item = __rest(_a, ["component", "_uid"]);
                var Component = posterItemComponents[component];
                return Component && React__namespace.default.createElement(Component, __assign({ key: _uid, _uid: _uid }, item));
            }),
        infoHeading && (React__namespace.default.createElement("h3", { className: classNames__default.default('mini-headline', css$k.infoHeading) }, infoHeading)),
        infoText && React__namespace.default.createElement("p", { className: "default-text-block" }, infoText),
        link[0] && (React__namespace.default.createElement(StyledLink, __assign({}, link[0], { className: "background-independent" })))));
};

var css$j = {"container":"styles_container__4uA3w","gridWidthSmallScreens":"styles_gridWidthSmallScreens__fVRGO","poster":"styles_poster__o8zBD","link":"styles_link__30m3r"};

var InfoPosterGroup = function (_a) {
    var _b = _a.infoPosters, infoPosters = _b === void 0 ? [] : _b, layout = _a.layout, rest = __rest(_a, ["infoPosters", "layout"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: css$j.container }, (infoPosters === null || infoPosters === void 0 ? void 0 : infoPosters.length) > 0 &&
            infoPosters.map(function (poster) { return (React__namespace.default.createElement("div", { className: css$j.poster, key: poster === null || poster === void 0 ? void 0 : poster._uid },
                React__namespace.default.createElement(InfoPoster, __assign({}, poster)))); }))));
};

var css$i = {"integrationsList":"styles_integrationsList__QhKFE","textContainer":"styles_textContainer__Uxofq","integrations":"styles_integrations__VYrsR","integrations-last-row-1":"styles_integrations-last-row-1__sIv98","integrations-last-row-2":"styles_integrations-last-row-2__f04Ju","integrations-last-row-3":"styles_integrations-last-row-3__KiU8O","integrations-last-row-0":"styles_integrations-last-row-0__C49Yu"};

var css$h = {"item":"styles_item__WygQ3","logo":"styles_logo__0Ccxq","text":"styles_text__TA0qj","type":"styles_type__LYg5O"};

var IntegrationItem = function (_a) {
    var _b;
    var _uid = _a._uid, logo = _a.logo, name = _a.name, integrationType = _a.integrationType, onOpen = _a.onOpen;
    var openItem = function () {
        if (onOpen)
            onOpen(_uid);
    };
    var handleKeyPress = function (event) {
        if ((event.charCode === 13 || event.charCode === 32) && onOpen) {
            onOpen(_uid);
        }
    };
    return (React__namespace.default.createElement("div", { className: css$h.item, onClick: openItem, onKeyPress: handleKeyPress, role: "button", tabIndex: 0 },
        React__namespace.default.createElement("div", { className: css$h.logo },
            React__namespace.default.createElement("div", null, logo && logo.image && (React__namespace.default.createElement(AdvanceImage, { src: logo.image, maxWidth: 300, alt: logo.alt_tag, quality: logo.quality, "aria-hidden": true })))),
        React__namespace.default.createElement("div", { className: css$h.text },
            name && React__namespace.default.createElement("div", { className: css$h.name }, name),
            integrationType && (React__namespace.default.createElement("div", { className: css$h.type },
                " ", (_b = integrationType.option) === null || _b === void 0 ? void 0 :
                _b.value)))));
};

var css$g = {"overlay":"styles_overlay__FLrGo","modal":"styles_modal__O2pfB","modalContentWrapper":"styles_modalContentWrapper__YCLWh","modalContent":"styles_modalContent__8g9wj","logo":"styles_logo__x41Ou","topContent":"styles_topContent__G44BM","modalText":"styles_modalText__WFF06","modalType":"styles_modalType__3sJff","description":"styles_description__B77Wp","modalRichText":"styles_modalRichText__w5XxG","closeLink":"styles_closeLink__sj3hA","closeIcon":"styles_closeIcon__CbN0m"};

var OpenedItem = function (_a) {
    var _b, _c, _d;
    var item = _a.item, onClose = _a.onClose, closeTitle = _a.closeTitle, _e = _a.rootNode, rootNode = _e === void 0 ? '#__next' : _e;
    React.useEffect(function () {
        Modal__default.default.setAppElement(rootNode);
    }, []);
    return (React__namespace.default.createElement(Modal__default.default, { isOpen: Boolean(item === null || item === void 0 ? void 0 : item._uid), onRequestClose: onClose, overlayClassName: css$g.overlay, className: css$g.modal, aria: (item === null || item === void 0 ? void 0 : item._uid) ? { labelledby: "title_".concat(item._uid) } : {} },
        React__namespace.default.createElement("div", { className: css$g.modalContentWrapper },
            React__namespace.default.createElement("div", { className: css$g.modalContent },
                React__namespace.default.createElement("div", { className: css$g.topContent },
                    React__namespace.default.createElement("div", { className: css$g.logo },
                        React__namespace.default.createElement("div", null, ((_b = item === null || item === void 0 ? void 0 : item.logo) === null || _b === void 0 ? void 0 : _b.image) && (React__namespace.default.createElement(AdvanceImage, { src: item.logo.image, maxWidth: 300, alt: item.logo.alt_tag, quality: item.logo.quality, "aria-hidden": true })))),
                    React__namespace.default.createElement("div", { className: css$g.modalText },
                        (item === null || item === void 0 ? void 0 : item.name) && (React__namespace.default.createElement("div", { id: "title_".concat(item._uid), className: 'large-text-block' }, item.name)),
                        (item === null || item === void 0 ? void 0 : item.integrationType) && (React__namespace.default.createElement("div", { className: classNames__default.default('large-text-block', css$g.modalType) }, (_d = (_c = item.integrationType) === null || _c === void 0 ? void 0 : _c.option) === null || _d === void 0 ? void 0 : _d.value)))),
                React__namespace.default.createElement("div", { className: css$g.description }, (item === null || item === void 0 ? void 0 : item.description) && (React__namespace.default.createElement(Richtext, { body: item.description, className: css$g.modalRichText }))),
                React__namespace.default.createElement("button", { "aria-labelledby": "close-btn-".concat(item === null || item === void 0 ? void 0 : item._uid), className: classNames__default.default('styled-link', css$g.closeLink), onClick: onClose },
                    React__namespace.default.createElement("span", { id: "close-btn-".concat(item === null || item === void 0 ? void 0 : item._uid), "aria-hidden": true }, closeTitle),
                    React__namespace.default.createElement("div", { className: css$g.closeIcon, "aria-hidden": true },
                        React__namespace.default.createElement("span", null)))))));
};

var IntegrationsList = function (_a) {
    var heading = _a.heading, body = _a.body, _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.layout, layout = _c === void 0 ? [] : _c, rootNode = _a.rootNode, closeTitle = _a.closeTitle, rest = __rest(_a, ["heading", "body", "items", "layout", "rootNode", "closeTitle"]);
    var _d = React.useState(''), openedItemId = _d[0], setOpenedItemId = _d[1];
    var openedItem = items.find(function (item) { return item._uid === openedItemId; });
    var sortedItems = items.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    var onModalClose = function (e) {
        e.preventDefault();
        setOpenedItemId('');
    };
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
            React__namespace.default.createElement("div", { className: css$i.integrationsList },
                React__namespace.default.createElement("div", { className: css$i.textContainer },
                    heading && React__namespace.default.createElement("h2", { className: 'default-headline' }, heading),
                    body && React__namespace.default.createElement(Richtext, { body: body })),
                React__namespace.default.createElement("div", { className: classNames__default.default(css$i.integrations, css$i["integrations-last-row-".concat(items.length % 4)]) }, sortedItems.length > 0 &&
                    sortedItems.map(function (item) {
                        return (React__namespace.default.createElement(IntegrationItem, __assign({ key: item._uid, onOpen: setOpenedItemId }, item)));
                    })))),
        React__namespace.default.createElement(OpenedItem, { item: openedItem, onClose: onModalClose, rootNode: rootNode, closeTitle: closeTitle })));
};

var css$f = {"linkContainer":"styles_linkContainer__WKTBb","linkItem":"styles_linkItem__pSCUo","arrow":"styles_arrow__epg7W","two-col":"styles_two-col__ErMBJ"};

var LinkGroup = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b, columns = _a.columns, layout = _a.layout, rest = __rest(_a, ["links", "columns", "layout"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$f[columns], css$f.linkContainer) }, links.length > 0 &&
            links.map(function (_a) {
                var _uid = _a._uid, text = _a.text, url = _a.url, target = _a.target, trackingId = _a.trackingId;
                return (React__namespace.default.createElement(Link, { key: _uid, url: url, target: target, trackingId: trackingId, className: classNames__default.default(css$f.linkItem, 'styled-link-arrow') },
                    React__namespace.default.createElement("span", { className: "default-text-block" }, text),
                    React__namespace.default.createElement(Svg, { name: "ArrowRight", className: css$f.arrow })));
            }))));
};

var css$e = {"arrowColor":"currentColor","megaCard":"styles_megaCard__XmLX-","noBackgroundImage":"styles_noBackgroundImage__IPCOV","hideSubtitleSm":"styles_hideSubtitleSm__QzbDX","titleContainer":"styles_titleContainer__d9sRF","hideLinkSm":"styles_hideLinkSm__udYgE","imageContainer":"styles_imageContainer__VDT-G","subtitle":"styles_subtitle__5KXcJ","linkContainer":"styles_linkContainer__DzxCT","imageBackground":"styles_imageBackground__SCuKF","content":"styles_content__LGzWx","iconArrow":"styles_iconArrow__OImw-","textColor-white":"styles_textColor-white__Axon-","textColor-dark":"styles_textColor-dark__SWIr-","hasLink":"styles_hasLink__vSEGq","title":"styles_title__xrRki","linkIconArrow":"styles_linkIconArrow__9xuL7"};

var MegaCard = function (_a) {
    var _b, _c, _d;
    var _e, _f, _g, _h, _j, _k, _l;
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, image = _a.image, layout = _a.layout, _m = _a.link, link = _m === void 0 ? [] : _m, subtitle = _a.subtitle, textColor = _a.textColor, title = _a.title, showSubtitleOnMobile = _a.showSubtitleOnMobile, showLinkOnMobile = _a.showLinkOnMobile; _a._editable; var rest = __rest(_a, ["backgroundColor", "backgroundImage", "image", "layout", "link", "subtitle", "textColor", "title", "showSubtitleOnMobile", "showLinkOnMobile", "_editable"]);
    var hasBackgroundImage = checkImage(backgroundImage);
    var hasImage = checkImage((_e = image === null || image === void 0 ? void 0 : image[0]) === null || _e === void 0 ? void 0 : _e.asset);
    var hasImageResizing = !!((_f = image === null || image === void 0 ? void 0 : image[0]) === null || _f === void 0 ? void 0 : _f.cropAlignment);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement(ConditionalWrapper, { condition: hasBackgroundImage, wrapper: function (children) { return (React__namespace.default.createElement(ImgBackground, { src: (backgroundImage && backgroundImage.image) || '', base64: backgroundImage && backgroundImage.base64, quality: 90, loading: "lazy", className: classNames__default.default(css$e.imageBackground, backgroundColor) }, children)); } },
            React__namespace.default.createElement(Link, { url: ((_g = link[0]) === null || _g === void 0 ? void 0 : _g.url) || '' },
                React__namespace.default.createElement("div", { className: classNames__default.default(css$e.megaCard, (_b = {},
                        _b[backgroundColor] = !hasBackgroundImage,
                        _b[css$e.noBackgroundImage] = !hasBackgroundImage,
                        _b[css$e.hideSubtitleSm] = !showSubtitleOnMobile,
                        _b[css$e.hideLinkSm] = !showLinkOnMobile,
                        _b)) },
                    React__namespace.default.createElement("div", { className: classNames__default.default(css$e.content, (_c = {},
                            _c[css$e["textColor-".concat(textColor)]] = hasBackgroundImage,
                            _c)) },
                        React__namespace.default.createElement("div", { className: classNames__default.default(css$e.titleContainer, (_d = {},
                                _d[css$e.hasLink] = link.length > 1,
                                _d)) },
                            React__namespace.default.createElement("h2", { className: css$e.title }, title),
                            React__namespace.default.createElement(Svg, { className: classNames__default.default('icon-headline-color', css$e.iconArrow), name: 'ArrowRightOtto' })),
                        subtitle && React__namespace.default.createElement("p", { className: css$e.subtitle }, subtitle),
                        link.length > 0 && (React__namespace.default.createElement("div", { className: css$e.linkContainer },
                            React__namespace.default.createElement("span", { className: classNames__default.default((_j = types[(_h = link[0]) === null || _h === void 0 ? void 0 : _h.type]) === null || _j === void 0 ? void 0 : _j.classes, (_k = link[0]) === null || _k === void 0 ? void 0 : _k.className) }, (_l = link[0]) === null || _l === void 0 ? void 0 :
                                _l.text,
                                React__namespace.default.createElement(Svg, { className: classNames__default.default(css$e.linkIconArrow), name: 'ArrowRightOtto' })))),
                        hasImage &&
                            (hasImageResizing ? (validateBreakpointCollection(image) ||
                                image.map(function (imgResized, index) { return (React__namespace.default.createElement(ImgResized, __assign({ className: css$e.imageContainer }, imgResized, { key: imgResized._uid + String(index) }))); })) : (React__namespace.default.createElement(AdvanceImage, __assign({ className: css$e.imageContainer }, image[0].asset, { src: image[0].asset.image, key: image[0].asset.image }))))))))));
};

var css$d = {"priceWrapper":"styles_priceWrapper__1PHNC","price":"styles_price__J-d1v","fee":"styles_fee__I1aH4"};

var Price = function (_a) {
    var price = _a.price, priceMonthlyFee = _a.priceMonthlyFee, priceMonthlyLabel = _a.priceMonthlyLabel, priceTransactionalFee = _a.priceTransactionalFee, priceTransactionalLabel = _a.priceTransactionalLabel;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement("div", { className: css$d.priceWrapper },
        price.product && (React__namespace.default.createElement("span", { className: css$d.price },
            pricing.getPrice(price.location, price.product.product),
            React__namespace.default.createElement(FootnoteRef, { name: price === null || price === void 0 ? void 0 : price.disclaimer }))),
        priceMonthlyFee.product && (React__namespace.default.createElement("span", { className: css$d.fee },
            pricing.getPrice(priceMonthlyFee.location, priceMonthlyFee.product.product),
            React__namespace.default.createElement(FootnoteRef, { name: priceMonthlyFee === null || priceMonthlyFee === void 0 ? void 0 : priceMonthlyFee.disclaimer }),
            " ",
            priceMonthlyLabel)),
        priceTransactionalFee.product && (React__namespace.default.createElement("span", { className: css$d.fee },
            pricing.getPrice(priceTransactionalFee.location, priceTransactionalFee.product.product),
            React__namespace.default.createElement(FootnoteRef, { name: priceTransactionalFee === null || priceTransactionalFee === void 0 ? void 0 : priceTransactionalFee.disclaimer }),
            ' ',
            priceTransactionalLabel))));
};

var css$c = {"card":"styles_card__qBDMU","standard":"styles_standard__Xu96m","imageContainer":"styles_imageContainer__8CmgL","priceContainer":"styles_priceContainer__HXxCq","large":"styles_large__-WPJl","noContent":"styles_noContent__OM-OT","infoContainer":"styles_infoContainer__R9lnx","headlineContainer":"styles_headlineContainer__Ie2dE","iconArrow":"styles_iconArrow__cJVK-","one-of-2":"styles_one-of-2__63xJL","one-of-3":"styles_one-of-3__q5YMf","title":"styles_title__WNkFf"};

var PriceCard = function (_a) {
    var _b;
    var _uid = _a._uid, image = _a.image, largeCard = _a.largeCard, list = _a.list, subtitle = _a.subtitle, _c = _a.numberOfCards, numberOfCards = _c === void 0 ? 1 : _c, price = _a.price, priceMonthlyFee = _a.priceMonthlyFee, priceMonthlyLabel = _a.priceMonthlyLabel, priceTransactionalFee = _a.priceTransactionalFee, priceTransactionalLabel = _a.priceTransactionalLabel, title = _a.title, url = _a.url, rest = __rest(_a, ["_uid", "image", "largeCard", "list", "subtitle", "numberOfCards", "price", "priceMonthlyFee", "priceMonthlyLabel", "priceTransactionalFee", "priceTransactionalLabel", "title", "url"]);
    var ref = React.useRef(null);
    var handleClick = React.useCallback(function (evt) {
        var _a, _b, _c;
        if (!((_a = evt.target) === null || _a === void 0 ? void 0 : _a.closest('a[href]'))) {
            (_c = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.querySelector('a[href]')) === null || _c === void 0 ? void 0 : _c.click();
        }
    }, []);
    React.useEffect(function () {
        if (ref.current) {
            ref.current.addEventListener('click', handleClick, {});
        }
        return function () {
            if (ref.current) {
                ref.current.removeEventListener('click', handleClick);
            }
        };
    });
    var hasContent = subtitle || (list && list.length > 0);
    var hasImage = image.image && image.image.length > 0;
    return (React__namespace.default.createElement("div", __assign({ className: classNames__default.default(css$c.card, 'white', css$c["one-of-".concat(numberOfCards)], (_b = {},
            _b[css$c.standard] = !largeCard,
            _b[css$c.large] = largeCard,
            _b[css$c.noContent] = !hasContent,
            _b)), "data-size": largeCard ? 'large' : 'standard', ref: ref }, react.storyblokEditable(rest)),
        React__namespace.default.createElement(Link, { url: url, className: classNames__default.default(css$c.headlineContainer) },
            React__namespace.default.createElement("h2", { id: "card_".concat(_uid, "_title"), className: classNames__default.default(css$c.title) }, title),
            React__namespace.default.createElement(Svg, { className: css$c.iconArrow, name: 'ArrowRightOtto' })),
        hasImage && (React__namespace.default.createElement("div", { className: classNames__default.default(css$c.imageContainer) },
            React__namespace.default.createElement(AdvanceImage, __assign({ className: css$c.image }, image, { src: image.image, key: image.image })))),
        subtitle && list && list.length > 0 && (React__namespace.default.createElement("div", { className: css$c.infoContainer },
            subtitle && (React__namespace.default.createElement("p", { className: classNames__default.default(css$c.subtitle, 'default-text-block') }, subtitle)),
            list && list.length > 0 && React__namespace.default.createElement(List, __assign({}, list[0])))),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$c.priceContainer) },
            React__namespace.default.createElement(Price, { price: price, priceMonthlyFee: priceMonthlyFee, priceMonthlyLabel: priceMonthlyLabel, priceTransactionalFee: priceTransactionalFee, priceTransactionalLabel: priceTransactionalLabel }))));
};

var css$b = {"cardGroup":"styles_cardGroup__Xo5Dx","cards-1":"styles_cards-1__wSGDo","cards-2":"styles_cards-2__KFyXo","cards-3":"styles_cards-3__D6IwX"};

var PriceCardGroup = function (_a) {
    var cards = _a.cards, layout = _a.layout, rest = __rest(_a, ["cards", "layout"]);
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$b.cardGroup, css$b["cards-".concat(cards.length)]) }, cards.map(function (card) { return (React__namespace.default.createElement(PriceCard, __assign({}, card, { numberOfCards: cards.length, key: card._uid }))); }))));
};

var transformDate = function (sbDate) { return sbDate.split(' ')[0]; };
var transformPrice = function (string) {
    try {
        var money = parseMoney__default.default(string);
        if (money)
            return money.amount;
    }
    catch (e) {
        return null;
    }
    return null;
};

var JsonLd = function (_a) {
    var _uid = _a._uid, json = _a.json;
    return (React__namespace.default.createElement("script", { key: _uid, type: "application/ld+json", dangerouslySetInnerHTML: {
            __html: "\n      ".concat(JSON.stringify(json, undefined, 2).replace(/\n/g, "\n      "), "\n")
        } }));
};

var trimTrailingSlash = function (s) { return s.replace(/\/$/, ''); };
var ProductOfferStructuredData = React.memo(function (_a) {
    var _uid = _a._uid, productName = _a.productName, image = _a.image, description = _a.description, price = _a.price, unit = _a.unit, currency = _a.currency, untilDate = _a.untilDate, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b, fullSlug = _a.fullSlug;
    var pricing = React.useContext(SiteComponentContext).pricing;
    return (React__namespace.default.createElement(JsonLd, { _uid: _uid, json: {
            '@context': 'http://schema.org',
            '@type': 'Product',
            name: productName,
            image: image.filename || undefined,
            description: description,
            offers: {
                '@type': 'Offer',
                availability: 'InStock',
                price: price
                    ? transformPrice(pricing.getPrice(price.location, price.product.product))
                    : undefined,
                priceCurrency: currency,
                priceSpecification: {
                    '@type': 'UnitPriceSpecification',
                    unitCode: unit,
                    price: price
                        ? transformPrice(pricing.getPrice(price.location, price.product.product))
                        : undefined
                },
                priceValidUntil: untilDate ? transformDate(untilDate) : undefined,
                url: "".concat(baseUrl, "/").concat(trimTrailingSlash(fullSlug))
            },
            brand: {
                '@type': 'thing',
                name: 'Zettle'
            }
        } }));
});

// regex from storyblok schema
var urlListMatcher = /(^$)|((?:https?:\/\/)?[a-zA-Z0-9_-]+[.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+(\/[a-zA-Z0-9_-]+)+)/g;
var makeStructuredData = function (_a) {
    var _b;
    var name = _a.companyName, alternateName = _a.alternateName, baseUrl = _a.baseUrl, fullSlug = _a.fullSlug, logo = _a.logo, streetAddress = _a.streetAddress, addressLocality = _a.addressLocality, addressRegion = _a.addressRegion, postalCode = _a.postalCode, addressCountry = _a.addressCountry, contactPoints = _a.contactPoints, sameAs = _a.sameAs, description = _a.description, images = _a.images;
    return ({
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: name || undefined,
        alternateName: alternateName || undefined,
        description: description || undefined,
        url: "".concat(baseUrl, "/").concat(fullSlug === null || fullSlug === void 0 ? void 0 : fullSlug.split('/')[0]),
        logo: (logo === null || logo === void 0 ? void 0 : logo.filename) || undefined,
        address: streetAddress ||
            addressRegion ||
            addressLocality ||
            addressCountry ||
            postalCode
            ? {
                '@type': 'PostalAddress',
                streetAddress: streetAddress || undefined,
                addressRegion: addressRegion || undefined,
                addressLocality: addressLocality || undefined,
                addressCountry: addressCountry || undefined,
                postalCode: postalCode || undefined
            }
            : undefined,
        contactPoint: isNonEmptyArray(contactPoints)
            ? contactPoints.map(function (_a) {
                var contactType = _a.contactType, telephone = _a.telephone, email = _a.email, areaServed = _a.areaServed;
                return ({
                    '@type': 'ContactPoint',
                    contactType: contactType || undefined,
                    telephone: telephone || undefined,
                    email: (email === null || email === void 0 ? void 0 : email.email) || undefined,
                    areaServed: (areaServed.length > 0 && areaServed) || undefined
                });
            })
            : undefined,
        image: isNonEmptyArray(images)
            ? (_b = images === null || images === void 0 ? void 0 : images.map) === null || _b === void 0 ? void 0 : _b.call(images, function (image) { return image.filename; })
            : undefined,
        sameAs: sameAs ? sameAs.match(urlListMatcher) : undefined
    });
};
var CompanyInfoStructuredData = function (props) { return (React__namespace.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
        __html: "\n      ".concat(JSON.stringify(makeStructuredData(props), undefined, 2).replace(/\n/g, "\n      "), "\n      ")
    } })); };

var css$a = {"listOfFeatures":"styles_listOfFeatures__kJzmp","list":"styles_list__-fJBn","row":"styles_row__kqIjw"};

var ListOfFeatures = function (_a) {
    var featureListTitle = _a.featureListTitle, features = _a.features, localeCode = _a.localeCode, currency = _a.currency;
    return (React__namespace.default.createElement("div", { className: css$a.listOfFeatures },
        featureListTitle && (React__namespace.default.createElement(Richtext, { body: featureListTitle, className: "text-center" })),
        React__namespace.default.createElement("ul", { className: css$a.list }, features.map(function (item) { return (React__namespace.default.createElement("li", { key: item._uid, className: classNames__default.default(css$a.row, 'default-text-block') },
            React__namespace.default.createElement("span", null, item.label),
            React__namespace.default.createElement("span", null, item.otherPrice ||
                (localeCode &&
                    currency &&
                    new Intl.NumberFormat(localeCode, {
                        style: 'currency',
                        currency: currency
                    }).format(Number(item.price))) ||
                ''))); }))));
};

var css$9 = {"rateCalculator":"styles_rateCalculator__hc-nW","head":"styles_head__ZJ1ua","title":"styles_title__vrMua","description":"styles_description__aWpz9","cta":"styles_cta__rfWQd","button":"styles_button__NuvYG","responsiveCalculator":"styles_responsiveCalculator__pVJhH"};

var DEFAULT_LOCALE_CODE = 'en-GB';
var DEFAULT_CURRENCY = 'GBP';

var PricingBreakdownContext = React.createContext({
    localeCode: DEFAULT_LOCALE_CODE,
    currency: DEFAULT_CURRENCY,
    hideEarnings: false,
    inputLabel: '',
    earningsLabel: '',
    totalCostLabel: '',
    rateLabel: '',
    disclaimer: ''
});

var css$8 = {"resultBlock":"styles_resultBlock__tTrGn","inlineSeparator":"styles_inlineSeparator__2MtWF","result":"styles_result__3dcLR","symbol":"styles_symbol__eVMph","divider":"styles_divider__3vZWj","inputLabel":"styles_inputLabel__RfpOO","inputBlock":"styles_inputBlock__UnYuX"};

var checkIE = function () { var _a, _b; return /MSIE|Trident/.test((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : ''); };
var useDeviceDetect = function () {
    var _a = React.useState(false), isIE = _a[0], setIsIE = _a[1];
    React.useEffect(function () {
        setIsIE(checkIE());
    }, []);
    return { isIE: isIE };
};

var ResultBlock = function (_a) {
    var earnings = _a.earnings, feeMoney = _a.feeMoney, feeRate = _a.feeRate, _b = _a.inlineSeparator, inlineSeparator = _b === void 0 ? '|' : _b;
    var _c = React.useContext(PricingBreakdownContext), currency = _c.currency, hideEarnings = _c.hideEarnings, earningsLabel = _c.earningsLabel, totalCostLabel = _c.totalCostLabel, rateLabel = _c.rateLabel, disclaimer = _c.disclaimer;
    var isIE = useDeviceDetect().isIE;
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$8.resultBlock, 'py-normal') },
        React__namespace.default.createElement("ul", null,
            !hideEarnings && (React__namespace.default.createElement("li", null,
                React__namespace.default.createElement("h4", { className: "default-text-block" }, earningsLabel),
                React__namespace.default.createElement(Result, null,
                    React__namespace.default.createElement(ResultItem, { isIE: isIE, value: earnings || 0, style: "currency", currency: currency })))),
            React__namespace.default.createElement("li", { className: css$8.divider }),
            React__namespace.default.createElement("li", null,
                !hideEarnings && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                    React__namespace.default.createElement("h4", { className: "default-text-block" },
                        rateLabel,
                        " ",
                        React__namespace.default.createElement(FootnoteRef, { name: disclaimer })),
                    React__namespace.default.createElement("p", null,
                        React__namespace.default.createElement(ResultItem, { isIE: isIE, value: feeMoney || 0, style: "currency", currency: currency }),
                        React__namespace.default.createElement("span", { className: css$8.inlineSeparator }, ' ' + inlineSeparator + ' '),
                        React__namespace.default.createElement(ResultItem, { isIE: isIE, value: feeRate || 0, style: "percent", maximumFractionDigits: 2 })))),
                hideEarnings && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                    React__namespace.default.createElement("div", null,
                        React__namespace.default.createElement("h4", { className: "default-text-block" }, totalCostLabel),
                        React__namespace.default.createElement("p", null,
                            React__namespace.default.createElement(ResultItem, { isIE: isIE, value: feeMoney || 0, style: "currency", currency: currency }))),
                    React__namespace.default.createElement("div", null,
                        React__namespace.default.createElement("h4", { className: "default-text-block" },
                            rateLabel,
                            " ",
                            React__namespace.default.createElement(FootnoteRef, { name: disclaimer })),
                        React__namespace.default.createElement("p", null,
                            React__namespace.default.createElement(ResultItem, { isIE: isIE, value: feeRate || 0, style: "percent", maximumFractionDigits: 2 })))))))));
};
var ResultItem = function (_a) {
    var value = _a.value, style = _a.style, currency = _a.currency, _b = _a.currencyDisplay, currencyDisplay = _b === void 0 ? 'narrowSymbol' : _b, maximumFractionDigits = _a.maximumFractionDigits, isIE = _a.isIE;
    return (React__namespace.default.createElement("span", { className: css$8.result },
        isIE && (React__namespace.default.createElement(reactIntl.FormattedNumber, { value: value, style: style, currency: currency, currencyDisplay: currencyDisplay, maximumFractionDigits: maximumFractionDigits })),
        !isIE && (React__namespace.default.createElement(reactIntl.FormattedNumberParts, { value: value, style: style, currency: currency, maximumFractionDigits: maximumFractionDigits }, function (parts) { return parts && React__namespace.default.createElement(StyledFormattedNumberParts, { parts: parts }); }))));
};
var Result = function (_a) {
    var children = _a.children;
    return React__namespace.default.createElement("p", { className: css$8.result }, children);
};
var StyledFormattedNumberParts = function (_a) {
    var parts = _a.parts;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, parts.map(function (part, idx) { return (React__namespace.default.createElement(Part, { key: idx, part: part })); })));
};
var Part = function (_a) {
    var part = _a.part;
    if (part.type === 'currency' || part.type === 'percentSign') {
        return React__namespace.default.createElement("span", { className: css$8.symbol }, part.value);
    }
    return React__namespace.default.createElement(React__namespace.default.Fragment, null, part.value);
};

var restrictNumberOfDigits = function (event) {
    var _a, _b;
    var MAX_NUMBER_OF_DIGITS = 7;
    var numberOfDigits = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length;
    if (numberOfDigits >= MAX_NUMBER_OF_DIGITS) {
        event.preventDefault();
    }
};
var getFractionizedInputAmount = function (amount) {
    return parseInt(amount || '0', 10) * 100;
};

var InputBlock = function (_a) {
    var inputAmount = _a.inputAmount, setInputAmount = _a.setInputAmount;
    var _b = React.useContext(PricingBreakdownContext), currency = _b.currency, inputLabel = _b.inputLabel;
    var intl = reactIntl.useIntl();
    var isIE = useDeviceDetect().isIE;
    var currencySymbol = extractCurrencySymbol(intl, currency, isIE);
    var handleInput = function (event) {
        var _a, _b;
        return setInputAmount(Number((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) > 0 ? (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value : '0');
    };
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: css$8.inputLabel }, inputLabel),
        React__namespace.default.createElement("div", { "data-currency-symbol": currencySymbol, className: css$8.inputBlock },
            React__namespace.default.createElement("input", { type: "number", onKeyPress: restrictNumberOfDigits, value: inputAmount, onChange: handleInput }))));
};
var extractCurrencySymbol = function (intl, currency, isIE) {
    if (isIE) {
        return currency;
    }
    return intl
        .formatNumberToParts(0, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
    })
        .map(function (part) {
        switch (part.type) {
            case 'currency':
                return part.value;
            default:
                return '';
        }
    })
        .join('');
};

var calculateFlatRate = function (flatRatePercentage, inputAmount) { return ({
    fee: inputAmount * flatRatePercentage,
    percent: flatRatePercentage
}); };
var FlatCalc = function (_a) {
    var flatRatePercentage = _a.flatRatePercentage, inputAmount = _a.inputAmount, setInputAmount = _a.setInputAmount;
    var rate = calculateFlatRate(Number(flatRatePercentage), parseFloat(inputAmount));
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: css$9.leftColumn },
            React__namespace.default.createElement(InputBlock, { inputAmount: inputAmount, setInputAmount: setInputAmount })),
        React__namespace.default.createElement(ResultBlock, { earnings: parseFloat(inputAmount) - rate.fee, feeMoney: rate.fee, feeRate: rate.percent })));
};

var useCommission = function (countryCode) {
    var _a = React.useState(null), commission = _a[0], setCommission = _a[1];
    React.useEffect(function () {
        var fetchCommission = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/api/commissions/".concat(countryCode)).then(function (res) { return res.ok && res.json(); })];
                    case 1:
                        data = _a.sent();
                        data.samples && setCommission(data);
                        return [2 /*return*/];
                }
            });
        }); };
        if (commission === null) {
            fetchCommission();
        }
    }, []);
    return commission;
};

var getClosestSmartRateSample = function (samples, amount) {
    if (!samples) {
        return 0;
    }
    var sample = samples.reduce(function (prevSample, currSample) {
        if (Math.abs(currSample.cpv - amount) < Math.abs(prevSample.cpv - amount)) {
            return currSample;
        }
        else {
            return prevSample;
        }
    }, samples[0]);
    return sample.feePerc;
};
var calculateSmartRate = function (inputAmount, commission) {
    var amount = getFractionizedInputAmount(inputAmount);
    var percent = getClosestSmartRateSample(commission.samples, amount);
    var fee = (amount / 100) * (percent / 100);
    return { fee: fee, percent: percent };
};
var SmartCalc = function (_a) {
    var _b;
    var inputAmount = _a.inputAmount, setInputAmount = _a.setInputAmount;
    var localeCode = React.useContext(PricingBreakdownContext).localeCode;
    var commission = useCommission((_b = localeCode.split('-')) === null || _b === void 0 ? void 0 : _b[0]);
    if (!commission)
        return null;
    var rate = calculateSmartRate(inputAmount, commission);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", { className: css$9.leftColumn },
            React__namespace.default.createElement(InputBlock, { inputAmount: inputAmount, setInputAmount: setInputAmount })),
        React__namespace.default.createElement(ResultBlock, { earnings: parseFloat(inputAmount) - rate.fee, feeMoney: rate.fee, feeRate: rate.percent / 100 })));
};

var RateCalculator = function (_a) {
    var cta = _a.cta, disclaimer = _a.disclaimer, initialAmount = _a.initialAmount, calculatorTitle = _a.calculatorTitle, calculatorDescription = _a.calculatorDescription, children = _a.children;
    var _b = React.useState(initialAmount), inputAmount = _b[0], setInputAmount = _b[1];
    return (React__namespace.default.createElement("div", { className: classNames__default.default(css$9.rateCalculator, 'py-small') },
        React__namespace.default.createElement("div", { className: css$9.head },
            calculatorTitle && (React__namespace.default.createElement("div", { className: "mega-text-block" },
                React__namespace.default.createElement("h3", { className: css$9.title },
                    calculatorTitle,
                    React__namespace.default.createElement(FootnoteRef, { name: disclaimer })))),
            calculatorDescription && (React__namespace.default.createElement(Richtext, { body: calculatorDescription, className: css$9.description }))),
        React__namespace.default.createElement("div", { className: css$9.responsiveCalculator }, React__namespace.default.Children.map(children, function (child) {
            return React__namespace.default.isValidElement(child) &&
                React__namespace.default.cloneElement(child, __assign(__assign({}, child.props), { inputAmount: inputAmount, setInputAmount: setInputAmount }));
        })),
        cta && cta[0] && (React__namespace.default.createElement("div", { className: css$9.cta },
            React__namespace.default.createElement(StyledLink, __assign({}, cta[0], { className: css$9.button }))))));
};

var css$7 = {"paymentSelector":"styles_paymentSelector__Ic0bh","hide":"styles_hide__SBbun","selectionArea":"styles_selectionArea__tDrno","noSelectionArea":"styles_noSelectionArea__RWRho","dropdownMobile":"styles_dropdownMobile__kJyAh","dropdownButton":"styles_dropdownButton__gN6U3","dropdownLabel":"styles_dropdownLabel__wdf3E","installmentsLabel":"styles_installmentsLabel__ufqRP"};

var PaneIds;
(function (PaneIds) {
    PaneIds["DEBIT"] = "debit";
    PaneIds["CREDIT"] = "credit";
    PaneIds["PARCELA"] = "parcela";
})(PaneIds || (PaneIds = {}));
var Panes;
(function (Panes) {
    Panes[Panes["DEBIT"] = 0] = "DEBIT";
    Panes[Panes["CREDIT"] = 1] = "CREDIT";
    Panes[Panes["PARCELA"] = 2] = "PARCELA";
})(Panes || (Panes = {}));
var MIN_NUMBER_OF_INSTALLMENTS = 2;
var MAX_NUMBER_OF_INSTALLMENTS = 12;

var getCommissionPercentage = function (_a) {
    var percentages = _a.percentages, paneId = _a.paneId;
    if (!percentages["".concat(paneId, "Percentage")].text) {
        return 0;
    }
    else {
        // Safeguard against people using comma instead of period for decimal marker
        var percentage = percentages["".concat(paneId, "Percentage")].text.replace(',', '.');
        var numberPercentage = parseFloat(percentage);
        return !isNaN(numberPercentage) ? numberPercentage : 0;
    }
};
var calculateParcelaPercentage = function (_a) {
    var creditPercentage = _a.creditPercentage, parcelaBasePercentage = _a.parcelaBasePercentage, months = _a.months;
    return creditPercentage + parcelaBasePercentage * months;
};
var calculateRate = function (_a) {
    var amount = _a.amount, commission = _a.commission;
    return {
        earnings: amount - amount * commission,
        ratePercentage: commission,
        rateMoney: amount * commission
    };
};
var getPaneList = function () {
    return Object.keys(Panes).filter(function (k) { return typeof Panes[k] === 'number'; });
};
/**
 * Return an array of rates for debit, credit and percela respectively.
 */
var getRates = function (inputAmount, numberOfInstallments, getDebitPercentage, getCreditPercentage, getParcelaBasePercentage) {
    return getPaneList().map(function (paneName) {
        switch (paneName) {
            case Panes[Panes.DEBIT]:
                return calculateRate({
                    amount: inputAmount,
                    commission: getDebitPercentage()
                });
            case Panes[Panes.CREDIT]:
                return calculateRate({
                    amount: inputAmount,
                    commission: getCreditPercentage()
                });
            case Panes[Panes.PARCELA]:
                return calculateRate({
                    amount: inputAmount,
                    commission: calculateParcelaPercentage({
                        creditPercentage: getCreditPercentage(),
                        parcelaBasePercentage: getParcelaBasePercentage(),
                        months: numberOfInstallments - 1
                    })
                });
            default:
                return { earnings: 0, rateMoney: 0, ratePercentage: 0 };
        }
    });
};

var ParcelaDropdown = function (_a) {
    var onClickNumberOfInstallments = _a.onClickNumberOfInstallments, calculateParcelaPercentage = _a.calculateParcelaPercentage, getCreditPercentage = _a.getCreditPercentage, getParcelaBasePercentage = _a.getParcelaBasePercentage, toggleParcelaDropdown = _a.toggleParcelaDropdown, _b = _a.installmentsMin, installmentsMin = _b === void 0 ? MIN_NUMBER_OF_INSTALLMENTS : _b, _c = _a.installmentsMax, installmentsMax = _c === void 0 ? MAX_NUMBER_OF_INSTALLMENTS : _c;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, __spreadArray([], Array(installmentsMax - installmentsMin + 1), true).fill(undefined)
        .map(function (_, idx) { return (React__namespace.default.createElement(Button, { className: classNames__default.default(css$7.dropdownButton, 'focus-otto'), key: idx, onPress: function () {
            onClickNumberOfInstallments({
                months: idx + installmentsMin
            });
            toggleParcelaDropdown();
        } },
        React__namespace.default.createElement("div", { className: css$7.dropdownLabel },
            React__namespace.default.createElement("span", { className: css$7.installmentsLabel },
                idx + installmentsMin,
                "X"),
            React__namespace.default.createElement("span", { className: css$7.divider }, "\u00A0-\u00A0"),
            React__namespace.default.createElement("span", { className: css$7.percentageLabel },
                React__namespace.default.createElement(reactIntl.FormattedNumber, { value: calculateParcelaPercentage({
                        creditPercentage: getCreditPercentage(),
                        parcelaBasePercentage: getParcelaBasePercentage(),
                        months: idx + (installmentsMin - 1)
                    }), style: "percent", maximumFractionDigits: 2 }))))); })));
};

var ParcelaDropdownMobile = function (_a) {
    var onClickNumberOfInstallments = _a.onClickNumberOfInstallments, calculateParcelaPercentage = _a.calculateParcelaPercentage, getCreditPercentage = _a.getCreditPercentage, getParcelaBasePercentage = _a.getParcelaBasePercentage, toggleParcelaDropdown = _a.toggleParcelaDropdown, _b = _a.installmentsMin, installmentsMin = _b === void 0 ? MIN_NUMBER_OF_INSTALLMENTS : _b, _c = _a.installmentsMax, installmentsMax = _c === void 0 ? MAX_NUMBER_OF_INSTALLMENTS : _c;
    var intl = reactIntl.useIntl();
    return (React__namespace.default.createElement("select", { className: css$7.dropdownMobile, onChange: function (e) {
            onClickNumberOfInstallments({
                months: parseInt(e.target.value) + installmentsMin
            });
            toggleParcelaDropdown();
        }, tabIndex: 0, onClick: function () { return toggleParcelaDropdown(); } }, __spreadArray([], Array(installmentsMax - installmentsMin + 1), true).fill(undefined)
        .map(function (_, idx) { return (React__namespace.default.createElement("option", { key: idx, value: idx },
        idx + installmentsMin,
        "X -",
        ' ',
        intl.formatNumber(calculateParcelaPercentage({
            creditPercentage: getCreditPercentage(),
            parcelaBasePercentage: getParcelaBasePercentage(),
            months: idx + (installmentsMin - 1)
        }), {
            style: 'percent',
            maximumFractionDigits: 2
        }))); })));
};

var ParcelaSelector = function (props) {
    var dropdownRef = React.useRef(null);
    useClickOutside(dropdownRef, function () {
        if (showParcelaDropdown) {
            toggleParcelaDropdown();
        }
    });
    var showParcelaDropdown = props.showParcelaDropdown, toggleParcelaDropdown = props.toggleParcelaDropdown;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(ParcelaDropdownMobile, __assign({}, props)),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$7.paymentSelector, !showParcelaDropdown ? css$7.hide : ''), ref: dropdownRef },
            React__namespace.default.createElement("div", { className: css$7.noSelectionArea, onClick: toggleParcelaDropdown, "aria-hidden": "true", role: "button" }),
            React__namespace.default.createElement("div", { className: css$7.selectionArea },
                React__namespace.default.createElement(ParcelaDropdown, __assign({}, props))))));
};

var css$6 = {"priceTypes":"styles_priceTypes__Fg0X-","parcela":"styles_parcela__qTQdR","button":"styles_button__Ht7WK","active":"styles_active__BnTx-","chevron":"styles_chevron__CwDF1","open":"styles_open__SKjpB","percentage":"styles_percentage__-V4iV"};

var PricingButtons = function (_a) {
    var labels = _a.labels, activePaymentButton = _a.activePaymentButton, setPaymentPane = _a.setPaymentPane, toggleParcelaDropdown = _a.toggleParcelaDropdown, showParcelaDropdown = _a.showParcelaDropdown, numberOfInstallments = _a.numberOfInstallments;
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, getPaneList().map(function (_panel, index) {
        var isParcela = index === Panes.PARCELA;
        var paneId = Object.values(PaneIds)[index];
        return (React__namespace.default.createElement("div", { className: isParcela ? css$6.parcela : '', key: index },
            React__namespace.default.createElement(Button, { onPress: function () {
                    setPaymentPane(index);
                    if (isParcela) {
                        toggleParcelaDropdown();
                    }
                }, className: classNames__default.default('styled-button styled-button-primary focus-otto', css$6.button, activePaymentButton === index ? css$6.active : '') },
                React__namespace.default.createElement("span", null, labels["".concat(paneId, "Label")]),
                isParcela && (React__namespace.default.createElement(Svg, { className: classNames__default.default(css$6.chevron, showParcelaDropdown ? css$6.open : ''), name: "IconDownChevron" }))),
            React__namespace.default.createElement("span", { className: css$6.percentage },
                isParcela && numberOfInstallments && (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                    numberOfInstallments,
                    "X -",
                    ' ',
                    React__namespace.default.createElement(reactIntl.FormattedNumber, { value: parseFloat(labels["".concat(paneId, "Percentage")]), style: "percent", maximumFractionDigits: 2 }))),
                index !== Panes.PARCELA && (React__namespace.default.createElement(reactIntl.FormattedNumber, { value: parseFloat(labels["".concat(paneId, "Percentage")]), style: "percent", maximumFractionDigits: 2 })))));
    })));
};

var ParcelaCalc = function (_a) {
    var debitLabel = _a.debitLabel, creditLabel = _a.creditLabel, parcelaLabel = _a.parcelaLabel, debitPercentage = _a.debitPercentage, creditPercentage = _a.creditPercentage, parcelaPercentage = _a.parcelaPercentage, inputAmount = _a.inputAmount, setInputAmount = _a.setInputAmount;
    var _b = React.useState(MIN_NUMBER_OF_INSTALLMENTS), numberOfInstallments = _b[0], setInstallments = _b[1];
    var _c = React.useState(0), activePaymentButton = _c[0], setPaymentPane = _c[1];
    var _d = React.useState(false), showParcelaDropdown = _d[0], setShowParcelaDropdown = _d[1];
    var toggleParcelaDropdown = function () {
        setShowParcelaDropdown(!showParcelaDropdown);
        setPaymentPane(Panes.PARCELA);
    };
    var percentages = {
        debitPercentage: { text: debitPercentage },
        creditPercentage: { text: creditPercentage },
        parcelaPercentage: { text: parcelaPercentage }
    };
    var getDebitPercentage = function () {
        return getCommissionPercentage({ paneId: PaneIds.DEBIT, percentages: percentages });
    };
    var getCreditPercentage = function () {
        return getCommissionPercentage({ paneId: PaneIds.CREDIT, percentages: percentages });
    };
    var getParcelaBasePercentage = function () {
        return getCommissionPercentage({ paneId: PaneIds.PARCELA, percentages: percentages });
    };
    var onClickNumberOfInstallments = function (_a) {
        var months = _a.months;
        setInstallments(months);
        setShowParcelaDropdown(false);
    };
    var results = getRates(parseFloat(inputAmount), numberOfInstallments, getDebitPercentage, getCreditPercentage, getParcelaBasePercentage);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("div", null,
            React__namespace.default.createElement(InputBlock, { inputAmount: inputAmount, setInputAmount: setInputAmount }),
            React__namespace.default.createElement("div", { className: css$6.priceTypes },
                React__namespace.default.createElement(PricingButtons, { labels: {
                        debitLabel: debitLabel,
                        creditLabel: creditLabel,
                        parcelaLabel: parcelaLabel,
                        debitPercentage: debitPercentage,
                        creditPercentage: creditPercentage,
                        parcelaPercentage: String(numberOfInstallments
                            ? results[Panes.PARCELA].ratePercentage
                            : '')
                    }, activePaymentButton: activePaymentButton, setPaymentPane: setPaymentPane, toggleParcelaDropdown: toggleParcelaDropdown, showParcelaDropdown: showParcelaDropdown, numberOfInstallments: numberOfInstallments }),
                React__namespace.default.createElement(ParcelaSelector, { showParcelaDropdown: showParcelaDropdown, onClickNumberOfInstallments: onClickNumberOfInstallments, calculateParcelaPercentage: calculateParcelaPercentage, getCreditPercentage: getCreditPercentage, getParcelaBasePercentage: getParcelaBasePercentage, toggleParcelaDropdown: toggleParcelaDropdown }))),
        React__namespace.default.createElement(ResultBlock, { earnings: results[activePaymentButton].earnings, feeMoney: results[activePaymentButton].rateMoney, feeRate: results[activePaymentButton].ratePercentage })));
};

var css$5 = {"pricingBreakdown":"styles_pricingBreakdown__AMDG4","responsiveContainer":"styles_responsiveContainer__TDWeJ"};

var PricingBreakdown = function (_a) {
    var pricingType = _a.pricingType, title = _a.title, subtitle = _a.subtitle, cta = _a.cta, disclaimer = _a.disclaimer, featureListTitle = _a.featureListTitle, features = _a.features, rateCalculator = _a.rateCalculator, initialAmount = _a.initialAmount, inputLabel = _a.inputLabel, earningsLabel = _a.earningsLabel, totalCostLabel = _a.totalCostLabel, flatRate = _a.flatRate, rateLabel = _a.rateLabel, currency = _a.currency, calculatorTitle = _a.calculatorTitle, calculatorDescription = _a.calculatorDescription, layout = _a.layout; _a.localeCode; _a.hideEarnings; var rest = __rest(_a, ["pricingType", "title", "subtitle", "cta", "disclaimer", "featureListTitle", "features", "rateCalculator", "initialAmount", "inputLabel", "earningsLabel", "totalCostLabel", "flatRate", "rateLabel", "currency", "calculatorTitle", "calculatorDescription", "layout", "localeCode", "hideEarnings"]);
    var localeCode = React.useContext(SiteComponentContext).localeCode;
    var hideEarnings = pricingType === 'smart-without-total';
    return (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], { className: css$5.pricingBreakdown }, react.storyblokEditable(rest)),
        React__namespace.default.createElement(reactIntl.IntlProvider, { locale: localeCode || DEFAULT_LOCALE_CODE },
            React__namespace.default.createElement(PricingBreakdownContext.Provider, { value: {
                    hideEarnings: hideEarnings,
                    currency: currency || DEFAULT_CURRENCY,
                    disclaimer: disclaimer,
                    inputLabel: inputLabel,
                    earningsLabel: earningsLabel,
                    totalCostLabel: totalCostLabel,
                    rateLabel: rateLabel,
                    localeCode: localeCode
                } },
                title && React__namespace.default.createElement(Richtext, { body: title, className: classNames__default.default(css$5.title) }),
                subtitle && (React__namespace.default.createElement(Richtext, { body: subtitle, className: classNames__default.default(css$5.subtitle) })),
                React__namespace.default.createElement("div", { className: css$5.responsiveContainer },
                    React__namespace.default.createElement(ListOfFeatures, { featureListTitle: featureListTitle, features: features, currency: currency || DEFAULT_CURRENCY, localeCode: localeCode }),
                    React__namespace.default.createElement(RateCalculator, __assign({}, rateCalculator[0], { cta: cta, initialAmount: initialAmount, calculatorTitle: calculatorTitle, calculatorDescription: calculatorDescription }),
                        pricingType === 'parcela' && (React__namespace.default.createElement(ParcelaCalc, __assign({}, rateCalculator[0]))),
                        pricingType === 'flat' && (React__namespace.default.createElement(FlatCalc, __assign({}, rateCalculator[0], { flatRatePercentage: flatRate }))),
                        pricingType.startsWith('smart') && (React__namespace.default.createElement(SmartCalc, __assign({}, rateCalculator[0])))))))));
};

var css$4 = {"trustpilot":"styles_trustpilot__DdGh1","skiplink":"styles_skiplink__jNCmQ"};

var dataLocale = {
    gb: 'en-GB',
    dk: 'da-DK',
    nl: 'nl-NL',
    no: 'nb-NO',
    de: 'de-DE',
    es: 'es-ES',
    it: 'it-IT',
    br: 'pt-BR',
    mx: 'es-ES',
    se: 'sv-SE',
    'sv-fi': 'sv-FI',
    fi: 'fi-FI',
    fr: 'fr-FR'
};
var domain = {
    gb: 'uk',
    dk: 'dk',
    nl: 'nl',
    no: 'no',
    de: 'de',
    es: 'es',
    it: 'it',
    br: 'br',
    mx: 'es',
    se: 'se',
    'sv-fi': 'se',
    fi: 'fi',
    fr: 'fr'
};
var reviewLanguages = {
    gb: 'en',
    dk: 'da',
    nl: 'nl',
    no: 'no',
    de: 'de',
    es: 'es',
    it: 'it',
    br: 'pt',
    mx: 'es',
    se: 'sv',
    'sv-fi': 'sv',
    fi: 'fi',
    fr: 'fr'
};
var scriptDomId = 'web-next-trustbox-loader';
var Trustpilot = function (_a) {
    var title = _a.title, locale = _a.locale, layout = _a.layout, headingAlign = _a.headingAlign, oneStar = _a.oneStar, twoStars = _a.twoStars, threeStars = _a.threeStars, fourStars = _a.fourStars, fiveStars = _a.fiveStars, rest = __rest(_a, ["title", "locale", "layout", "headingAlign", "oneStar", "twoStars", "threeStars", "fourStars", "fiveStars"]);
    var ref = React.useRef(null);
    var stars = {
        1: oneStar,
        2: twoStars,
        3: threeStars,
        4: fourStars,
        5: fiveStars
    };
    /* eslint-env browser */
    React.useEffect(function () {
        var _a;
        var headerScript;
        var scriptExists = document.getElementById(scriptDomId);
        if (!scriptExists) {
            headerScript = document.createElement('script');
            headerScript.src =
                'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            headerScript.async = true;
            headerScript.id = scriptDomId;
            document.querySelector('head').appendChild(headerScript);
        }
        var trustpilot = window.Trustpilot;
        (_a = trustpilot === null || trustpilot === void 0 ? void 0 : trustpilot.loadFromElement) === null || _a === void 0 ? void 0 : _a.call(trustpilot, ref.current, true);
        return function () {
            document.querySelector('head').removeChild(headerScript);
        };
    }, [locale, oneStar, twoStars, threeStars, fourStars, fiveStars]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("a", { href: "#skiptrustpilot", className: css$4.skiplink }, "Skip Trustpilot"),
        React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
            title && (React__namespace.default.createElement("h2", { className: classNames__default.default([headingAlign], 'default-headline', css$4.trustpilot) }, title)),
            React__namespace.default.createElement("div", { className: classNames__default.default('trustpilot-widget', css$4.trustpilot), "data-locale": dataLocale[locale], "data-template-id": "54ad5defc6454f065c28af8b", "data-businessunit-id": "6023c4a5e8edca00013d8597", "data-style-height": "240px", "data-style-width": "100%", "data-theme": "light", "data-stars": "".concat(Object.entries(stars)
                    .filter(function (_a) {
                    var enabled = _a[1];
                    return enabled;
                })
                    .map(function (_a) {
                    var rating = _a[0];
                    return rating;
                })
                    .join(',')), "data-review-languages": reviewLanguages[locale], ref: ref },
                React__namespace.default.createElement("a", { href: "https://".concat(domain[locale], ".trustpilot.com/review/zettle.com"), target: "_blank", rel: "noopener noreferrer" }, "Trustpilot"))),
        React__namespace.default.createElement("div", { id: "skiptrustpilot" })));
};

var css$3 = {"pricingSection":"styles_pricingSection__yNipF","heading":"styles_heading__PnFY5","divider":"styles_divider__E8gA-","accordion":"styles_accordion__79uKf","tabs":"styles_tabs__FftzQ"};

var css$2 = {"tabs":"styles_tabs__oe609","title":"styles_title__YG-Ot","tabBar":"styles_tabBar__unbnm","tab":"styles_tab__cHbj1","active":"styles_active__yszng","sectionItem":"styles_sectionItem__0JDhP","hidden":"styles_hidden__r5JAR"};

var TabButton = function (_a) {
    var _b;
    var title = _a.title, id = _a.id, isActive = _a.isActive, onClick = _a.onClick, onKeyUp = _a.onKeyUp;
    return (React__namespace.default.createElement("button", { onClick: onClick, onKeyUp: onKeyUp, className: classNames__default.default('mini-headline', 'focus-pp', css$2.tab, (_b = {},
            _b[css$2.active] = isActive,
            _b)), key: id, role: "tab", "aria-selected": isActive, tabIndex: isActive ? 0 : -1, "aria-controls": "tabpanel".concat(id), id: "tab".concat(id) }, title));
};
var PricingSectionTabs = function (_a) {
    var title = _a.title, _b = _a.items, items = _b === void 0 ? [] : _b, openedItemID = _a.openedItemID, onItemOpen = _a.onItemOpen, tabContainerLabel = _a.tabContainerLabel;
    var openedItem = items.findIndex(function (item) { return item._uid === openedItemID; });
    var handleTabClick = React.useCallback(function (e) {
        var button = e.currentTarget;
        var itemId = button.id.substring(3); // skips the 'tab' prefix
        onItemOpen(itemId);
    }, []);
    var handleTabKeyUp = React.useCallback(function (e) {
        var _a;
        var target;
        switch (e.key) {
            case 'ArrowRight':
                target = e.currentTarget.nextSibling;
                target = !target ? e.currentTarget.parentElement.firstChild : target;
                break;
            case 'ArrowLeft':
                target = e.currentTarget.previousSibling;
                target = !target ? e.currentTarget.parentElement.lastChild : target;
                break;
            case 'Home':
                target = e.currentTarget.parentElement.firstChild;
                break;
            case 'End':
                target = e.currentTarget.parentElement.lastChild;
                break;
        }
        (_a = target === null || target === void 0 ? void 0 : target.focus) === null || _a === void 0 ? void 0 : _a.call(target);
    }, []);
    return (React__namespace.default.createElement("div", { className: css$2.tabs },
        React__namespace.default.createElement("h2", { className: classNames__default.default('default-headline', css$2.title) }, title),
        React__namespace.default.createElement("div", { className: classNames__default.default(css$2.tabBar), role: "tablist", "aria-label": tabContainerLabel }, items.map(function (item) { return (React__namespace.default.createElement(TabButton, { title: item.title, id: item._uid, key: item._uid, isActive: openedItemID === item._uid, onClick: handleTabClick, onKeyUp: handleTabKeyUp })); })),
        items.map(function (item, itemIndex) {
            var _a;
            return (React__namespace.default.createElement("div", { className: classNames__default.default(css$2.sectionItem, 'focus-pp', (_a = {},
                    _a[css$2.hidden] = itemIndex !== openedItem,
                    _a)), role: "tabpanel", tabIndex: itemIndex === openedItem ? 0 : -1, id: "tabpanel".concat(item._uid), "aria-labelledby": "tab".concat(item._uid), key: item._uid },
                React__namespace.default.createElement(PricingSectionItem, __assign({}, item))));
        })));
};

var PricingSection = function (_a) {
    var _b;
    var title = _a.title, _c = _a.items, items = _c === void 0 ? [] : _c, _d = _a.layout, layout = _d === void 0 ? [] : _d, ottoIconDropdown = _a.ottoIconDropdown, tabContainerLabel = _a.tabContainerLabel, rest = __rest(_a, ["title", "items", "layout", "ottoIconDropdown", "tabContainerLabel"]);
    var _e = React.useState(((_b = items === null || items === void 0 ? void 0 : items[0]) === null || _b === void 0 ? void 0 : _b._uid) || ''), openItemId = _e[0], setOpenItemId = _e[1];
    var _f = React.useState(true), showAccordion = _f[0], setShowAccordion = _f[1];
    var isMobile = reactResponsive.useMediaQuery({ maxWidth: breakpoints.m2 });
    React.useEffect(function () { return setShowAccordion(isMobile); }, [isMobile]);
    var accordionItems = items.map(function (item) {
        var accordionItem = {
            title: item.title,
            ottoIconDropdown: ottoIconDropdown,
            _uid: item._uid,
            content: [__assign(__assign({}, item), { component: 'pricing-section-item' })]
        };
        return accordionItem;
    });
    return (React__namespace.default.createElement("div", __assign({ className: css$3.pricingSection }, react.storyblokEditable(rest)),
        items.length === 1 && (React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
            React__namespace.default.createElement("h2", { className: classNames__default.default(css$3.heading, 'default-headline') }, title),
            React__namespace.default.createElement("div", { className: css$3.divider }),
            React__namespace.default.createElement(PricingSectionItem, __assign({}, items[0])))),
        items.length > 1 && (React__namespace.default.createElement(React__namespace.default.Fragment, null, showAccordion ? (React__namespace.default.createElement("div", { className: classNames__default.default(css$3.accordion, 'accordion-global') },
            React__namespace.default.createElement(Accordion, { items: accordionItems, heading: title, layout: layout, openedItemID: openItemId, onItemOpen: setOpenItemId, headingAlign: "text-left", ottoIconDropdown: ottoIconDropdown }))) : (React__namespace.default.createElement("div", { className: css$3.tabs },
            React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0]),
                React__namespace.default.createElement(PricingSectionTabs, { onItemOpen: setOpenItemId, openedItemID: openItemId, title: title, items: items, tabContainerLabel: tabContainerLabel }))))))));
};

var css$1 = {"header":"styles_header__4vZWE","headerContainer":"styles_headerContainer__Xqfsk","default":"styles_default__FBX-z","home":"styles_home__43X6s","link":"styles_link__aQrtk","linkText":"styles_linkText__8Jgp6","iconLink":"styles_iconLink__O2Uxj"};

var HeaderSimple = function (_a) {
    var logo = _a.logo, logoLink = _a.logoLink, logoLinkLabelAria = _a.logoLinkLabelAria, title = _a.title, link = _a.link, _b = _a.layoutOption, layoutOption = _b === void 0 ? 'default' : _b, rest = __rest(_a, ["logo", "logoLink", "logoLinkLabelAria", "title", "link", "layoutOption"]);
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement("header", __assign({ className: css$1.header }, react.storyblokEditable(rest)),
            React__namespace.default.createElement("div", { className: classNames__default.default(css$1.headerContainer, css$1[layoutOption]) },
                React__namespace.default.createElement(Brand, { logo: logo, logoLink: logoLink, title: title, "aria-label": logoLinkLabelAria }),
                isNonEmptyArray(link) && (React__namespace.default.createElement(Link, { className: css$1.link, url: link[0].url },
                    React__namespace.default.createElement("span", { className: css$1.linkText }, link[0].text),
                    link[0].icon && (React__namespace.default.createElement(Svg, { className: css$1.iconLink, name: link[0].icon }))))))));
};

var css = {"legal":"styles_legal__PVqs9","content":"styles_content__dQrPB","sidebar":"styles_sidebar__H4ZkT","alignBottom":"styles_alignBottom__USImK","mobileNav":"styles_mobileNav__cZVTE","fixed":"styles_fixed__X1gsm","nav":"styles_nav__5BJ5v","table-responsive":"styles_table-responsive__ZCMYD"};

var createMenuTreeFromHeadingsContext = function (headingList) {
    var createNavGroupItem = function (heading) {
        var id = heading.id, text = heading.text;
        return {
            _uid: id,
            component: 'navigation-group',
            title: text,
            body: []
        };
    };
    var createNavItem = function (heading) {
        var id = heading.id, text = heading.text;
        return {
            _uid: id,
            component: 'navigation-item',
            text: text,
            link: {
                url: "#".concat(id),
                linktype: 'url',
                id: id
            }
        };
    };
    var tree = headingList.reduce(function (headingTree, headingItem) {
        var element = headingItem.element;
        if (element === 'H2') {
            headingTree.push(createNavGroupItem(headingItem));
            return headingTree;
        }
        if (headingTree.length > 0) {
            var lastH2 = headingTree[headingTree.length - 1];
            lastH2.body.push(createNavItem(headingItem));
        }
        return headingTree;
    }, []);
    var menuRoot = [
        {
            _uid: 'legal-root',
            title: 'Content',
            component: 'navigation-group',
            body: tree
        }
    ];
    return menuRoot;
};
var setMenuTitle = function (tree, title) {
    var firstItem = tree[0];
    if (firstItem) {
        firstItem.title = title !== null && title !== void 0 ? title : '';
    }
    return tree;
};

var NavigationTreeWrapper = function (_a) {
    var _b;
    var _c = _a.initialOpenCategories, initialOpenCategories = _c === void 0 ? [] : _c, _d = _a.menuTitle, menuTitle = _d === void 0 ? '' : _d, _e = _a.ariaNavTitle, ariaNavTitle = _e === void 0 ? '' : _e, container = _a.container, setNavTreeAlignBottom = _a.setNavTreeAlignBottom, mobile = _a.mobile;
    var headings = React.useContext(HeadingsContext).headings;
    var menu = createMenuTreeFromHeadingsContext(headings);
    var menuWithTitle = setMenuTitle(menu, menuTitle);
    var headerHeight = React.useContext(HeaderContext).headerHeight;
    var treeRef = React.useRef(null);
    var _f = React.useState(false), fixed = _f[0], setFixed = _f[1];
    var _g = React.useState(false), posBottom = _g[0], setPosBottom = _g[1];
    var handleScroll = function () {
        var _a, _b;
        if (treeRef.current)
            if (treeRef.current && container && !mobile) {
                var navTreeDiv = (_a = treeRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!fixed && !posBottom && navTreeDiv.y <= headerHeight) {
                    setFixed(true);
                    setPosBottom(false);
                }
                if (fixed && window.scrollY + headerHeight < container.top) {
                    setFixed(false);
                    setPosBottom(false);
                    if (setNavTreeAlignBottom)
                        setNavTreeAlignBottom(false);
                }
                var reachedBottom = window.scrollY + navTreeDiv.height + headerHeight >= container.bottom;
                if (reachedBottom && !posBottom) {
                    setFixed(false);
                    setPosBottom(true);
                    if (setNavTreeAlignBottom)
                        setNavTreeAlignBottom(true);
                }
                if (posBottom && navTreeDiv.y > headerHeight) {
                    setFixed(true);
                    setPosBottom(false);
                }
            }
        if (treeRef.current && container && mobile) {
            var navTreeDiv = (_b = treeRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            if (!fixed && !posBottom && navTreeDiv.y <= headerHeight) {
                setFixed(true);
                setPosBottom(false);
            }
            if (fixed && window.scrollY + headerHeight < container.top) {
                setFixed(false);
                setPosBottom(false);
                if (setNavTreeAlignBottom)
                    setNavTreeAlignBottom(false);
            }
        }
    };
    reactUse.useIsomorphicLayoutEffect(function () {
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    });
    return (React__namespace.default.createElement("div", { ref: treeRef, className: classNames__default.default(css.nav, (_b = {},
            _b[css.fixed] = fixed,
            _b)) },
        React__namespace.default.createElement(NavigationTree, { cssClass: 'legal', menu: menuWithTitle, ariaNavTitle: ariaNavTitle, initialOpenCategories: initialOpenCategories, isMobile: mobile, isFixed: fixed })));
};

var processH2s = function (rootElement, selector, callback) {
    var headingIdMap = new Map();
    if (rootElement.current == null) {
        return headingIdMap;
    }
    var articleH2s = Array.from(rootElement.current.querySelectorAll(selector));
    for (var _i = 0, articleH2s_1 = articleH2s; _i < articleH2s_1.length; _i++) {
        var h2 = articleH2s_1[_i];
        var existingId = h2.id, textContent = h2.textContent;
        var text = textContent === null || textContent === void 0 ? void 0 : textContent.trim().replace(/#$/, '').replace(/[\u00A0\u202F]/g, '\x20');
        if (!text) {
            continue;
        }
        var id = existingId ? existingId : slugify(text);
        var count = 0;
        while (headingIdMap.has(id)) {
            id = "".concat(id).concat(++count);
        }
        headingIdMap.set(id, { text: text, element: h2 });
        try {
            callback(id, h2);
        }
        catch (e) {
            console.error(e);
        }
    }
    return headingIdMap;
};
var setIdAndAddAnchorLinkToH2 = function (addHeadingKnob) { return function (id, h2) {
    var existingId = h2.id;
    if (existingId !== id) {
        h2.setAttribute('id', id);
    }
    if (addHeadingKnob && h2.lastElementChild == null) {
        var anchorKnob = document.createElement('a');
        anchorKnob.setAttribute('aria-hidden', 'true');
        anchorKnob.classList.add('anchor-knob');
        anchorKnob.href = "#".concat(id);
        h2.appendChild(anchorKnob);
    }
}; };
var trackActiveHeading = function (headings, setActiveHeading) {
    var keys = Array.from(headings.keys());
    if (typeof IntersectionObserver === 'function') {
        var observer_1 = new IntersectionObserver(function (entries) {
            var firstVisibleHeadingId = entries
                .filter(function (entry) { return entry.isIntersecting; })
                .map(function (entry) { return entry.target.id; })
                .sort(function (a, b) { return keys.indexOf(a) - keys.indexOf(b); })[0];
            if (firstVisibleHeadingId && keys.indexOf(firstVisibleHeadingId) >= 0) {
                setActiveHeading(firstVisibleHeadingId);
            }
        }, {
            rootMargin: '0px 0px -50% 0px',
            threshold: 1
        });
        Array.from(headings.values()).forEach(function (_a) {
            var element = _a.element;
            return observer_1.observe(element);
        });
        return observer_1;
    }
    else {
        return null;
    }
};
var getActiveIdFromUrl = function () { var _a, _b; return decodeURIComponent((_b = (_a = window.location.hash) === null || _a === void 0 ? void 0 : _a.replace(/^#/, '')) !== null && _b !== void 0 ? _b : ''); };
var useHeadingNavigation = function (_a) {
    var rootElement = _a.rootElement, selector = _a.selector, _b = _a.addHeadingKnob, addHeadingKnob = _b === void 0 ? true : _b;
    var useRouter = React.useContext(SiteComponentContext).hooks.useRouter;
    var route = useRouter();
    var setHeadings = React.useContext(HeadingsContext).setHeadings;
    var populateHeadings = React.useCallback(function () {
        var headingIdMap = processH2s(rootElement, selector, setIdAndAddAnchorLinkToH2(addHeadingKnob));
        setHeadings(Array.from(headingIdMap.entries()).map(function (_a) {
            var id = _a[0], _b = _a[1], text = _b.text, element = _b.element;
            return ({
                id: id,
                text: text,
                element: element.tagName,
                isActive: false
            });
        }));
        return headingIdMap;
    }, [rootElement, selector, addHeadingKnob]);
    var setActiveHeading = React.useCallback(function (activeId) {
        setHeadings(function (headings) {
            return headings.map(function (_a) {
                var id = _a.id, rest = __rest(_a, ["id"]);
                return (__assign(__assign({}, rest), { id: id, isActive: id === activeId }));
            });
        });
    }, [setHeadings]);
    reactUse.useIsomorphicLayoutEffect(function () {
        var headingIdMap = populateHeadings();
        var intersectionObserver = trackActiveHeading(headingIdMap, setActiveHeading);
        return function () {
            if (intersectionObserver) {
                intersectionObserver.disconnect();
            }
        };
    }, [route.asPath, populateHeadings, setActiveHeading]);
    React.useEffect(function () {
        // this effect is because react's child component update order is unpredicatble and the effect above might not always run at the correct time
        var mutationObserver;
        var intersectionObserver;
        if (rootElement.current) {
            mutationObserver = new MutationObserver(function () {
                var headingIdMap = populateHeadings();
                intersectionObserver = trackActiveHeading(headingIdMap, setActiveHeading);
            });
            mutationObserver.observe(rootElement.current, {
                childList: true,
                subtree: true
            });
        }
        return function () {
            if (mutationObserver) {
                mutationObserver.disconnect();
            }
            if (intersectionObserver) {
                intersectionObserver.disconnect();
            }
        };
    }, [rootElement.current, populateHeadings, trackActiveHeading]);
    React.useEffect(function () {
        // this effect is only for the first time the user navigate to the heading section directly from a url with a hash
        var activeIdFromUrl = getActiveIdFromUrl();
        if (activeIdFromUrl) {
            var h2 = document.getElementById(activeIdFromUrl);
            if (h2) {
                h2.scrollIntoView({ behavior: 'auto' });
            }
        }
    }, []);
};

var LegalRichTextBody = function (_a) {
    var content = _a.content;
    var containerRef = React.useRef(null);
    useHeadingNavigation({
        rootElement: containerRef,
        selector: 'h2, h3',
        addHeadingKnob: false
    });
    return (React__namespace.default.createElement("div", { ref: containerRef, className: css.content },
        React__namespace.default.createElement(Richtext, { body: content, tableWrapperClassName: css['table-responsive'] })));
};
var LegalBody = function (_a) {
    var _b;
    var _c;
    var _d = _a.layout, layout = _d === void 0 ? [] : _d, content = _a.content, navigation = _a.navigation, rest = __rest(_a, ["layout", "content", "navigation"]);
    var navTreeDesktopContainer = React.useRef(null);
    var _e = React.useState(0), containerTop = _e[0], setContainerTop = _e[1];
    var _f = React.useState(0), containerBottom = _f[0], setContainerBottom = _f[1];
    var _g = React.useState(0), containerWidth = _g[0], setContainerWidth = _g[1];
    var _h = React.useState(false), navTreeAlignBottom = _h[0], setNavTreeAlignBottom = _h[1];
    var navTreeMobileContainer = React.useRef(null);
    var _j = React.useState(0), containerTopMobile = _j[0], setContainerTopMobile = _j[1];
    var _k = React.useState(0), containerBottomMobile = _k[0], setContainerBottomMobile = _k[1];
    var elementDistanceToTop = function (element) {
        var yPosition = 0;
        if (element.offsetParent) {
            while (element) {
                yPosition += element.offsetTop;
                element = element.offsetParent;
            }
        }
        return yPosition;
    };
    var setStates = function () {
        if (navTreeDesktopContainer === null || navTreeDesktopContainer === void 0 ? void 0 : navTreeDesktopContainer.current) {
            setContainerTop(elementDistanceToTop(navTreeDesktopContainer.current));
            setContainerBottom(navTreeDesktopContainer.current.offsetHeight +
                elementDistanceToTop(navTreeDesktopContainer.current));
            setContainerWidth(navTreeDesktopContainer.current.offsetWidth);
        }
        if (navTreeMobileContainer === null || navTreeMobileContainer === void 0 ? void 0 : navTreeMobileContainer.current) {
            setContainerTopMobile(elementDistanceToTop(navTreeMobileContainer.current));
            setContainerBottomMobile(navTreeMobileContainer.current.offsetHeight +
                elementDistanceToTop(navTreeMobileContainer.current));
        }
    };
    reactUse.useIsomorphicLayoutEffect(function () {
        setStates();
    });
    reactUse.useIsomorphicLayoutEffect(function () {
        /* In some cases needed for Webkit browsers to return correct values */
        document.onreadystatechange = function () {
            setStates();
        };
    });
    return (React__namespace.default.createElement(HeadingsContextProvider, null,
        React__namespace.default.createElement(ContainerLayout, __assign({}, layout[0], react.storyblokEditable(rest)),
            navigation && (React__namespace.default.createElement("div", { className: css.mobileNav, ref: navTreeMobileContainer },
                React__namespace.default.createElement(NavigationTreeWrapper, { menuTitle: navigation[0] && navigation[0].menuTitle, container: {
                        top: containerTopMobile,
                        bottom: containerBottomMobile,
                        width: '100%'
                    }, setNavTreeAlignBottom: setNavTreeAlignBottom, mobile: true }))),
            React__namespace.default.createElement("div", { className: css.legal },
                React__namespace.default.createElement("div", { ref: navTreeDesktopContainer, className: classNames__default.default(css.sidebar, (_b = {},
                        _b[css.alignBottom] = navTreeAlignBottom,
                        _b)) }, navigation && (React__namespace.default.createElement(NavigationTreeWrapper, { initialOpenCategories: ['legal-root'], menuTitle: (_c = navigation === null || navigation === void 0 ? void 0 : navigation[0]) === null || _c === void 0 ? void 0 : _c.menuTitle, container: {
                        top: containerTop,
                        bottom: containerBottom,
                        width: containerWidth + 'px'
                    }, setNavTreeAlignBottom: setNavTreeAlignBottom, mobile: false }))),
                React__namespace.default.createElement(LegalRichTextBody, { content: content })))));
};

var WebNextComponents = buildComponentsObject(__assign(__assign({}, sharedComponents), { Disclaimer: Disclaimer, Footer: Footer, GlobalReference: GlobalReference, GoogleOptimizeExperiment: GoogleOptimizeExperiment, GoogleOptimizeVariant: GoogleOptimizeVariant, Header: Header, HeaderSimple: HeaderSimple, Hero: Hero, Iframe: Iframe, InfoPosterGroup: InfoPosterGroup, IntegrationsList: IntegrationsList, LegalBody: LegalBody, LinkGroup: LinkGroup, MegaCard: MegaCard, PardotIframe: PardotIframe, PriceCard: PriceCard, PriceCardGroup: PriceCardGroup, CompanyInfoStructuredData: CompanyInfoStructuredData, PricingBreakdown: PricingBreakdown, ProductOfferStructuredData: ProductOfferStructuredData, QuickStart: QuickStart, StyledLinkSection: StyledLinkSection, Trustpilot: Trustpilot, VideoHero: VideoHero, PricingSection: PricingSection }));

exports.Accordion = Accordion;
exports.CalloutBlock = CalloutBlock;
exports.Col = Col;
exports.CompanyInfoStructuredData = CompanyInfoStructuredData;
exports.ContainerLayout = ContainerLayout;
exports.Disclaimer = Disclaimer;
exports.Footer = Footer;
exports.Global = Global;
exports.GlobalReference = GlobalReference;
exports.GoogleOptimizeExperiment = GoogleOptimizeExperiment;
exports.GoogleOptimizeVariant = GoogleOptimizeVariant;
exports.HeaderContext = HeaderContext;
exports.HeaderContextProvider = HeaderContextProvider;
exports.Hero = Hero;
exports.HeroBase = HeroBase;
exports.HeroWithImages = HeroWithImages;
exports.Iframe = Iframe;
exports.Image = Image$1;
exports.ImageSection = ImageSection;
exports.ImageStatic = ImageStatic;
exports.ImgResized = ImgResized;
exports.InfoPosterGroup = InfoPosterGroup;
exports.IntegrationsList = IntegrationsList;
exports.LinkGroup = LinkGroup;
exports.List = List;
exports.ListCircle = ListCircle;
exports.MediaAlignedTitle = MediaAlignedTitle;
exports.MegaCard = MegaCard;
exports.NavigationTree = NavigationTree;
exports.OttoIconProvider = OttoIconProvider;
exports.PardotIframe = PardotIframe;
exports.PriceCard = PriceCard;
exports.PriceCardGroup = PriceCardGroup;
exports.PricingBreakdown = PricingBreakdown;
exports.PricingSection = PricingSection;
exports.ProductOfferStructuredData = ProductOfferStructuredData;
exports.Provider = Provider;
exports.QuickStart = QuickStart;
exports.Richtext = Richtext;
exports.Row = Row;
exports.SectionLayout = SectionLayout;
exports.SectionLayoutLegacy = SectionLayoutLegacy;
exports.SiteComponentContext = SiteComponentContext;
exports.StandardCard = StandardCard;
exports.StandardCardGroup = StandardCardGroup;
exports.StandardModule = StandardModule;
exports.StatusBanner = StatusBanner;
exports.StyledLinkSection = StyledLinkSection;
exports.Svg = Svg;
exports.Table = Table;
exports.TableStandard = TableStandard;
exports.TextGrid = TextGrid;
exports.Trustpilot = Trustpilot;
exports.VideoHero = VideoHero;
exports.WebNextComponents = WebNextComponents;
exports.collectIcons = collectIcons;
exports.isOttoIconBlock = isOttoIconBlock;
exports.isOttoIconData = isOttoIconData;
exports.isOttoIconName = isOttoIconName;
exports.loadOttoIcons = loadOttoIcons;
exports.ottoUtils = ottoUtils;
exports.sharedComponents = sharedComponents;
exports.sharedUtils = sharedUtils;
exports.transformAccordionItemPropsToFaqItem = transformAccordionItemPropsToFaqItem;
exports.useOttoIcons = useOttoIcons;
